var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommercewebpageAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M77.66,248.86c-95.18,55-95.17,144.05,0,199s249.49,54.95,344.67,0,95.17-144,0-199S172.84,193.91,77.66,248.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "462.09 239.87 460.05 241.08 392.76 202.22 394.8 201.01 462.09 239.87",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.8 201.01 460.05 238.69 460.05 102.41 394.79 64.75 394.8 201.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,204.44l75,43.3V100.19l-75-43.3Zm3.85-140.89,67.29,38.86V241.08l-67.29-38.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.76 202.22 394.8 201.01 394.79 64.75 392.76 63.55 392.76 202.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.05 191 460.05 193.39 392.76 154.53 394.8 153.32 460.05 191",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.05 143.28 460.05 145.68 392.76 106.82 394.8 105.6 460.05 143.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.91 56.89 390.98 55.71 465.96 99.01 463.89 100.19 388.91 56.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.96 99.01 463.89 100.19 463.89 247.74 465.96 246.56 465.96 99.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.4 85.3 428.33 84.1 428.33 222.78 430.4 221.59 430.4 85.3",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "424.48 81.89 428.33 84.1 428.33 222.78 424.48 220.55 424.48 81.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.91 104.6 388.91 109.03 463.89 152.33 463.89 147.9 388.91 104.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.91 152.3 388.91 156.74 463.89 200.04 463.89 195.6 388.91 152.3",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.33 127.36 430.4 126.17 460.05 143.28 460.05 145.68 428.33 127.36",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.33 175.05 430.4 173.86 460.05 190.98 460.05 193.37 428.33 175.05",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "31.8 202.66 33.47 203.65 67.62 183.93 65.96 182.94 31.8 202.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.96 182.94 33.47 201.69 33.47 167.67 65.96 148.92 65.96 182.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.77,142.51,30.33,165.85v43.24l40.44-23.35Zm-3.15,41.42L33.47,203.65v-36L67.62,148Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.62 183.93 65.96 182.94 65.96 148.92 67.62 147.95 67.62 183.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.77 142.51 69.08 141.54 28.64 164.89 30.33 165.85 70.77 142.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.64 164.89 30.33 165.85 30.33 209.09 28.64 208.12 28.64 164.89",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "64.69 181.92 34.74 199.22 34.74 190.57 42.23 173.27 46.89 177.6 45.21 184.84 55.56 162.72 64.69 173.27 64.69 181.92",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,164.92a4.93,4.93,0,0,0-2.22,3.84c0,1.41,1,2,2.22,1.28a4.92,4.92,0,0,0,2.21-3.84C48.82,164.79,47.83,164.22,46.61,164.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "31.8 262.91 33.47 263.9 67.62 244.18 65.96 243.19 31.8 262.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.96 243.19 33.47 261.95 33.47 227.92 65.96 209.18 65.96 243.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.77,202.76,30.33,226.11v43.23L70.77,246Zm-3.15,41.42L33.47,263.9v-36L67.62,208.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.62 244.18 65.96 243.19 65.96 209.18 67.62 208.2 67.62 244.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.77 202.76 69.08 201.79 28.64 225.14 30.33 226.11 70.77 202.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.64 225.14 30.33 226.11 30.33 269.34 28.64 268.38 28.64 225.14",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "64.69 242.17 34.74 259.47 34.74 250.82 42.23 233.53 46.89 237.85 45.21 245.1 55.56 222.98 64.69 233.53 64.69 242.17",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,225.18A4.89,4.89,0,0,0,44.39,229c0,1.42,1,2,2.22,1.28a4.88,4.88,0,0,0,2.21-3.84C48.82,225,47.83,224.47,46.61,225.18Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M184.54,470.82,158.37,455.7a.46.46,0,0,1,0-.88l47.86-27.63a1.72,1.72,0,0,1,1.53,0l26.17,15.11a.47.47,0,0,1,0,.89l-47.86,27.63A1.72,1.72,0,0,1,184.54,470.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M143.71,456.91l-35.78-20.66a.46.46,0,0,1,0-.87l51.71-29.85a1.69,1.69,0,0,1,1.52,0l35.77,20.66c.42.25.42.64,0,.88l-51.7,29.84A1.63,1.63,0,0,1,143.71,456.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M315.31,282.92,298.16,273a4.11,4.11,0,0,0-3.71,0L79.13,397.33a1.14,1.14,0,0,0,0,2.15l17.32,10.07a4.06,4.06,0,0,0,3.7,0l36.43-21.08a15.66,15.66,0,0,0,1.62,1.07l27.9,16.11a26.9,26.9,0,0,0,24.73,0l53.85-31.09c4-2.31,6.29-5.75,6.29-9.45s-2.29-7.13-6.29-9.44L219,340.82l96.36-55.76A1.13,1.13,0,0,0,315.31,282.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M78.66,400.66c8.63,5,8.63,13.21,0,18.25s-22.63,5-31.26,0-8.63-13.21,0-18.25S70,395.62,78.66,400.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M454.41,407.14c25.1-14.5,25.1-38,0-52.49s-65.8-14.49-90.9,0-25.1,38,0,52.49S429.31,421.63,454.41,407.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M246.68,424.78c-14.92-8.61-14.92-22.58,0-31.2s39.12-8.61,54,0,14.91,22.58,0,31.2S261.6,433.39,246.68,424.78Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.69,355.37l-27.91-16.11c-5.73-3.3-15.37-4.06-21.55-1.68L176.67,344a95.5,95.5,0,0,0-20.59,11.71l-16.85,13.27a8.46,8.46,0,0,0-3.62,6.5v3.85c0,2.56,1.56,5.05,4.58,6.79l27.91,16.11c5.72,3.31,15,3.31,20.74,0l53.85-31.08c2.87-1.67,4.3-3.84,4.28-6,0-.62,0-3.09,0-3.72C247,359.2,245.55,357,242.69,355.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,379.28c0,2.56,1.56,5.05,4.58,6.79l27.91,16.11a21.1,21.1,0,0,0,10.37,2.48v-4l-42.86-24.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,379.28c0,2.56,1.56,5.05,4.58,6.79l27.91,16.11a21.1,21.1,0,0,0,10.37,2.48v-4l-42.86-24.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,337.58,176.67,344a95.5,95.5,0,0,0-20.59,11.71l-16.85,13.27c-5.2,4.1-4.77,10.09,1,13.4l27.91,16.11c5.72,3.31,15,3.31,20.74,0l53.85-31.09c5.72-3.31,5.72-8.67,0-12l-27.91-16.11C209.05,336,199.41,335.2,193.23,337.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.78,339.26c-5.73-3.3-15.37-4.06-21.55-1.68L176.67,344a95.19,95.19,0,0,0-20.58,11.71l-16.86,13.27a8.46,8.46,0,0,0-3.62,6.5v3.85c0,2.56,1.56,5.05,4.58,6.79l15.55,9v-3.73l74.6-43.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,356.21c0-8.23,2.57-34.13,8-40.2l-17.28-1.91c-8.5,9-18.67,30.44-24.82,42.8,0,0,5.07,2.06,11.32,4.65s15,2.58,19.44,0a6,6,0,0,0,3.35-5.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,356.21c0-8.23,2.57-34.13,8-40.2l-17.28-1.91c-8.5,9-18.67,30.44-24.82,42.8,0,0,5.07,2.06,11.32,4.65s15,2.58,19.44,0a6,6,0,0,0,3.35-5.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,316.6c3.35,1.38,8,1.38,10.42,0s2.4-4.08,0-6l-4.35-3.52a49.77,49.77,0,0,0-12.14,7S182.06,315.21,185.41,316.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.93,373.45a9.84,9.84,0,0,0,8.9-.16L309,252.53a10.12,10.12,0,0,0,4.59-7.95V29.88a9.87,9.87,0,0,0-4.31-7.79,9.84,9.84,0,0,0-8.9.17L91.22,143a10.13,10.13,0,0,0-4.6,7.95V365.66A9.84,9.84,0,0,0,90.93,373.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.83,373.28,309,252.53a10.16,10.16,0,0,0,4.59-8V29.88c0-2.93-2.05-4.12-4.59-2.65L99.83,148a10.18,10.18,0,0,0-4.59,8V370.63C95.24,373.56,97.29,374.75,99.83,373.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,355v15.62c0,2.93,2.05,4.12,4.59,2.65L309,252.53a10.16,10.16,0,0,0,4.59-8V229Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.31,340.47V158a6.25,6.25,0,0,1,2.82-4.9L304.65,37.31c1.56-.9,2.83-.17,2.83,1.63V221.43a6.21,6.21,0,0,1-2.82,4.89L104.13,342.1C102.57,343,101.31,342.27,101.31,340.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,146.43l8.61,5a9.75,9.75,0,0,0-1.36,4.54v214.7c0,2.67,1.81,4.17,4.59,2.66a9.72,9.72,0,0,1-8.9.16,8.82,8.82,0,0,1-4.31-7.23V151A9.49,9.49,0,0,1,88,146.43Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.19,358a4.29,4.29,0,0,1-2,.6,5,5,0,0,1-2.89-.51,5.38,5.38,0,0,1-2.37-4.27V204.45l4.74,2.73V356.56c0,1.14.57,1.8,1.4,1.8A2.43,2.43,0,0,0,114.19,358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,231.77a5.56,5.56,0,0,1-2.51,4.36L114.19,358c-1.38.8-2.51.15-2.51-1.46V193l6.94-4c1.38-.8,3.41-12.19,4.81-13l60.67-35c1.39-.8,4.36,7.71,5.75,6.91L327.72,68.15V231.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.72,69.89V231.77a4.6,4.6,0,0,1-2,3.5l-211,121.88a1.29,1.29,0,0,1-.62.21c-.34,0-.39-.5-.39-.8v-163l6.44-3.72c.95-.55,1.54-2.38,2.85-7.07.61-2.15,1.51-5.37,2-6L184.27,142a19.08,19.08,0,0,1,1.84,2.9c1.45,2.55,2.33,4,3.54,4a1.32,1.32,0,0,0,.7-.19L326.72,69.89m1-1.74L189.85,147.82a.46.46,0,0,1-.2.05c-1.38,0-4-7-5.35-7a.46.46,0,0,0-.2,0l-60.67,35c-1.4.8-3.43,12.19-4.81,13l-6.94,4V356.56c0,1.14.57,1.8,1.39,1.8a2.28,2.28,0,0,0,1.12-.34l211-121.89a5.56,5.56,0,0,0,2.51-4.36V68.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.31,200.71a5.4,5.4,0,0,1-2.36-4.28V182.61a5.57,5.57,0,0,1,2.53-4.37l211-121.88a4.73,4.73,0,0,1,7.24,4.18V74.37a5.53,5.53,0,0,1-2.51,4.36l-211,121.88A5.39,5.39,0,0,1,109.31,200.71Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.7,60.13c-.18-1.3-1.24-1.78-2.49-1L114.19,181a5.5,5.5,0,0,0-1.78,1.89l-4.72-2.74a5.21,5.21,0,0,1,1.78-1.88l211-121.88a4.71,4.71,0,0,1,7.22,3.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41,182.86a5.14,5.14,0,0,0-.73,2.48v21.84l-4.74-2.73V182.61c0-.1,0-.2,0-.3a5.61,5.61,0,0,1,.09-.63,5.84,5.84,0,0,1,.64-1.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,60.54v7.61L189.85,147.82l-71.23,41.12-6.94,4v-7.61a5.59,5.59,0,0,1,2.51-4.37l211-121.88C326.59,58.28,327.72,58.93,327.72,60.54Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,64.79c1-.57,1.8-.11,1.8,1a4,4,0,0,1-1.8,3.1c-1,.57-1.79.11-1.79-1A4,4,0,0,1,321.41,64.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,68.51c1-.57,1.79-.1,1.79,1a4,4,0,0,1-1.79,3.1c-1,.58-1.79.11-1.79-1A4,4,0,0,1,315,68.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,72.23c1-.57,1.8-.1,1.8,1a4,4,0,0,1-1.8,3.1c-1,.58-1.79.11-1.79-1A4,4,0,0,1,308.5,72.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86,190c.85-.5,1.14-1.25,1.55-2.69l.93-3.24c.35-1.3.7-2.19,1.56-2.68l37.3-21.54c.86-.49,1.53-.55,2.18.53l1.14,2.09c.48.84.73,1.33,1.58.84l29-16.72L327.72,68.15V82.39l-216,124.79V193l5.18-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.68 192.95 111.68 207.18 106.94 204.45 106.94 190.23 111.68 192.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.68 192.95 111.68 207.18 106.94 204.45 106.94 190.23 111.68 192.95",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,194.19l-2.91,1.68,1.11-2.14a.51.51,0,0,0,0-.52c-.08-.1-.23,0-.33.16l-1.58,3h0a.36.36,0,0,0,0,.11.06.06,0,0,0,0,0,.41.41,0,0,0,0,.16.28.28,0,0,0,0,.13v0a.09.09,0,0,0,0,.06h0l1.58,1.22a.15.15,0,0,0,.16,0,.48.48,0,0,0,.17-.23.46.46,0,0,0,0-.5l-1.11-.85,2.91-1.68a.62.62,0,0,0,.24-.5C120.74,194.21,120.63,194.11,120.5,194.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.94,192.78l2.91-1.68-1.11-.85c-.1-.07-.11-.3,0-.5s.23-.3.33-.22l1.58,1.21h0l0,.06,0,0a.44.44,0,0,1,0,.13,1,1,0,0,1,0,.16l0,0a.36.36,0,0,1,0,.11v0l-1.58,3a.44.44,0,0,1-.16.17.12.12,0,0,1-.17,0,.51.51,0,0,1,0-.52l1.11-2.14-2.91,1.69c-.13.07-.24,0-.24-.23A.64.64,0,0,1,122.94,192.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.49,184.4c0-.18-.17-.15-.25,0l-.4,1c-.68-.07-1.5.59-2.06,1.77-.72,1.53-.72,3.33,0,4a1,1,0,0,0,1.31.08,3.73,3.73,0,0,0,1.31-1.59.5.5,0,0,0,0-.51c-.1-.09-.24,0-.34.19-.53,1.14-1.41,1.65-1.95,1.13s-.54-1.87,0-3c.38-.81.94-1.29,1.42-1.32l-.3.73c-.08.19,0,.37.11.29l1.19-.77a.42.42,0,0,0,.13-.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.66,163.62l.89-1.88a.56.56,0,0,0,0-.59c-.1-.1-.27,0-.38.22l-.88,1.88-.89-.85c-.11-.1-.28,0-.38.22a.54.54,0,0,0,0,.58l.89.85-.89,1.88a.56.56,0,0,0,0,.59.15.15,0,0,0,.19,0,.5.5,0,0,0,.19-.23l.89-1.88.88.85a.15.15,0,0,0,.19,0,.5.5,0,0,0,.19-.23.54.54,0,0,0,0-.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.49,186.66v-3.38a3.68,3.68,0,0,1,1.68-2.9l176.37-102c.93-.53,1.68-.1,1.68,1v3.38a3.7,3.7,0,0,1-1.68,2.9l-176.37,102C138.24,188.16,137.49,187.73,137.49,186.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.27,85.93a.33.33,0,0,1-.15,0,.44.44,0,0,1-.25-.51L313,84l-.65-.47a.44.44,0,0,1-.17-.37.75.75,0,0,1,.27-.58l1-.76a.56.56,0,0,0,0-.08l.44-1.44a.63.63,0,0,1,.49-.47.4.4,0,0,1,.39.23l.37.79.83-.32a.4.4,0,0,1,.44.1.61.61,0,0,1,0,.68l-.71,1.33a.17.17,0,0,0,0,.08l.17,1.21a.79.79,0,0,1-.21.6.47.47,0,0,1-.39.16l-.81-.1-.86,1.1A.51.51,0,0,1,313.27,85.93Zm-.48-2.8.65.47a.49.49,0,0,1,.17.46l-.11.91.58-.74a.48.48,0,0,1,.44-.21l.8.1a.19.19,0,0,0,0-.09l-.17-1.21a.86.86,0,0,1,.09-.43l.62-1.17-.64.25a.4.4,0,0,1-.51-.2l-.29-.62-.39,1.28a.73.73,0,0,1-.24.37l-1,.75A.22.22,0,0,0,312.79,83.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.19,78a.58.58,0,0,1-.5-.29.59.59,0,0,1,.21-.8l4.71-2.71a.58.58,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,319.19,78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319.19,80.73a.58.58,0,0,1-.5-.29.59.59,0,0,1,.21-.8l4.71-2.71a.57.57,0,0,1,.79.21.58.58,0,0,1-.21.79l-4.71,2.72A.6.6,0,0,1,319.19,80.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.19,83.44a.57.57,0,0,1-.5-.28.59.59,0,0,1,.21-.8l4.71-2.71a.57.57,0,0,1,.79.21.59.59,0,0,1-.21.79l-4.71,2.72A.59.59,0,0,1,319.19,83.44Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M235.91,153.09l-15,8.7a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l15-8.69a2.54,2.54,0,0,0,1.18-2C237.09,153,236.56,152.72,235.91,153.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,140.2,246.44,147a2.54,2.54,0,0,0-1.19,2c0,.71.53,1,1.19.6l11.82-6.83a2.52,2.52,0,0,0,1.19-2C259.45,140.09,258.92,139.83,258.26,140.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,128.47l-9.82,5.67a2.55,2.55,0,0,0-1.18,2c0,.71.53,1,1.18.6l9.82-5.67a2.52,2.52,0,0,0,1.18-2C279.79,128.37,279.26,128.1,278.61,128.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,113.72l-15,8.7a2.52,2.52,0,0,0-1.18,2c0,.7.53,1,1.18.59l15-8.69a2.52,2.52,0,0,0,1.18-2C305.34,113.61,304.82,113.34,304.16,113.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,211.35a.14.14,0,0,1,.19,0,.23.23,0,0,1,.09.21v1a.64.64,0,0,1-.09.31.52.52,0,0,1-.19.22l-4.57,2.64a.16.16,0,0,1-.19,0,.24.24,0,0,1-.09-.22v-8.95a.64.64,0,0,1,.09-.31.52.52,0,0,1,.19-.22l4.48-2.59a.18.18,0,0,1,.2,0,.23.23,0,0,1,.08.21v1a.62.62,0,0,1-.08.31.48.48,0,0,1-.2.22l-3.35,1.94v2.2l3.13-1.8a.15.15,0,0,1,.19,0,.27.27,0,0,1,.09.22v1a.61.61,0,0,1-.09.31.5.5,0,0,1-.19.23L134.88,211v2.3Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,205.7c0,.42,0,.82,0,1.18s0,.74,0,1.15a2.09,2.09,0,0,0,.52,1.56c.33.28.8.25,1.42-.11a3.75,3.75,0,0,0,.84-.65,3.68,3.68,0,0,0,.57-.76,3.5,3.5,0,0,0,.34-.8,6,6,0,0,0,.18-.79.73.73,0,0,1,.11-.29.53.53,0,0,1,.16-.17l.48-.27a.14.14,0,0,1,.16,0,.21.21,0,0,1,.07.18,5.19,5.19,0,0,1-.18,1.1,6.54,6.54,0,0,1-.51,1.31,6.44,6.44,0,0,1-.9,1.32,5,5,0,0,1-1.32,1.08,2.63,2.63,0,0,1-1.21.41,1.32,1.32,0,0,1-.9-.26,1.68,1.68,0,0,1-.59-.84,4.21,4.21,0,0,1-.23-1.37c0-.81,0-1.64,0-2.47a7,7,0,0,1,.23-1.63,6.74,6.74,0,0,1,.59-1.53,6.62,6.62,0,0,1,.9-1.31,5.16,5.16,0,0,1,1.21-1,2.65,2.65,0,0,1,1.32-.44,1.36,1.36,0,0,1,.9.28,1.58,1.58,0,0,1,.51.72,2.83,2.83,0,0,1,.18.9.5.5,0,0,1-.07.25.41.41,0,0,1-.16.18l-.48.28a.18.18,0,0,1-.16,0c-.06,0-.09-.08-.11-.17a2.62,2.62,0,0,0-.18-.58.87.87,0,0,0-.34-.41.93.93,0,0,0-.57-.1,2.17,2.17,0,0,0-.84.32,3.56,3.56,0,0,0-1.42,1.53A5.13,5.13,0,0,0,140.69,205.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63,202.2a7.86,7.86,0,0,1,.2-1.58,7,7,0,0,1,.56-1.51,6.24,6.24,0,0,1,.89-1.32,4.86,4.86,0,0,1,1.22-1,2.59,2.59,0,0,1,1.22-.41,1.34,1.34,0,0,1,.89.29,1.91,1.91,0,0,1,.56.87,4.8,4.8,0,0,1,.2,1.35q0,1.22,0,2.46a7.9,7.9,0,0,1-.22,1.59,6.73,6.73,0,0,1-.55,1.52,5.93,5.93,0,0,1-.89,1.31,4.61,4.61,0,0,1-1.21,1,2.59,2.59,0,0,1-1.21.41,1.29,1.29,0,0,1-.89-.29,1.89,1.89,0,0,1-.56-.88,5.15,5.15,0,0,1-.21-1.33C146.61,203.85,146.61,203,146.63,202.2Zm4.75-2.67a3.63,3.63,0,0,0-.16-1.05,1.11,1.11,0,0,0-.39-.58.9.9,0,0,0-.59-.14,2.17,2.17,0,0,0-.74.27,3.49,3.49,0,0,0-.74.59,3.81,3.81,0,0,0-.59.82,4.51,4.51,0,0,0-.4,1,5.92,5.92,0,0,0-.15,1.23c0,.42,0,.81,0,1.17s0,.75,0,1.16a3.59,3.59,0,0,0,.15,1,1.18,1.18,0,0,0,.4.58.9.9,0,0,0,.59.14,2.17,2.17,0,0,0,.74-.27,3.2,3.2,0,0,0,.74-.59,3.81,3.81,0,0,0,.59-.82,4.08,4.08,0,0,0,.39-1,5.73,5.73,0,0,0,.16-1.23c0-.42,0-.81,0-1.17S151.39,199.93,151.38,199.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.12,198.39l2.1-6.63a1.55,1.55,0,0,1,.17-.4.77.77,0,0,1,.28-.31l.4-.23a.18.18,0,0,1,.2,0,.27.27,0,0,1,.08.22v9a.75.75,0,0,1-.08.31.62.62,0,0,1-.2.22l-.43.25a.18.18,0,0,1-.2,0,.26.26,0,0,1-.08-.21V194l-1.62,5.11a2.11,2.11,0,0,1-.18.42.6.6,0,0,1-.25.27l-.39.22c-.11.06-.19.07-.25,0a.71.71,0,0,1-.18-.22l-1.62-3.24v6.57a.71.71,0,0,1-.08.31.58.58,0,0,1-.2.23l-.42.24a.15.15,0,0,1-.2,0,.23.23,0,0,1-.09-.21v-8.95a.61.61,0,0,1,.09-.31.51.51,0,0,1,.2-.23l.39-.23a.28.28,0,0,1,.29,0,.55.55,0,0,1,.17.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.37,193.63l2.1-6.63a2.37,2.37,0,0,1,.17-.41.81.81,0,0,1,.28-.3l.4-.23a.18.18,0,0,1,.2,0,.26.26,0,0,1,.08.21v8.95a.71.71,0,0,1-.08.31.51.51,0,0,1-.2.23l-.43.25a.16.16,0,0,1-.19,0,.25.25,0,0,1-.09-.22v-6.57L166,194.33a1.74,1.74,0,0,1-.18.43.67.67,0,0,1-.24.26l-.4.23a.24.24,0,0,1-.25,0,.76.76,0,0,1-.18-.23l-1.62-3.23v6.57a.62.62,0,0,1-.08.31.54.54,0,0,1-.2.22l-.42.25a.18.18,0,0,1-.2,0,.23.23,0,0,1-.08-.21v-9a.62.62,0,0,1,.08-.31.48.48,0,0,1,.2-.22l.39-.23a.26.26,0,0,1,.29,0,.51.51,0,0,1,.17.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,190.73a.16.16,0,0,1,.19,0,.23.23,0,0,1,.09.21v.5a.59.59,0,0,1-.09.31.5.5,0,0,1-.19.23l-4.2,2.42a.17.17,0,0,1-.2,0,.25.25,0,0,1-.08-.22v-8.95a.62.62,0,0,1,.08-.31.58.58,0,0,1,.2-.23l4.11-2.37a.17.17,0,0,1,.2,0,.26.26,0,0,1,.08.22v.5a.62.62,0,0,1-.08.31.58.58,0,0,1-.2.23l-3.41,2v2.93l3.18-1.84a.18.18,0,0,1,.2,0,.23.23,0,0,1,.09.21v.5a.61.61,0,0,1-.09.31.51.51,0,0,1-.2.23l-3.18,1.83v3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.34,179.7a3.13,3.13,0,0,1,1-.39,1.38,1.38,0,0,1,.79.05,1.12,1.12,0,0,1,.55.58,2.85,2.85,0,0,1,.2,1.18,4.76,4.76,0,0,1-.42,2,5.35,5.35,0,0,1-1.08,1.57l1.57,2.73a.35.35,0,0,1,0,.14.57.57,0,0,1-.06.25.52.52,0,0,1-.16.19l-.45.25c-.14.08-.24.1-.31,0a.64.64,0,0,1-.14-.15l-1.51-2.67-1.78,1v3.53a.61.61,0,0,1-.09.31.56.56,0,0,1-.19.23l-.43.24a.15.15,0,0,1-.2,0,.26.26,0,0,1-.08-.21v-8.95a.71.71,0,0,1,.08-.31.58.58,0,0,1,.2-.23Zm-1.81,5.59,1.75-1a3.34,3.34,0,0,0,1.16-1.07,2.68,2.68,0,0,0,.41-1.52c0-.59-.13-.93-.41-1a1.54,1.54,0,0,0-1.16.3l-1.75,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,180.68c0,.42,0,.82,0,1.18s0,.74,0,1.15a2.09,2.09,0,0,0,.53,1.56c.33.28.8.25,1.41-.11a3.57,3.57,0,0,0,1.41-1.41,3.54,3.54,0,0,0,.35-.8,6,6,0,0,0,.18-.79.72.72,0,0,1,.1-.29.55.55,0,0,1,.17-.17l.48-.27a.14.14,0,0,1,.16,0,.24.24,0,0,1,.06.18,4.55,4.55,0,0,1-.17,1.1,6,6,0,0,1-.52,1.31,6.8,6.8,0,0,1-.89,1.32,5.08,5.08,0,0,1-1.33,1.08,2.6,2.6,0,0,1-1.2.41,1.34,1.34,0,0,1-.91-.26,1.74,1.74,0,0,1-.59-.84,4.5,4.5,0,0,1-.23-1.37c0-.81,0-1.64,0-2.47a7.62,7.62,0,0,1,.23-1.63,7.24,7.24,0,0,1,.59-1.53,6.66,6.66,0,0,1,.91-1.31,5.11,5.11,0,0,1,1.2-1,2.79,2.79,0,0,1,1.33-.44,1.36,1.36,0,0,1,.89.28,1.53,1.53,0,0,1,.52.72,2.56,2.56,0,0,1,.17.9.61.61,0,0,1-.06.25.41.41,0,0,1-.16.18l-.48.28a.21.21,0,0,1-.17,0,.19.19,0,0,1-.1-.17,2.62,2.62,0,0,0-.18-.58.89.89,0,0,0-.35-.41.9.9,0,0,0-.56-.1,2.27,2.27,0,0,0-.85.32,3.6,3.6,0,0,0-1.41,1.53A5.14,5.14,0,0,0,184,180.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,179.27a.16.16,0,0,1,.19,0,.23.23,0,0,1,.09.21v.5a.59.59,0,0,1-.09.31.5.5,0,0,1-.19.23l-4.2,2.42a.17.17,0,0,1-.2,0,.25.25,0,0,1-.08-.22v-8.95a.62.62,0,0,1,.08-.31.58.58,0,0,1,.2-.23l4.11-2.37a.17.17,0,0,1,.2,0,.26.26,0,0,1,.08.22v.5a.62.62,0,0,1-.08.31.58.58,0,0,1-.2.23l-3.41,2V177l3.18-1.84a.18.18,0,0,1,.2,0,.23.23,0,0,1,.08.21v.5a.6.6,0,0,1-.08.31.51.51,0,0,1-.2.23l-3.18,1.83v3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,107.2a.22.22,0,0,1-.21-.12.25.25,0,0,1,.08-.34l2.16-1.26a.25.25,0,0,1,.34.09.27.27,0,0,1-.09.34l-2.16,1.26A.27.27,0,0,1,312.13,107.2Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,112.88a.18.18,0,0,1-.1,0,.24.24,0,0,1-.14-.17l-1.6-6.93-1-.19a.24.24,0,0,1,.09-.48l1.11.21a.23.23,0,0,1,.19.19l1.57,6.76,5.88-3.39,1.26-6.65-1.67,1a.25.25,0,1,1-.25-.43l2.13-1.24a.24.24,0,0,1,.27,0,.24.24,0,0,1,.1.25L320,109.06a.3.3,0,0,1-.12.17l-6.28,3.62A.24.24,0,0,1,313.44,112.88Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,114.87a.59.59,0,0,1-.31-.09.89.89,0,0,1-.38-.81,2,2,0,0,1,.86-1.63l2.74-1.58a.25.25,0,0,1,.34.09.27.27,0,0,1-.09.34l-2.74,1.57a1.57,1.57,0,0,0-.62,1.21c0,.23.07.35.14.39s.18,0,.23,0l6.06-3.5a.25.25,0,0,1,.25.43l-6.06,3.49A.76.76,0,0,1,313.29,114.87Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,117.45a.72.72,0,0,1-.32-.08.91.91,0,0,1-.38-.82,2,2,0,0,1,.87-1.65.71.71,0,0,1,.74,0,.89.89,0,0,1,.38.82,2.05,2.05,0,0,1-.87,1.65A.87.87,0,0,1,314,117.45Zm.59-2.18a.32.32,0,0,0-.17.06,1.54,1.54,0,0,0-.63,1.22c0,.23.07.35.14.39s.18,0,.24,0a1.57,1.57,0,0,0,.63-1.22c0-.23-.07-.36-.14-.39A.08.08,0,0,0,314.58,115.27Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,115a.65.65,0,0,1-.31-.08.89.89,0,0,1-.39-.82,2,2,0,0,1,.88-1.65.73.73,0,0,1,.74,0,.91.91,0,0,1,.38.82,2,2,0,0,1-.88,1.65A.84.84,0,0,1,318.28,115Zm.6-2.18a.35.35,0,0,0-.18.06,1.53,1.53,0,0,0-.62,1.22.47.47,0,0,0,.13.39.31.31,0,0,0,.25,0,1.54,1.54,0,0,0,.62-1.22c0-.23-.07-.36-.13-.39A.1.1,0,0,0,318.88,112.79Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.69,108a1.39,1.39,0,0,1-.72-.19,2.29,2.29,0,0,1-.93-2.1,5.89,5.89,0,0,1,2.45-4.68,1.75,1.75,0,0,1,1.78-.12,2.32,2.32,0,0,1,.93,2.1,5.86,5.86,0,0,1-2.46,4.68A2.1,2.1,0,0,1,315.69,108Zm1.85-6.78a1.66,1.66,0,0,0-.8.24,5.34,5.34,0,0,0-2.21,4.25,1.86,1.86,0,0,0,.68,1.67,1.26,1.26,0,0,0,1.28-.12A5.32,5.32,0,0,0,318.7,103a1.83,1.83,0,0,0-.68-1.67A1,1,0,0,0,317.54,101.19Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.32,106a.21.21,0,0,1-.15-.05l-.92-.68a.25.25,0,1,1,.29-.4l.67.5,1.33-3.13a.24.24,0,0,1,.32-.13.23.23,0,0,1,.13.32l-1.44,3.42a.24.24,0,0,1-.17.14Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.75,115.52a.26.26,0,0,1-.22-.13.24.24,0,0,1,.09-.33l1.38-.8a.24.24,0,0,1,.33.09.25.25,0,0,1-.09.34l-1.37.79A.19.19,0,0,1,315.75,115.52Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88,328.6a.51.51,0,0,1-.5-.5V215a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V328.1A.5.5,0,0,1,153.88,328.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,233.39l-10.28,5.93c-.41.24-.75,0-.75-.56h0a1.81,1.81,0,0,1,.75-1.43l10.28-5.93c.41-.24.75,0,.75.56h0A1.81,1.81,0,0,1,133.7,233.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,290l-10.28,5.94c-.41.24-.75,0-.75-.57h0a1.8,1.8,0,0,1,.75-1.42L133.7,288c.41-.23.75,0,.75.57h0A1.77,1.77,0,0,1,133.7,290Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,232.82l-15.71,9.07c-.24.13-.44,0-.44-.33a1,1,0,0,1,.44-.83l15.71-9.07c.24-.14.43,0,.43.33A1,1,0,0,1,142.2,232.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,236.57l-15.71,9.07c-.24.14-.44,0-.44-.32a1,1,0,0,1,.44-.83l15.71-9.07c.24-.14.43,0,.43.33A1,1,0,0,1,142.2,236.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,270.47l-10.28,5.94c-.41.23-.75,0-.75-.57h0a1.77,1.77,0,0,1,.75-1.42l10.28-5.94c.41-.24.75,0,.75.57h0A1.79,1.79,0,0,1,133.7,270.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,316.47l-10.28,5.94c-.41.24-.75,0-.75-.57h0a1.79,1.79,0,0,1,.75-1.42l10.28-5.94c.41-.24.75,0,.75.57h0A1.79,1.79,0,0,1,133.7,316.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,250.41l-10.28,5.93c-.41.24-.75,0-.75-.56h0a1.77,1.77,0,0,1,.75-1.42l10.28-5.94c.41-.24.75,0,.75.56h0A1.81,1.81,0,0,1,133.7,250.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,255.72l-5.53,3.19c-.24.14-.44,0-.44-.33a1,1,0,0,1,.44-.83l5.53-3.19c.24-.14.43,0,.43.33A1,1,0,0,1,132,255.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,259.48l-5.53,3.19c-.24.14-.44,0-.44-.33a1,1,0,0,1,.44-.83l5.53-3.19c.24-.14.43,0,.43.33A1,1,0,0,1,132,259.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,263.23l-5.53,3.2c-.24.13-.44,0-.44-.33a1,1,0,0,1,.44-.83l5.53-3.19c.24-.14.43,0,.43.33A1,1,0,0,1,132,263.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,249.84,136.67,253c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82l5.53-3.2c.24-.13.43,0,.43.33A1,1,0,0,1,142.2,249.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,253.6l-5.53,3.19c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82l5.53-3.2c.24-.14.43,0,.43.33A1,1,0,0,1,142.2,253.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,257.36l-5.53,3.19c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.83l5.53-3.19c.24-.14.43,0,.43.33A1,1,0,0,1,142.2,257.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,277.66a2.66,2.66,0,0,1-1.11,2.13c-.61.35-1.11,0-1.11-.84a2.67,2.67,0,0,1,1.11-2.13C128.22,276.46,128.71,276.84,128.71,277.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,275.06a2.67,2.67,0,0,1-1.11,2.13c-.62.36-1.12,0-1.12-.84a2.67,2.67,0,0,1,1.12-2.13C132.71,273.87,133.21,274.24,133.21,275.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7,272.47a2.69,2.69,0,0,1-1.11,2.13c-.62.35-1.11,0-1.11-.84a2.65,2.65,0,0,1,1.11-2.13C137.2,271.27,137.7,271.65,137.7,272.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,269.87a2.66,2.66,0,0,1-1.12,2.13c-.61.36-1.11,0-1.11-.84a2.69,2.69,0,0,1,1.11-2.13C141.7,268.68,142.2,269.06,142.2,269.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,282.81a2.63,2.63,0,0,1-1.11,2.12c-.61.36-1.11,0-1.11-.84A2.66,2.66,0,0,1,127.6,282C128.22,281.61,128.71,282,128.71,282.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,280.21a2.69,2.69,0,0,1-1.11,2.13c-.62.35-1.12,0-1.12-.84a2.67,2.67,0,0,1,1.12-2.13C132.71,279,133.21,279.39,133.21,280.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7,277.62a2.66,2.66,0,0,1-1.11,2.12c-.62.36-1.11,0-1.11-.84a2.63,2.63,0,0,1,1.11-2.12C137.2,276.42,137.7,276.8,137.7,277.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,275a2.67,2.67,0,0,1-1.12,2.13c-.61.35-1.11,0-1.11-.84a2.69,2.69,0,0,1,1.11-2.13C141.7,273.83,142.2,274.2,142.2,275Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,284.65,140,285.94c-.24.13-.43,0-.43-.33a1,1,0,0,1,.43-.83l2.23-1.29c.24-.13.43,0,.43.33A1,1,0,0,1,142.2,284.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,286.78c-.24.14-.43,0-.43-.33v-3a1,1,0,0,1,.43-.83c.24-.14.44,0,.44.33v3A1,1,0,0,1,141.08,286.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,299l-10.28,5.93c-.41.24-.75,0-.75-.56h0a1.81,1.81,0,0,1,.75-1.43L133.7,297c.41-.24.75,0,.75.56h0A1.81,1.81,0,0,1,133.7,299Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,293.67,140,295c-.24.14-.43,0-.43-.33a1,1,0,0,1,.43-.82l2.23-1.29c.24-.14.43,0,.43.33A1,1,0,0,1,142.2,293.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,295.8c-.24.14-.43,0-.43-.33v-3a1,1,0,0,1,.43-.83c.24-.14.44,0,.44.33v3A1,1,0,0,1,141.08,295.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,308,123.42,314c-.41.24-.75,0-.75-.57h0a1.79,1.79,0,0,1,.75-1.42L133.7,306c.41-.23.75,0,.75.57h0A1.79,1.79,0,0,1,133.7,308Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.19,334.82l-4.77,2.75c-.41.24-.75,0-.75-.56h0a1.81,1.81,0,0,1,.75-1.43l4.77-2.75c.41-.24.74,0,.74.57h0A1.78,1.78,0,0,1,128.19,334.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.47,327.15l-4.76,2.75c-.41.24-.75,0-.75-.56h0a1.81,1.81,0,0,1,.75-1.43l4.76-2.75c.42-.24.75,0,.75.56h0A1.78,1.78,0,0,1,141.47,327.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,302.7,140,304c-.24.14-.43,0-.43-.32a1,1,0,0,1,.43-.83l2.23-1.29c.24-.13.43,0,.43.33A1,1,0,0,1,142.2,302.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,304.83c-.24.14-.43,0-.43-.33v-3a1,1,0,0,1,.43-.83c.24-.14.44,0,.44.33v3A1,1,0,0,1,141.08,304.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,321.82l-14.45,8.33c-.23.14-.43,0-.43-.32a1.07,1.07,0,0,1,.43-.83L140,320.66c.24-.14.43,0,.43.33A1,1,0,0,1,140,321.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.37,332.33c-.87.5-1.57,0-1.57-1.19a3.76,3.76,0,0,1,1.57-3c.86-.5,1.57,0,1.57,1.19A3.79,3.79,0,0,1,124.37,332.33Zm0-3a1.67,1.67,0,0,0-.71,1.34c0,.52.32.76.71.53a1.68,1.68,0,0,0,.7-1.34C125.07,329.31,124.76,329.07,124.37,329.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,322.68c-.86.49-1.57,0-1.57-1.19a3.77,3.77,0,0,1,1.57-3c.87-.5,1.57,0,1.57,1.19A3.76,3.76,0,0,1,141.08,322.68Zm0-3a1.72,1.72,0,0,0-.7,1.35c0,.52.32.75.7.53a1.68,1.68,0,0,0,.71-1.34C141.79,319.66,141.47,319.42,141.08,319.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.12 246.23 160.2 257.73 160.2 215.44 180.12 203.93 180.12 246.23",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.12 246.23 160.2 257.73 160.2 215.44 180.12 203.93 180.12 246.23",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,244.52l-15.51,8.95V217.14l15.51-8.95Zm-15.32,8.59,15.13-8.73V208.55l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.56 238.1 162.44 237.97 167.04 230.54 169.24 231.67 175.92 219.49 177.88 220.96 177.75 221.22 175.91 219.85 169.25 232 167.04 230.87 162.56 238.1",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,225.39c-1.1.63-2,0-2-1.51a4.76,4.76,0,0,1,2-3.8c1.1-.64,2,0,2,1.5A4.78,4.78,0,0,1,169.56,225.39Zm0-5.06a4.3,4.3,0,0,0-1.8,3.44c0,1.33.8,1.94,1.8,1.36a4.31,4.31,0,0,0,1.8-3.44C171.36,220.37,170.55,219.76,169.56,220.33Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.71 217.94 159.1 222.9 159.1 218.3 167.71 213.34 167.71 217.94",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,215.68a.46.46,0,0,1,.23-.07.19.19,0,0,1,.15,0,.29.29,0,0,1,.1.12,1.06,1.06,0,0,1,0,.19c0,.08,0,.16,0,.25s0,.18,0,.26a2.23,2.23,0,0,1,0,.23.87.87,0,0,1-.1.24,1.07,1.07,0,0,1-.15.22,1,1,0,0,1-.23.18.54.54,0,0,1-.22.08.24.24,0,0,1-.15,0,.22.22,0,0,1-.1-.13,1.06,1.06,0,0,1,0-.19c0-.07,0-.16,0-.25s0-.17,0-.26a2.23,2.23,0,0,1,0-.23.82.82,0,0,1,.1-.24,1.07,1.07,0,0,1,.15-.22A1.24,1.24,0,0,1,164.79,215.68Zm1.39-.68a.31.31,0,0,1,0-.1.14.14,0,0,1,.07-.06l.21-.12a0,0,0,0,1,.06,0,.06.06,0,0,1,0,0v0s0,0,0,0l-1.71,4a.19.19,0,0,1-.05.09.16.16,0,0,1-.07.07l-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.05v0a0,0,0,0,0,0,0Zm-1.2,1.62v-.43a.25.25,0,0,0,0-.13s-.07,0-.14,0a.29.29,0,0,0-.13.14.61.61,0,0,0,0,.18v.43a.22.22,0,0,0,0,.13s.07,0,.13,0a.27.27,0,0,0,.14-.14A.61.61,0,0,0,165,216.62Zm1.31-.19a.55.55,0,0,1,.22-.07.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.53.53,0,0,1,0,.18,2,2,0,0,1,0,.25,2.17,2.17,0,0,1,0,.26,1.09,1.09,0,0,1,0,.24.92.92,0,0,1-.09.23,1.25,1.25,0,0,1-.16.22,1,1,0,0,1-.22.18.49.49,0,0,1-.22.08.27.27,0,0,1-.16,0,.34.34,0,0,1-.1-.13,1,1,0,0,1,0-.18v-.51a2.4,2.4,0,0,1,0-.24,2.44,2.44,0,0,1,.1-.24,1.53,1.53,0,0,1,.16-.22A.79.79,0,0,1,166.29,216.43Zm.18.94V217a.2.2,0,0,0,0-.13s-.08,0-.14,0a.37.37,0,0,0-.14.14.59.59,0,0,0-.05.19v.42a.22.22,0,0,0,.05.13s.07,0,.14,0a.32.32,0,0,0,.14-.14A.58.58,0,0,0,166.47,217.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.26,252.32l-13.77,7.94c-.2.12-.36,0-.36-.27a.88.88,0,0,1,.36-.69l13.77-8c.2-.11.36,0,.36.28A.88.88,0,0,1,174.26,252.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37,252.5l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.8-.86,1.1-.63s.3.88,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,259.84l-4.58,2.65c-.2.11-.36,0-.36-.27a.85.85,0,0,1,.36-.69l4.58-2.65c.2-.11.36,0,.36.28A.84.84,0,0,1,165.07,259.84Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,257.14l-3.11,1.8c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.11.36,0,.36.27A.85.85,0,0,1,169.75,257.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.11 230.64 187.19 242.14 187.19 199.85 207.11 188.35 207.11 230.64",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.11 230.64 187.19 242.14 187.19 199.85 207.11 188.35 207.11 230.64",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91,228.94l-15.51,8.95V201.56l15.51-9Zm-15.32,8.59,15.13-8.74V193l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.55 222.52 189.44 222.38 194.03 214.96 196.24 216.08 202.91 203.91 204.88 205.38 204.75 205.63 202.91 204.26 196.25 216.41 194.03 215.28 189.55 222.52",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55,209.8c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.63,2,0,2,1.51A4.77,4.77,0,0,1,196.55,209.8Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.31,4.31,0,0,0,1.81-3.44C198.36,204.78,197.55,204.17,196.55,204.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.7 202.35 186.1 207.32 186.1 202.72 194.7 197.75 194.7 202.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,200.1A.46.46,0,0,1,192,200a.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.41.41,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26.66.66,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.77,1.77,0,0,1-.16.22.92.92,0,0,1-.22.17.49.49,0,0,1-.22.08.22.22,0,0,1-.16,0,.23.23,0,0,1-.09-.12.41.41,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.66.66,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.12,1.12,0,0,1,.16-.22A.79.79,0,0,1,191.79,200.1Zm1.38-.69a.36.36,0,0,1,.05-.09.19.19,0,0,1,.08-.07l.2-.12s.05,0,.06,0a.06.06,0,0,1,0,.06v0a0,0,0,0,1,0,0l-1.7,4-.05.09a.29.29,0,0,1-.08.07l-.2.11s0,0-.06,0,0,0,0-.05,0,0,0,0,0,0,0,0ZM192,201s0-.05,0-.09v-.25s0-.06,0-.08a.22.22,0,0,0,0-.13s-.07,0-.14,0a.33.33,0,0,0-.14.15.53.53,0,0,0,0,.18.22.22,0,0,0,0,.09v.25s0,.07,0,.08a.22.22,0,0,0,0,.13s.07,0,.14,0a.33.33,0,0,0,.14-.15A.48.48,0,0,0,192,201Zm1.31-.18a.49.49,0,0,1,.22-.08.27.27,0,0,1,.16,0,.45.45,0,0,1,.1.13,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,2.44,2.44,0,0,1-.1.24,1.12,1.12,0,0,1-.16.22.62.62,0,0,1-.22.17.46.46,0,0,1-.22.08.29.29,0,0,1-.16,0,.3.3,0,0,1-.09-.13.58.58,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26,1,1,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,193.28,200.85Zm.19.93v-.42a.22.22,0,0,0-.05-.13s-.07,0-.14,0a.32.32,0,0,0-.14.14.58.58,0,0,0,0,.18.34.34,0,0,1,0,.09v.25a.32.32,0,0,1,0,.08.2.2,0,0,0,0,.13s.08,0,.14,0a.37.37,0,0,0,.14-.14A.59.59,0,0,0,193.47,201.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,236.73l-13.77,8c-.2.11-.36,0-.36-.27a.85.85,0,0,1,.36-.69l13.77-7.95c.2-.12.36,0,.36.27A.86.86,0,0,1,201.26,236.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,236.91l-1.52-1.15c-.31-.23-.31-.88,0-1.47s.79-.86,1.1-.63l.42.31.41-.79c.31-.58.8-.87,1.1-.64s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,244.26l-4.58,2.64c-.2.12-.36,0-.36-.27a.86.86,0,0,1,.36-.69l4.58-2.64c.2-.12.36,0,.36.27A.86.86,0,0,1,192.07,244.26Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,241.56l-3.1,1.79c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l3.1-1.79c.2-.12.36,0,.36.27A.86.86,0,0,1,196.74,241.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 215.06 214.19 226.56 214.19 184.26 234.11 172.76 234.11 215.06",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 215.06 214.19 226.56 214.19 184.26 234.11 172.76 234.11 215.06",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9,213.35l-15.51,9V186L231.9,177Zm-15.32,8.59,15.13-8.73V177.38l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.55 206.93 216.43 206.8 221.03 199.37 223.23 200.5 229.91 188.32 231.87 189.79 231.74 190.05 229.9 188.68 223.24 200.83 221.03 199.7 216.55 206.93",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.55,194.22c-1.1.63-2,0-2-1.51a4.77,4.77,0,0,1,2-3.8c1.1-.64,2,0,2,1.5A4.78,4.78,0,0,1,223.55,194.22Zm0-5.06a4.31,4.31,0,0,0-1.81,3.44c0,1.33.81,1.94,1.81,1.36a4.31,4.31,0,0,0,1.8-3.44C225.35,189.2,224.54,188.59,223.55,189.16Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.69 186.77 213.09 191.73 213.09 187.13 221.69 182.17 221.69 186.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.78,184.51a.46.46,0,0,1,.22-.07.2.2,0,0,1,.16,0,.29.29,0,0,1,.1.12,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,1.22,1.22,0,0,1-.1.24.82.82,0,0,1-.16.22.79.79,0,0,1-.22.18.59.59,0,0,1-.22.08.24.24,0,0,1-.15,0,.22.22,0,0,1-.1-.13.58.58,0,0,1,0-.19c0-.07,0-.16,0-.25s0-.17,0-.26a1,1,0,0,1,0-.23.82.82,0,0,1,.1-.24,1.07,1.07,0,0,1,.15-.22A1,1,0,0,1,218.78,184.51Zm1.39-.69a.41.41,0,0,1,.05-.09.14.14,0,0,1,.07-.06l.21-.12a0,0,0,0,1,.06,0,.06.06,0,0,1,0,.05v0a0,0,0,0,0,0,0l-1.71,4a.19.19,0,0,1-.05.09.16.16,0,0,1-.07.07l-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0,0v0s0,0,0,0Zm-1.2,1.63V185a.22.22,0,0,0-.05-.13s-.07,0-.14,0a.29.29,0,0,0-.13.14.61.61,0,0,0-.05.18v.09a.62.62,0,0,0,0,.13.49.49,0,0,0,0,.12v.09a.22.22,0,0,0,.05.13s.07,0,.13,0a.27.27,0,0,0,.14-.14A.61.61,0,0,0,219,185.45Zm1.31-.19a.55.55,0,0,1,.22-.07.24.24,0,0,1,.15,0,.22.22,0,0,1,.1.13.48.48,0,0,1,0,.18,2,2,0,0,1,0,.25,2.17,2.17,0,0,1,0,.26.93.93,0,0,1,0,.23.64.64,0,0,1-.1.24.86.86,0,0,1-.15.22,1,1,0,0,1-.22.18.66.66,0,0,1-.22.08.25.25,0,0,1-.16,0,.27.27,0,0,1-.1-.13,1,1,0,0,1,0-.18v-.51a2.4,2.4,0,0,1,0-.24,1.22,1.22,0,0,1,.1-.24,1,1,0,0,1,.16-.22A.79.79,0,0,1,220.28,185.26Zm.18.94v-.43a.25.25,0,0,0-.05-.13s-.07,0-.13,0a.31.31,0,0,0-.14.14.59.59,0,0,0,0,.19v.42a.22.22,0,0,0,0,.13s.07,0,.14,0a.25.25,0,0,0,.13-.14A.61.61,0,0,0,220.46,186.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,221.14l-13.77,8c-.2.12-.36,0-.36-.27a.88.88,0,0,1,.36-.69l13.77-7.95c.2-.11.36,0,.36.28A.84.84,0,0,1,228.25,221.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.36,221.33l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.79-.86,1.1-.63s.3.88,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.06,228.67l-4.58,2.65c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l4.58-2.64c.2-.11.36,0,.36.27A.85.85,0,0,1,219.06,228.67Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.74,226l-3.11,1.8c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.11.36,0,.36.27A.85.85,0,0,1,223.74,226Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.1 199.47 241.18 210.97 241.18 168.68 261.1 157.18 261.1 199.47",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.1 199.47 241.18 210.97 241.18 168.68 261.1 157.18 261.1 199.47",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,197.76l-15.51,9V170.39l15.51-9Zm-15.32,8.6,15.13-8.74V161.8l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.54 191.35 243.42 191.22 248.02 183.79 250.23 184.91 256.9 172.74 258.87 174.21 258.73 174.46 256.9 173.09 250.24 185.24 248.02 184.12 243.54 191.35",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,178.63c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.63,2,0,2,1.51A4.76,4.76,0,0,1,250.54,178.63Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.3,4.3,0,0,0,1.8-3.44C252.34,173.61,251.54,173,250.54,173.57Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.69 171.18 240.09 176.15 240.09 171.55 248.69 166.58 248.69 171.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,168.93a.46.46,0,0,1,.22-.08.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.58.58,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26,1,1,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.77,1.77,0,0,1-.16.22,1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.22.22,0,0,1-.16,0,.4.4,0,0,1-.1-.12,1.06,1.06,0,0,1,0-.19v-.51a2.23,2.23,0,0,1,0-.23,2.44,2.44,0,0,1,.1-.24,1.12,1.12,0,0,1,.16-.22A.79.79,0,0,1,245.78,168.93Zm1.38-.69a.36.36,0,0,1,.05-.09.23.23,0,0,1,.07-.07l.21-.12s0,0,.06,0,0,0,0,.06v0a0,0,0,0,1,0,0l-1.7,4a.41.41,0,0,0-.05.09.17.17,0,0,1-.08.06l-.2.12s-.05,0-.06,0,0,0,0,0,0,0,0,0,0,0,0,0Zm-1.2,1.62v-.42a.22.22,0,0,0,0-.13s-.08,0-.14,0a.33.33,0,0,0-.14.15.37.37,0,0,0,0,.18.22.22,0,0,0,0,.09V170s0,.07,0,.08a.17.17,0,0,0,0,.13s.07,0,.14,0a.4.4,0,0,0,.14-.15A.48.48,0,0,0,246,169.86Zm1.31-.18a.49.49,0,0,1,.22-.08.27.27,0,0,1,.16,0,.25.25,0,0,1,.09.13.41.41,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.17,2.17,0,0,1,0,.26.66.66,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.12,1.12,0,0,1-.16.22.62.62,0,0,1-.22.17.46.46,0,0,1-.22.08.29.29,0,0,1-.16,0,.3.3,0,0,1-.09-.13.41.41,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.66.66,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,247.27,169.68Zm.18.93a.22.22,0,0,0,0-.09v-.24a.6.6,0,0,0-.05-.22s-.07,0-.14,0a.33.33,0,0,0-.14.15.58.58,0,0,0,0,.18s0,0,0,.09v.25a.54.54,0,0,0,0,.08.2.2,0,0,0,0,.13s.07,0,.14,0a.37.37,0,0,0,.14-.14A.58.58,0,0,0,247.45,170.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,205.56l-13.76,7.95c-.2.11-.36,0-.36-.27a.85.85,0,0,1,.36-.69l13.76-8c.2-.12.37,0,.37.27A.87.87,0,0,1,255.24,205.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,205.74l-1.51-1.15c-.31-.23-.31-.88,0-1.47s.79-.86,1.1-.63l.41.31.42-.79c.31-.59.8-.87,1.1-.64s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,213.09l-4.57,2.64c-.2.12-.36,0-.36-.27a.86.86,0,0,1,.36-.69l4.57-2.64c.2-.12.37,0,.37.27A.87.87,0,0,1,246.05,213.09Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,210.39l-3.1,1.79c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l3.1-1.79c.2-.12.36,0,.36.27A.88.88,0,0,1,250.73,210.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.1 183.88 268.18 195.39 268.18 153.09 288.1 141.59 288.1 183.88",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.1 183.88 268.18 195.39 268.18 153.09 288.1 141.59 288.1 183.88",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,182.18l-15.51,8.95V154.8l15.51-9Zm-15.32,8.59L285.7,182V146.21l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.54 175.76 270.42 175.63 275.02 168.2 277.22 169.33 283.9 157.15 285.86 158.62 285.73 158.88 283.89 157.51 277.23 169.66 275.01 168.53 270.54 175.76",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,163.05c-1.1.63-2,0-2-1.51a4.8,4.8,0,0,1,2-3.81c1.09-.63,2,.05,2,1.51A4.81,4.81,0,0,1,277.54,163.05Zm0-5.06a4.31,4.31,0,0,0-1.81,3.44c0,1.33.81,1.94,1.81,1.36a4.31,4.31,0,0,0,1.8-3.44C279.34,158,278.53,157.41,277.54,158Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.68 155.6 267.08 160.56 267.08 155.96 275.68 151 275.68 155.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,153.34a.46.46,0,0,1,.22-.07.2.2,0,0,1,.16,0,.4.4,0,0,1,.1.12,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,2.44,2.44,0,0,1-.1.24.82.82,0,0,1-.16.22.79.79,0,0,1-.22.18.59.59,0,0,1-.22.08.29.29,0,0,1-.16,0,.25.25,0,0,1-.09-.13.58.58,0,0,1,0-.19,1.93,1.93,0,0,1,0-.25,2.26,2.26,0,0,1,0-.26,1,1,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,272.77,153.34Zm1.38-.69.06-.09a.14.14,0,0,1,.07-.06l.21-.12a0,0,0,0,1,.06,0s0,0,0,0v0a.08.08,0,0,0,0,0l-1.71,4a.19.19,0,0,1-.05.09l-.07.07-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.06v-.05Zm-1.2,1.63a.22.22,0,0,0,0-.09v-.25a.22.22,0,0,0,0-.09.17.17,0,0,0,0-.13s-.07,0-.14,0a.38.38,0,0,0-.14.14.58.58,0,0,0,0,.18.34.34,0,0,1,0,.09v.25a.34.34,0,0,1,0,.09.22.22,0,0,0,0,.13s.08,0,.14,0a.32.32,0,0,0,.14-.14A.39.39,0,0,0,273,154.28Zm1.32-.19a.4.4,0,0,1,.22-.07.24.24,0,0,1,.15,0,.22.22,0,0,1,.1.13.8.8,0,0,1,0,.18c0,.08,0,.16,0,.25s0,.18,0,.26a1.85,1.85,0,0,1,0,.23.64.64,0,0,1-.1.24.86.86,0,0,1-.15.22,1.24,1.24,0,0,1-.22.18.63.63,0,0,1-.23.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.1-.13,1,1,0,0,1,0-.18c0-.08,0-.16,0-.26s0-.17,0-.25a2.4,2.4,0,0,1,0-.24,1.22,1.22,0,0,1,.1-.24,1.43,1.43,0,0,1,.15-.22A1,1,0,0,1,274.27,154.09Zm.18.94v-.43a.25.25,0,0,0-.05-.13s-.07,0-.13,0a.31.31,0,0,0-.14.14.59.59,0,0,0-.05.19v.42a.22.22,0,0,0,.05.13s.07,0,.14,0a.25.25,0,0,0,.13-.14A.61.61,0,0,0,274.45,155Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,190l-13.77,7.95c-.2.12-.36,0-.36-.27a.86.86,0,0,1,.36-.69l13.77-8c.2-.11.36,0,.36.27A.85.85,0,0,1,282.24,190Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.35,190.16,284.83,189c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.79-.87,1.1-.64s.3.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.05,197.5l-4.58,2.65c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l4.58-2.64c.2-.11.36,0,.36.27A.85.85,0,0,1,273.05,197.5Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,194.8l-3.11,1.8c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.11.36,0,.36.27A.85.85,0,0,1,277.73,194.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 168.3 295.17 179.8 295.17 137.51 315.09 126.01 315.09 168.3",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 168.3 295.17 179.8 295.17 137.51 315.09 126.01 315.09 168.3",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,166.59l-15.5,9V139.22l15.5-9Zm-15.31,8.59,15.12-8.73V130.62l-15.12,8.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.53 160.18 297.41 160.04 302.01 152.62 304.21 153.74 310.89 141.57 312.86 143.03 312.72 143.29 310.89 141.92 304.22 154.07 302.01 152.94 297.53 160.18",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53,147.46c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.63,2,0,2,1.51A4.76,4.76,0,0,1,304.53,147.46Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.34,4.34,0,0,0,1.8-3.44C306.33,142.44,305.52,141.83,304.53,142.4Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.68 140.01 294.08 144.98 294.08 140.38 302.68 135.41 302.68 140.01",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.77,137.76a.46.46,0,0,1,.22-.08.24.24,0,0,1,.15,0,.22.22,0,0,1,.1.13.58.58,0,0,1,0,.19c0,.07,0,.16,0,.25s0,.17,0,.26a1,1,0,0,1,0,.23.82.82,0,0,1-.1.24,1.07,1.07,0,0,1-.15.22,1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.25.25,0,0,1-.16,0,.29.29,0,0,1-.1-.12,1.06,1.06,0,0,1,0-.19v-.51a2.23,2.23,0,0,1,0-.23.87.87,0,0,1,.1-.24.69.69,0,0,1,.16-.22A.79.79,0,0,1,299.77,137.76Zm1.38-.69a.36.36,0,0,1,.05-.09l.07-.07.21-.12s0,0,.06,0,0,0,0,.05v.06l-1.7,4a.41.41,0,0,0-.05.09.24.24,0,0,1-.08.06l-.21.12a0,0,0,0,1-.06,0s0,0,0-.05v0a0,0,0,0,1,0,0Zm-1.2,1.62v-.42a.22.22,0,0,0-.05-.13s-.07,0-.13,0a.29.29,0,0,0-.14.15.48.48,0,0,0-.05.18v.42a.22.22,0,0,0,.05.13s.07,0,.14,0a.31.31,0,0,0,.13-.15A.53.53,0,0,0,300,138.69Zm1.31-.18a.46.46,0,0,1,.22-.08.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.41.41,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26.66.66,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.77,1.77,0,0,1-.16.22.92.92,0,0,1-.22.17.49.49,0,0,1-.22.08.22.22,0,0,1-.16,0,.23.23,0,0,1-.09-.12.41.41,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.66.66,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.12,1.12,0,0,1,.16-.22A.79.79,0,0,1,301.26,138.51Zm.18.93s0-.05,0-.09v-.25s0-.06,0-.08a.22.22,0,0,0,0-.13s-.07,0-.14,0a.33.33,0,0,0-.14.15.58.58,0,0,0,0,.18.22.22,0,0,0,0,.09v.25s0,.07,0,.08a.2.2,0,0,0,0,.13s.07,0,.14,0a.33.33,0,0,0,.14-.15A.48.48,0,0,0,301.44,139.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23,174.39l-13.76,8c-.2.11-.37,0-.37-.27a.86.86,0,0,1,.37-.69l13.76-7.95c.2-.12.36,0,.36.27A.86.86,0,0,1,309.23,174.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,174.57l-1.52-1.15c-.3-.23-.3-.88,0-1.47s.8-.86,1.11-.63l.41.31.42-.79c.3-.59.8-.87,1.1-.64s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,181.92l-4.57,2.64c-.2.12-.37,0-.37-.27a.86.86,0,0,1,.37-.69L300,181c.2-.12.36,0,.36.27A.88.88,0,0,1,300,181.92Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,179.22l-3.1,1.79c-.2.12-.37,0-.37-.27a.86.86,0,0,1,.37-.69l3.1-1.79c.2-.12.36,0,.36.27A.88.88,0,0,1,304.72,179.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.12 304.45 160.2 315.96 160.2 273.66 180.12 262.16 180.12 304.45",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.12 304.45 160.2 315.96 160.2 273.66 180.12 262.16 180.12 304.45",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,302.75,162.4,311.7V275.37l15.51-8.95Zm-15.32,8.59,15.13-8.73V266.78l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.56 296.33 162.44 296.2 167.04 288.77 169.24 289.9 175.92 277.72 177.88 279.19 177.75 279.45 175.91 278.08 169.25 290.23 167.04 289.1 162.56 296.33",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,283.62c-1.1.63-2,0-2-1.51a4.79,4.79,0,0,1,2-3.81c1.1-.63,2,.05,2,1.51A4.79,4.79,0,0,1,169.56,283.62Zm0-5.06a4.3,4.3,0,0,0-1.8,3.44c0,1.33.8,1.94,1.8,1.36a4.31,4.31,0,0,0,1.8-3.44C171.36,278.59,170.55,278,169.56,278.56Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.71 276.17 159.1 281.13 159.1 276.53 167.71 271.56 167.71 276.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,273.91a.46.46,0,0,1,.23-.07.19.19,0,0,1,.15,0,.24.24,0,0,1,.1.12,1.06,1.06,0,0,1,0,.19c0,.08,0,.16,0,.25s0,.18,0,.26a2.23,2.23,0,0,1,0,.23,1.22,1.22,0,0,1-.1.24,1.07,1.07,0,0,1-.15.22,1,1,0,0,1-.23.18.54.54,0,0,1-.22.08.24.24,0,0,1-.15,0,.22.22,0,0,1-.1-.13,1.06,1.06,0,0,1,0-.19c0-.07,0-.16,0-.25s0-.17,0-.26a2.23,2.23,0,0,1,0-.23.82.82,0,0,1,.1-.24,1.07,1.07,0,0,1,.15-.22A1.24,1.24,0,0,1,164.79,273.91Zm1.39-.69a.41.41,0,0,1,0-.09l.07-.07.21-.11a0,0,0,0,1,.06,0s0,0,0,.05v.06l-1.71,4a.19.19,0,0,1-.05.09.16.16,0,0,1-.07.07l-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.06v0a0,0,0,0,0,0,0Zm-1.2,1.63v-.43a.22.22,0,0,0,0-.13s-.07,0-.14,0a.29.29,0,0,0-.13.14.61.61,0,0,0,0,.18v.43a.25.25,0,0,0,0,.13s.07,0,.13,0a.27.27,0,0,0,.14-.14A.61.61,0,0,0,165,274.85Zm1.31-.19a.43.43,0,0,1,.22-.07.23.23,0,0,1,.16,0,.25.25,0,0,1,.09.13.48.48,0,0,1,0,.18,2,2,0,0,1,0,.25,2.17,2.17,0,0,1,0,.26.93.93,0,0,1,0,.23.85.85,0,0,1-.09.24,1.77,1.77,0,0,1-.16.22,1,1,0,0,1-.22.18.66.66,0,0,1-.22.08.27.27,0,0,1-.16,0,.34.34,0,0,1-.1-.13,1,1,0,0,1,0-.18v-.52a2.23,2.23,0,0,1,0-.23,2.44,2.44,0,0,1,.1-.24,1.12,1.12,0,0,1,.16-.22A.79.79,0,0,1,166.29,274.66Zm.18.94v-.43a.25.25,0,0,0,0-.13.13.13,0,0,0-.14,0,.37.37,0,0,0-.14.14.59.59,0,0,0-.05.19v.42a.22.22,0,0,0,.05.13s.07,0,.14,0a.38.38,0,0,0,.14-.14A.58.58,0,0,0,166.47,275.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.26,310.54l-13.77,7.95c-.2.12-.36,0-.36-.27a.86.86,0,0,1,.36-.69l13.77-7.95c.2-.11.36,0,.36.27A.85.85,0,0,1,174.26,310.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37,310.73l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.8-.87,1.1-.64s.3.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.07,318.07l-4.58,2.65c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l4.58-2.64c.2-.11.36,0,.36.27A.85.85,0,0,1,165.07,318.07Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,315.37l-3.11,1.8c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.11.36,0,.36.27A.85.85,0,0,1,169.75,315.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.11 288.87 187.19 300.37 187.19 258.08 207.11 246.58 207.11 288.87",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.11 288.87 187.19 300.37 187.19 258.08 207.11 246.58 207.11 288.87",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91,287.16l-15.51,9V259.78l15.51-8.95Zm-15.32,8.59L204.72,287V251.19l-15.13,8.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.55 280.75 189.44 280.61 194.03 273.19 196.24 274.31 202.91 262.14 204.88 263.61 204.75 263.86 202.91 262.49 196.25 274.64 194.03 273.51 189.55 280.75",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.55,268c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.64,2,0,2,1.51A4.77,4.77,0,0,1,196.55,268Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.33,4.33,0,0,0,1.81-3.45C198.36,263,197.55,262.4,196.55,263Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.7 260.58 186.1 265.55 186.1 260.95 194.7 255.98 194.7 260.58",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.79,258.33a.46.46,0,0,1,.22-.08.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.37.37,0,0,1,0,.18,2.17,2.17,0,0,1,0,.26,2,2,0,0,1,0,.25.67.67,0,0,1,0,.24,1.17,1.17,0,0,1-.09.24c0,.07-.1.15-.16.22a1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.27.27,0,0,1-.16,0,.25.25,0,0,1-.09-.13.34.34,0,0,1,0-.18,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.62.62,0,0,1,0-.23.85.85,0,0,1,.09-.24,1.19,1.19,0,0,1,.16-.23A1,1,0,0,1,191.79,258.33Zm1.38-.69a.36.36,0,0,1,.05-.09.19.19,0,0,1,.08-.07l.2-.12s.05,0,.06,0a.05.05,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0l-1.7,4a.93.93,0,0,1-.05.1.17.17,0,0,1-.08.06l-.2.12s0,0-.06,0a0,0,0,0,1,0-.05v0a0,0,0,0,1,0,0Zm-1.2,1.62s0-.05,0-.09v-.25a.54.54,0,0,0,0-.08.2.2,0,0,0,0-.13s-.07,0-.14,0a.33.33,0,0,0-.14.15.48.48,0,0,0,0,.18.22.22,0,0,0,0,.09v.25a.17.17,0,0,0,0,.08.22.22,0,0,0,0,.13s.07,0,.14,0a.33.33,0,0,0,.14-.15A.58.58,0,0,0,192,259.26Zm1.31-.18a.49.49,0,0,1,.22-.08.27.27,0,0,1,.16,0,.34.34,0,0,1,.1.13,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,2.44,2.44,0,0,1-.1.24,1.12,1.12,0,0,1-.16.22.76.76,0,0,1-.22.17.46.46,0,0,1-.22.08.24.24,0,0,1-.25-.16.58.58,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26,1,1,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,193.28,259.08Zm.19.93v-.42a.22.22,0,0,0-.05-.13s-.07,0-.14,0a.4.4,0,0,0-.14.15.58.58,0,0,0,0,.18.34.34,0,0,1,0,.09v.25a.32.32,0,0,1,0,.08.2.2,0,0,0,0,.13s.08,0,.14,0a.33.33,0,0,0,.14-.15A.48.48,0,0,0,193.47,260Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,295l-13.77,8c-.2.11-.36,0-.36-.28a.84.84,0,0,1,.36-.68L201.26,294c.2-.12.36,0,.36.27A.86.86,0,0,1,201.26,295Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.37,295.14,203.85,294c-.31-.23-.31-.89,0-1.47s.79-.86,1.1-.63l.42.31.41-.79c.31-.59.8-.87,1.1-.64s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,302.49l-4.58,2.64c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l4.58-2.64c.2-.12.36,0,.36.27A.88.88,0,0,1,192.07,302.49Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,299.79l-3.1,1.79c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l3.1-1.79c.2-.12.36,0,.36.27A.88.88,0,0,1,196.74,299.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 273.28 214.19 284.79 214.19 242.49 234.11 230.99 234.11 273.28",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.11 273.28 214.19 284.79 214.19 242.49 234.11 230.99 234.11 273.28",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9,271.58l-15.51,8.95V244.2l15.51-8.95Zm-15.32,8.59,15.13-8.74V235.61l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.55 265.16 216.43 265.03 221.03 257.6 223.23 258.73 229.91 246.55 231.87 248.02 231.74 248.28 229.9 246.91 223.24 259.06 221.03 257.93 216.55 265.16",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.55,252.45c-1.1.63-2,0-2-1.51a4.8,4.8,0,0,1,2-3.81c1.1-.63,2,.05,2,1.51A4.79,4.79,0,0,1,223.55,252.45Zm0-5.06a4.31,4.31,0,0,0-1.81,3.44c0,1.33.81,1.94,1.81,1.36a4.33,4.33,0,0,0,1.8-3.44C225.35,247.42,224.54,246.81,223.55,247.39Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.69 245 213.09 249.96 213.09 245.36 221.69 240.39 221.69 245",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.78,242.74a.66.66,0,0,1,.22-.08.34.34,0,0,1,.16,0,.32.32,0,0,1,.1.13,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,1.22,1.22,0,0,1-.1.24.82.82,0,0,1-.16.22.79.79,0,0,1-.22.18.59.59,0,0,1-.22.08.24.24,0,0,1-.15,0,.22.22,0,0,1-.1-.13.58.58,0,0,1,0-.19c0-.07,0-.16,0-.25s0-.18,0-.26a1,1,0,0,1,0-.23.82.82,0,0,1,.1-.24,1.07,1.07,0,0,1,.15-.22A1,1,0,0,1,218.78,242.74Zm1.39-.69a.41.41,0,0,1,.05-.09.16.16,0,0,1,.07-.07l.21-.12a.06.06,0,0,1,.06,0s0,0,0,0v0a.06.06,0,0,0,0,0l-1.71,4a.19.19,0,0,1-.05.09.16.16,0,0,1-.07.07l-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.06V246Zm-1.2,1.62v-.42a.22.22,0,0,0-.05-.13s-.07,0-.14,0a.29.29,0,0,0-.13.14.61.61,0,0,0-.05.18v.09a.57.57,0,0,0,0,.13.49.49,0,0,0,0,.12v.09a.25.25,0,0,0,.05.13s.07,0,.13,0a.31.31,0,0,0,.14-.14A.59.59,0,0,0,219,243.67Zm1.31-.18a.43.43,0,0,1,.22-.07.19.19,0,0,1,.15,0,.23.23,0,0,1,.1.12.58.58,0,0,1,0,.19,2,2,0,0,1,0,.25,2.17,2.17,0,0,1,0,.26,1,1,0,0,1,0,.23.64.64,0,0,1-.1.24,1.07,1.07,0,0,1-.15.22,1,1,0,0,1-.22.18.66.66,0,0,1-.22.08.25.25,0,0,1-.16,0,.27.27,0,0,1-.1-.13,1.06,1.06,0,0,1,0-.19v-.51a2.23,2.23,0,0,1,0-.23,1.22,1.22,0,0,1,.1-.24.82.82,0,0,1,.16-.22A.79.79,0,0,1,220.28,243.49Zm.18.94V244a.25.25,0,0,0-.05-.13s-.07,0-.13,0a.27.27,0,0,0-.14.14.61.61,0,0,0,0,.18v.43a.22.22,0,0,0,0,.13s.07,0,.14,0a.29.29,0,0,0,.13-.14A.61.61,0,0,0,220.46,244.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,279.37l-13.77,7.95c-.2.12-.36,0-.36-.27a.86.86,0,0,1,.36-.69l13.77-7.95c.2-.11.36,0,.36.27A.85.85,0,0,1,228.25,279.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.36,279.56l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.79-.87,1.1-.64s.3.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.06,286.9l-4.58,2.65c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l4.58-2.64c.2-.11.36,0,.36.27A.85.85,0,0,1,219.06,286.9Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.74,284.2,220.63,286c-.2.12-.36,0-.36-.27a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.12.36,0,.36.27A.85.85,0,0,1,223.74,284.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.1 257.7 241.18 269.2 241.18 226.91 261.1 215.41 261.1 257.7",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.1 257.7 241.18 269.2 241.18 226.91 261.1 215.41 261.1 257.7",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,256l-15.51,9V228.61l15.51-9Zm-15.32,8.59,15.13-8.73V220l-15.13,8.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.54 249.58 243.42 249.44 248.02 242.02 250.23 243.14 256.9 230.97 258.87 232.43 258.73 232.69 256.9 231.32 250.24 243.47 248.02 242.34 243.54 249.58",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,236.86c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.64,2,0,2,1.5A4.76,4.76,0,0,1,250.54,236.86Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.32,4.32,0,0,0,1.8-3.45C252.34,231.84,251.54,231.23,250.54,231.8Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.69 229.41 240.09 234.38 240.09 229.78 248.69 224.81 248.69 229.41",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.78,227.16a.46.46,0,0,1,.22-.08.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.53.53,0,0,1,0,.18,2.17,2.17,0,0,1,0,.26,2,2,0,0,1,0,.25,1,1,0,0,1,0,.24,1.17,1.17,0,0,1-.09.24c0,.07-.1.15-.16.22a1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.27.27,0,0,1-.16,0,.34.34,0,0,1-.1-.13.8.8,0,0,1,0-.18V228a1.85,1.85,0,0,1,0-.23,1.33,1.33,0,0,1,.1-.24,1.19,1.19,0,0,1,.16-.23A.76.76,0,0,1,245.78,227.16Zm1.38-.69a.36.36,0,0,1,.05-.09.23.23,0,0,1,.07-.07l.21-.12s0,0,.06,0,0,0,0,0v0a0,0,0,0,1,0,0l-1.7,4a.93.93,0,0,0-.05.1.28.28,0,0,1-.08.06l-.2.12s-.05,0-.06,0a0,0,0,0,1,0-.05v0a0,0,0,0,1,0,0Zm-1.2,1.62v-.42a.2.2,0,0,0,0-.13s-.08,0-.14,0a.33.33,0,0,0-.14.15.34.34,0,0,0,0,.18.22.22,0,0,0,0,.09v.25a.17.17,0,0,0,0,.08.17.17,0,0,0,0,.13s.07,0,.14,0a.4.4,0,0,0,.14-.15A.58.58,0,0,0,246,228.09Zm1.31-.18a.49.49,0,0,1,.22-.08.27.27,0,0,1,.16,0,.25.25,0,0,1,.09.13.41.41,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26.66.66,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.12,1.12,0,0,1-.16.22.76.76,0,0,1-.22.17.46.46,0,0,1-.22.08.24.24,0,0,1-.25-.16.41.41,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.66.66,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,247.27,227.91Zm.18.93a.22.22,0,0,0,0-.09v-.25a.17.17,0,0,0,0-.08.22.22,0,0,0,0-.13s-.07,0-.14,0a.33.33,0,0,0-.14.15.53.53,0,0,0,0,.18s0,.05,0,.09V229a.54.54,0,0,0,0,.08.22.22,0,0,0,0,.13s.07,0,.14,0a.33.33,0,0,0,.14-.15A.48.48,0,0,0,247.45,228.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,263.79l-13.76,7.95c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l13.76-7.94c.2-.12.37,0,.37.27A.89.89,0,0,1,255.24,263.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,264l-1.51-1.15c-.31-.23-.31-.89,0-1.47s.79-.86,1.1-.63l.41.31.42-.8c.31-.58.8-.86,1.1-.63s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,271.32,241.48,274c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l4.57-2.64c.2-.12.37,0,.37.27A.89.89,0,0,1,246.05,271.32Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,268.62l-3.1,1.79c-.2.11-.36,0-.36-.27a.85.85,0,0,1,.36-.69l3.1-1.8c.2-.11.36,0,.36.28A.88.88,0,0,1,250.73,268.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.1 242.11 268.18 253.62 268.18 211.32 288.1 199.82 288.1 242.11",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.1 242.11 268.18 253.62 268.18 211.32 288.1 199.82 288.1 242.11",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,240.41l-15.51,9V213l15.51-9ZM270.57,249l15.13-8.74V204.44l-15.13,8.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.54 233.99 270.42 233.86 275.02 226.43 277.22 227.56 283.9 215.38 285.86 216.85 285.73 217.11 283.89 215.74 277.23 227.89 275.01 226.76 270.54 233.99",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.54,221.28c-1.1.63-2-.05-2-1.51a4.8,4.8,0,0,1,2-3.81c1.09-.63,2,0,2,1.51A4.82,4.82,0,0,1,277.54,221.28Zm0-5.06a4.31,4.31,0,0,0-1.81,3.44c0,1.33.81,1.94,1.81,1.36a4.33,4.33,0,0,0,1.8-3.44C279.34,216.25,278.53,215.64,277.54,216.22Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.68 213.82 267.08 218.79 267.08 214.19 275.68 209.22 275.68 213.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,211.57a.66.66,0,0,1,.22-.08.34.34,0,0,1,.16,0,.45.45,0,0,1,.1.13,1.06,1.06,0,0,1,0,.19v.51a2.23,2.23,0,0,1,0,.23,2.44,2.44,0,0,1-.1.24.82.82,0,0,1-.16.22.79.79,0,0,1-.22.18.59.59,0,0,1-.22.08.29.29,0,0,1-.16,0,.25.25,0,0,1-.09-.13.58.58,0,0,1,0-.19,1.93,1.93,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26,1,1,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.77,1.77,0,0,1,.16-.22A1,1,0,0,1,272.77,211.57Zm1.38-.69.06-.09a.16.16,0,0,1,.07-.07l.21-.12h.06s0,0,0,.05v0a.06.06,0,0,0,0,0l-1.71,4a.19.19,0,0,1-.05.09l-.07.07-.21.12a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.06v0s0,0,0,0ZM273,212.5a.22.22,0,0,0,0-.09v-.24a.22.22,0,0,0,0-.09.17.17,0,0,0,0-.13s-.07,0-.14,0a.32.32,0,0,0-.14.14.58.58,0,0,0,0,.18.34.34,0,0,1,0,.09v.25a.34.34,0,0,1,0,.09.25.25,0,0,0,0,.13.13.13,0,0,0,.14,0,.37.37,0,0,0,.14-.14A.41.41,0,0,0,273,212.5Zm1.32-.18a.4.4,0,0,1,.22-.07.19.19,0,0,1,.15,0,.23.23,0,0,1,.1.12,1.06,1.06,0,0,1,0,.19c0,.08,0,.16,0,.25s0,.18,0,.26a2.23,2.23,0,0,1,0,.23.82.82,0,0,1-.1.24,1.07,1.07,0,0,1-.15.22,1.24,1.24,0,0,1-.22.18.63.63,0,0,1-.23.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.1-.13,1.06,1.06,0,0,1,0-.19c0-.07,0-.16,0-.25s0-.17,0-.26a2.23,2.23,0,0,1,0-.23,1.22,1.22,0,0,1,.1-.24,1.07,1.07,0,0,1,.15-.22A1,1,0,0,1,274.27,212.32Zm.18.94v-.43a.22.22,0,0,0-.05-.13s-.07,0-.13,0a.27.27,0,0,0-.14.14.61.61,0,0,0-.05.18v.43a.22.22,0,0,0,.05.13s.07,0,.14,0a.29.29,0,0,0,.13-.14A.61.61,0,0,0,274.45,213.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,248.2l-13.77,7.95c-.2.12-.36,0-.36-.27a.85.85,0,0,1,.36-.69l13.77-7.95c.2-.11.36,0,.36.27A.85.85,0,0,1,282.24,248.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.35,248.39l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.87,1.1-.64l.42.32.42-.8c.3-.58.79-.87,1.1-.64s.3.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.05,255.73l-4.58,2.65c-.2.11-.36,0-.36-.28a.88.88,0,0,1,.36-.69l4.58-2.64c.2-.12.36,0,.36.27A.85.85,0,0,1,273.05,255.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,253l-3.11,1.79c-.2.12-.36,0-.36-.27a.88.88,0,0,1,.36-.69l3.11-1.79c.2-.12.36,0,.36.27A.85.85,0,0,1,277.73,253Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 226.53 295.17 238.03 295.17 195.74 315.09 184.24 315.09 226.53",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.09 226.53 295.17 238.03 295.17 195.74 315.09 184.24 315.09 226.53",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.88,224.82l-15.5,9V197.44l15.5-8.95Zm-15.31,8.59,15.12-8.73V188.85l-15.12,8.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.53 218.41 297.41 218.27 302.01 210.85 304.21 211.97 310.89 199.8 312.86 201.26 312.72 201.52 310.89 200.15 304.22 212.3 302.01 211.17 297.53 218.41",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53,205.69c-1.1.64-2,0-2-1.5a4.76,4.76,0,0,1,2-3.81c1.1-.64,2,0,2,1.5A4.76,4.76,0,0,1,304.53,205.69Zm0-5.06a4.35,4.35,0,0,0-1.8,3.45c0,1.32.81,1.93,1.8,1.36a4.35,4.35,0,0,0,1.8-3.45C306.33,200.67,305.52,200.06,304.53,200.63Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.68 198.24 294.08 203.21 294.08 198.6 302.68 193.64 302.68 198.24",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.77,196a.46.46,0,0,1,.22-.08.24.24,0,0,1,.15,0,.22.22,0,0,1,.1.13.53.53,0,0,1,0,.18c0,.08,0,.16,0,.26s0,.17,0,.25a1.09,1.09,0,0,1,0,.24.82.82,0,0,1-.1.24,1.43,1.43,0,0,1-.15.22,1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.25.25,0,0,1-.16,0,.27.27,0,0,1-.1-.13.8.8,0,0,1,0-.18v-.51a1.85,1.85,0,0,1,0-.23,1.27,1.27,0,0,1,.26-.47A.62.62,0,0,1,299.77,196Zm1.38-.69.05-.1.07-.06.21-.12s0,0,.06,0,0,0,0,.05v.06l-1.7,4a.93.93,0,0,0-.05.1l-.08.06-.21.12a0,0,0,0,1-.06,0,.06.06,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0Zm-1.2,1.62v-.42c0-.06,0-.11-.05-.13s-.07,0-.13,0a.29.29,0,0,0-.14.15.48.48,0,0,0-.05.18v.42a.22.22,0,0,0,.05.13s.07,0,.14,0a.31.31,0,0,0,.13-.15A.61.61,0,0,0,300,196.92Zm1.31-.18a.46.46,0,0,1,.22-.08.29.29,0,0,1,.16,0,.25.25,0,0,1,.09.13.41.41,0,0,1,0,.19,1.93,1.93,0,0,1,0,.25,2.26,2.26,0,0,1,0,.26.66.66,0,0,1,0,.23,1.17,1.17,0,0,1-.09.24,1.77,1.77,0,0,1-.16.22,1.28,1.28,0,0,1-.22.17.49.49,0,0,1-.22.08.22.22,0,0,1-.16,0,.27.27,0,0,1-.09-.12.41.41,0,0,1,0-.19,2,2,0,0,1,0-.25,2.17,2.17,0,0,1,0-.26.66.66,0,0,1,0-.23,1.17,1.17,0,0,1,.09-.24,1.12,1.12,0,0,1,.16-.22A.79.79,0,0,1,301.26,196.74Zm.18.93s0,0,0-.09v-.25s0-.06,0-.08a.22.22,0,0,0,0-.13s-.07,0-.14,0a.33.33,0,0,0-.14.15.53.53,0,0,0,0,.18.22.22,0,0,0,0,.09v.25a.17.17,0,0,0,0,.08.22.22,0,0,0,0,.13s.07,0,.14,0a.33.33,0,0,0,.14-.15A.53.53,0,0,0,301.44,197.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23,232.62l-13.76,7.95c-.2.11-.37,0-.37-.28a.89.89,0,0,1,.37-.69l13.76-7.94c.2-.12.36,0,.36.27A.88.88,0,0,1,309.23,232.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34,232.8l-1.52-1.15c-.3-.23-.3-.89,0-1.47s.8-.86,1.11-.63l.41.31.42-.8c.3-.58.8-.86,1.1-.63s.31.89,0,1.47Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,240.15l-4.57,2.64c-.2.12-.37,0-.37-.27a.86.86,0,0,1,.37-.69l4.57-2.65c.2-.11.36,0,.36.28A.88.88,0,0,1,300,240.15Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,237.45l-3.1,1.79c-.2.11-.37,0-.37-.27a.86.86,0,0,1,.37-.69l3.1-1.8c.2-.11.36,0,.36.28A.88.88,0,0,1,304.72,237.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,232h0c-.84.48-1.52,0-1.52-1.15V120.65a3.62,3.62,0,0,1,1.52-2.9h0c.84-.49,1.52,0,1.52,1.15V229.1A3.66,3.66,0,0,1,321.25,232Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,140.75h0c-.38.22-.7,0-.7-.53v-20a1.69,1.69,0,0,1,.7-1.34h0c.39-.23.71,0,.71.53v20A1.67,1.67,0,0,1,321.25,140.75Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Awning--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--awning--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.22 154.76 291.61 44.84 335.15 72.97 300.75 92.82 297.7 94.59 144.76 182.89 101.22 154.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.23 154.76 144.76 182.89 160.63 173.73 117.09 145.6 101.23 154.76",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.96 136.44 176.5 164.57 192.36 155.41 148.82 127.28 132.96 136.44",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.69 118.12 208.23 146.25 224.09 137.09 180.55 108.96 164.69 118.12",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.42 99.8 239.96 127.93 255.82 118.77 212.28 90.64 196.42 99.8",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.15 81.48 271.69 109.61 287.55 100.45 244.01 72.32 228.15 81.48",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.88 63.16 303.42 91.29 319.28 82.13 275.74 54 259.88 63.16",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.62 44.84 335.16 72.97 351.02 63.8 307.48 35.67 291.62 44.84",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76,182.89c0,5.06,3.56,7.11,7.94,4.58a17.53,17.53,0,0,0,7.93-13.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,164.57c0,5.06,3.55,7.11,7.93,4.58a17.53,17.53,0,0,0,7.93-13.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,146.25c0,5.06,3.55,7.11,7.93,4.58a17.53,17.53,0,0,0,7.93-13.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,127.93c0,5,3.55,7.11,7.93,4.58s7.94-8.69,7.94-13.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.69,109.61c0,5,3.55,7.1,7.94,4.58a17.55,17.55,0,0,0,7.93-13.75Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.42,91.28c0,5.06,3.56,7.11,7.94,4.58s7.93-8.68,7.93-13.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.16,73.1c0,5.06,3.55,7.11,7.93,4.58A17.53,17.53,0,0,0,351,63.94Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.76,182.89c0,5.06,3.56,7.11,7.94,4.58a17.53,17.53,0,0,0,7.93-13.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5,164.57c0,5.06,3.55,7.11,7.93,4.58a17.53,17.53,0,0,0,7.93-13.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.23,146.25c0,5.06,3.55,7.11,7.93,4.58a17.53,17.53,0,0,0,7.93-13.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240,127.93c0,5,3.55,7.11,7.93,4.58s7.94-8.69,7.94-13.74Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.69,109.61c0,5,3.55,7.1,7.94,4.58a17.55,17.55,0,0,0,7.93-13.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.42,91.28c0,5.06,3.56,7.11,7.94,4.58s7.93-8.68,7.93-13.74Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16,73.1c0,5.06,3.55,7.11,7.93,4.58A17.53,17.53,0,0,0,351,63.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.63,173.73c0,5.06,3.55,7.11,7.93,4.58s7.94-8.68,7.94-13.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36,155.41c0,5.06,3.55,7.11,7.93,4.58a17.52,17.52,0,0,0,7.94-13.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09,137.09c0,5.06,3.56,7.11,7.94,4.58A17.55,17.55,0,0,0,240,127.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.83,118.77c0,5,3.55,7.11,7.93,4.58a17.55,17.55,0,0,0,7.93-13.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.56,100.44c0,5.06,3.55,7.11,7.93,4.58s7.93-8.68,7.93-13.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.29,82.12c0,5.06,3.55,7.11,7.93,4.58S335.16,78,335.16,73Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.29,209.12l.12-.24h0C215.37,209,215.33,209,215.29,209.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,156.33a.53.53,0,0,0-.51-.41.87.87,0,0,0-.46.14l-90.18,52.06a2.11,2.11,0,0,0-.72.76l-5.65-3.23a2,2,0,0,1,.69-.73l90.18-52.06a2.29,2.29,0,0,1,2,0l3.63,2A2.14,2.14,0,0,1,307.28,156.33Z",
    style: {
      fill: "#37474f",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.13,378.24a2.35,2.35,0,0,1-2,0l-3.63-2.05a2.19,2.19,0,0,1-1-1.74V206.69a2.08,2.08,0,0,1,.33-1l5.66,3.23a2,2,0,0,0-.3,1V377.65C215.12,378.24,215.54,378.58,216.13,378.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.76,155.92a.86.86,0,0,0-.45.14l-90.18,52.06a2.25,2.25,0,0,0-1,1.76V377.65c0,.46.23.72.56.72a.91.91,0,0,0,.45-.13l90.18-52.07a2.24,2.24,0,0,0,1-1.76V156.65c0-.46-.23-.73-.57-.73Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Info--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296,291.69a.64.64,0,0,0-.37-.14,1.74,1.74,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.17-.06.22.22,0,0,1-.06-.18.59.59,0,0,1,0-.23.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.2-.14a.76.76,0,0,1,.23-.09.37.37,0,0,1,.16,0,.14.14,0,0,1,.1.06l.06.05a.2.2,0,0,0,.09.05.24.24,0,0,0,.12,0l.71-.41a.17.17,0,0,0,.08-.1.4.4,0,0,0,0-.15,1,1,0,0,0-.08-.39,1.07,1.07,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.2.2,0,0,0-.05-.14.07.07,0,0,0-.1,0l-.71.41a.25.25,0,0,0-.1.12.39.39,0,0,0,0,.18v.62a4.23,4.23,0,0,0-.44.51,3.68,3.68,0,0,0-.32.58,2.72,2.72,0,0,0-.2.61,2.61,2.61,0,0,0-.08.6,1.5,1.5,0,0,0,.26,1,.79.79,0,0,0,.82.14l.51-.13a2.45,2.45,0,0,1,.36-.07.31.31,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.45.45,0,0,1-.18,0l-.12-.09a.45.45,0,0,0-.07-.07s0,0-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.77.77,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.23.23,0,0,0,.1-.13.41.41,0,0,0,.05-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.17,3.17,0,0,0,.08-.69,2.31,2.31,0,0,0-.07-.64A.8.8,0,0,0,296,291.69Zm-4.19,2.42a.67.67,0,0,0-.37-.14,1.74,1.74,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.17-.06.22.22,0,0,1-.06-.18.59.59,0,0,1,0-.23.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.19-.14a.92.92,0,0,1,.24-.09.37.37,0,0,1,.16,0,.14.14,0,0,1,.1.06l.06.05a.2.2,0,0,0,.09,0,.24.24,0,0,0,.12,0l.71-.41s.05-.05.08-.1a.4.4,0,0,0,0-.15,1,1,0,0,0-.08-.39,1,1,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.2.2,0,0,0-.05-.14.08.08,0,0,0-.1,0l-.71.4a.34.34,0,0,0-.1.13.39.39,0,0,0,0,.18v.62a3.58,3.58,0,0,0-.44.51,3.68,3.68,0,0,0-.32.58,3.39,3.39,0,0,0-.21.61,3.26,3.26,0,0,0-.07.6,1.5,1.5,0,0,0,.26,1,.77.77,0,0,0,.81.14l.52-.13a2.45,2.45,0,0,1,.36-.07.34.34,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.5.5,0,0,1-.19,0l-.11-.09a.45.45,0,0,0-.07-.07s0,0-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.87.87,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.28.28,0,0,0,.1-.13.41.41,0,0,0,.05-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.25,3.25,0,0,0,.08-.69,2.31,2.31,0,0,0-.07-.64A.8.8,0,0,0,291.79,294.11Zm8.6-4.46a.78.78,0,0,0-.22-.38.64.64,0,0,0-.37-.14,2.13,2.13,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.23-.23.6.6,0,0,1,0-.24.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.19-.13a.72.72,0,0,1,.24-.1.37.37,0,0,1,.16,0,.19.19,0,0,1,.1.06l.06.05a.14.14,0,0,0,.09.05.24.24,0,0,0,.12,0l.71-.41a.17.17,0,0,0,.08-.1.37.37,0,0,0,0-.15,1,1,0,0,0-.08-.39,1.07,1.07,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.16.16,0,0,0,0-.13.07.07,0,0,0-.1,0l-.71.41a.25.25,0,0,0-.1.12.41.41,0,0,0,0,.19v.61a3.5,3.5,0,0,0-.44.51,3.79,3.79,0,0,0-.53,1.19,3.26,3.26,0,0,0-.07.61,1.49,1.49,0,0,0,.26,1,.75.75,0,0,0,.81.14c.2,0,.38-.09.52-.13a2.45,2.45,0,0,1,.36-.07.4.4,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.5.5,0,0,1-.19,0l-.11-.09a.45.45,0,0,0-.07-.07l-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.77.77,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.2.2,0,0,0,.1-.13.41.41,0,0,0,0-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.17,3.17,0,0,0,.08-.69A2.19,2.19,0,0,0,300.39,289.65Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,291.69a.64.64,0,0,0-.37-.14,1.74,1.74,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.17-.06.22.22,0,0,1-.06-.18.59.59,0,0,1,0-.23.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.2-.14a.76.76,0,0,1,.23-.09.37.37,0,0,1,.16,0,.14.14,0,0,1,.1.06l.06.05a.2.2,0,0,0,.09.05.24.24,0,0,0,.12,0l.71-.41a.17.17,0,0,0,.08-.1.4.4,0,0,0,0-.15,1,1,0,0,0-.08-.39,1.07,1.07,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.2.2,0,0,0-.05-.14.07.07,0,0,0-.1,0l-.71.41a.25.25,0,0,0-.1.12.39.39,0,0,0,0,.18v.62a4.23,4.23,0,0,0-.44.51,3.68,3.68,0,0,0-.32.58,2.72,2.72,0,0,0-.2.61,2.61,2.61,0,0,0-.08.6,1.5,1.5,0,0,0,.26,1,.79.79,0,0,0,.82.14l.51-.13a2.45,2.45,0,0,1,.36-.07.31.31,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.45.45,0,0,1-.18,0l-.12-.09a.45.45,0,0,0-.07-.07s0,0-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.77.77,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.23.23,0,0,0,.1-.13.41.41,0,0,0,.05-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.17,3.17,0,0,0,.08-.69,2.31,2.31,0,0,0-.07-.64A.8.8,0,0,0,296,291.69Zm-4.19,2.42a.67.67,0,0,0-.37-.14,1.74,1.74,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.17-.06.22.22,0,0,1-.06-.18.59.59,0,0,1,0-.23.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.19-.14a.92.92,0,0,1,.24-.09.37.37,0,0,1,.16,0,.14.14,0,0,1,.1.06l.06.05a.2.2,0,0,0,.09,0,.24.24,0,0,0,.12,0l.71-.41s.05-.05.08-.1a.4.4,0,0,0,0-.15,1,1,0,0,0-.08-.39,1,1,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.2.2,0,0,0-.05-.14.08.08,0,0,0-.1,0l-.71.4a.34.34,0,0,0-.1.13.39.39,0,0,0,0,.18v.62a3.58,3.58,0,0,0-.44.51,3.68,3.68,0,0,0-.32.58,3.39,3.39,0,0,0-.21.61,3.26,3.26,0,0,0-.07.6,1.5,1.5,0,0,0,.26,1,.77.77,0,0,0,.81.14l.52-.13a2.45,2.45,0,0,1,.36-.07.34.34,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.5.5,0,0,1-.19,0l-.11-.09a.45.45,0,0,0-.07-.07s0,0-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.87.87,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.28.28,0,0,0,.1-.13.41.41,0,0,0,.05-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.25,3.25,0,0,0,.08-.69,2.31,2.31,0,0,0-.07-.64A.8.8,0,0,0,291.79,294.11Zm8.6-4.46a.78.78,0,0,0-.22-.38.64.64,0,0,0-.37-.14,2.13,2.13,0,0,0-.52.07l-.5.13a1.57,1.57,0,0,1-.32.05.21.21,0,0,1-.23-.23.6.6,0,0,1,0-.24.82.82,0,0,1,.12-.2.87.87,0,0,1,.17-.16l.19-.13a.72.72,0,0,1,.24-.1.37.37,0,0,1,.16,0,.19.19,0,0,1,.1.06l.06.05a.14.14,0,0,0,.09.05.24.24,0,0,0,.12,0l.71-.41a.17.17,0,0,0,.08-.1.37.37,0,0,0,0-.15,1,1,0,0,0-.08-.39,1.07,1.07,0,0,0-.22-.32.88.88,0,0,0-.34-.19.92.92,0,0,0-.44,0v-.62a.16.16,0,0,0,0-.13.07.07,0,0,0-.1,0l-.71.41a.25.25,0,0,0-.1.12.41.41,0,0,0,0,.19v.61a3.5,3.5,0,0,0-.44.51,3.79,3.79,0,0,0-.53,1.19,3.26,3.26,0,0,0-.07.61,1.49,1.49,0,0,0,.26,1,.75.75,0,0,0,.81.14c.2,0,.38-.09.52-.13a2.45,2.45,0,0,1,.36-.07.4.4,0,0,1,.21,0,.18.18,0,0,1,.07.17.65.65,0,0,1-.19.46,2.34,2.34,0,0,1-.48.37.83.83,0,0,1-.27.1.5.5,0,0,1-.19,0l-.11-.09a.45.45,0,0,0-.07-.07l-.08,0a.24.24,0,0,0-.12,0l-.71.41a.21.21,0,0,0-.08.1.4.4,0,0,0,0,.15,1.34,1.34,0,0,0,.08.46.93.93,0,0,0,.23.34.77.77,0,0,0,.36.18,1.07,1.07,0,0,0,.47,0v.62a.17.17,0,0,0,0,.13.08.08,0,0,0,.1,0l.71-.41a.2.2,0,0,0,.1-.13.41.41,0,0,0,0-.18v-.59a3.25,3.25,0,0,0,.48-.5,2.83,2.83,0,0,0,.38-.59,3.09,3.09,0,0,0,.25-.66,3.17,3.17,0,0,0,.08-.69A2.19,2.19,0,0,0,300.39,289.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.08,319.32c0,.8.65,1.06,1.46.6l51.74-29.87a3,3,0,0,0,1.45-2.28c0-.79-.65-1.06-1.45-.6l-51.74,29.88A3,3,0,0,0,222.08,319.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,324.93c0,.79.65,1.06,1.46.6l13.66-7.89a3,3,0,0,0,1.46-2.28c0-.79-.65-1.06-1.46-.59l-13.66,7.88A3,3,0,0,0,222.08,324.93Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.34,332.49l-1,.37a.11.11,0,0,1-.15-.05l-.43-.92c-.07-.15-.27,0-.33.19L223,333.5a.42.42,0,0,1-.14.22l-1,.75c-.15.11-.21.4-.1.48l.7.51a.21.21,0,0,1,0,.19l-.16,1.38c0,.22.13.28.27.1l.87-1.1a.2.2,0,0,1,.17-.1l.87.1c.13,0,.29-.23.27-.42l-.17-1.19a.4.4,0,0,1,.06-.25l.7-1.31C225.56,332.65,225.5,332.43,225.34,332.49Zm6.13-3.51-1,.38a.11.11,0,0,1-.14-.06l-.43-.92c-.07-.15-.27,0-.34.19l-.43,1.42a.49.49,0,0,1-.14.22l-1,.75c-.16.12-.22.4-.11.48l.7.51a.19.19,0,0,1,.06.19l-.17,1.38c0,.22.14.28.28.11l.86-1.11c.06-.07.12-.11.18-.1l.86.11c.14,0,.3-.23.27-.42l-.16-1.19a.5.5,0,0,1,.05-.26l.7-1.31C231.68,329.14,231.62,328.92,231.47,329Zm6.12-3.5-1,.37a.11.11,0,0,1-.15-.06l-.43-.92c-.07-.14-.27,0-.34.2l-.43,1.42a.49.49,0,0,1-.14.22l-1,.74c-.15.12-.21.41-.1.49l.7.5a.23.23,0,0,1,0,.19l-.16,1.38c0,.22.13.29.27.11l.87-1.11a.22.22,0,0,1,.17-.1l.87.11c.13,0,.29-.23.27-.42l-.17-1.19a.4.4,0,0,1,.06-.25l.7-1.32C237.81,325.63,237.75,325.42,237.59,325.48Zm6.23-3.14c.11-.21.05-.43-.1-.37l-1,.37a.1.1,0,0,1-.14,0l-.43-.92c-.07-.15-.27,0-.34.19l-.43,1.42a.49.49,0,0,1-.14.22l-1,.74c-.16.12-.22.41-.11.49l.7.51a.19.19,0,0,1,.06.19l-.17,1.38c0,.22.14.28.27.1l.87-1.1c.06-.07.12-.11.18-.1l.86.1c.14,0,.3-.23.27-.42l-.16-1.19a.47.47,0,0,1,.05-.25Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,332.49l-1,.37a.11.11,0,0,1-.15-.05l-.43-.92c-.07-.15-.27,0-.33.19L223,333.5a.42.42,0,0,1-.14.22l-1,.75c-.15.11-.21.4-.1.48l.7.51a.21.21,0,0,1,0,.19l-.16,1.38c0,.22.13.28.27.1l.87-1.1a.2.2,0,0,1,.17-.1l.87.1c.13,0,.29-.23.27-.42l-.17-1.19a.4.4,0,0,1,.06-.25l.7-1.31C225.56,332.65,225.5,332.43,225.34,332.49Zm6.13-3.51-1,.38a.11.11,0,0,1-.14-.06l-.43-.92c-.07-.15-.27,0-.34.19l-.43,1.42a.49.49,0,0,1-.14.22l-1,.75c-.16.12-.22.4-.11.48l.7.51a.19.19,0,0,1,.06.19l-.17,1.38c0,.22.14.28.28.11l.86-1.11c.06-.07.12-.11.18-.1l.86.11c.14,0,.3-.23.27-.42l-.16-1.19a.5.5,0,0,1,.05-.26l.7-1.31C231.68,329.14,231.62,328.92,231.47,329Zm6.12-3.5-1,.37a.11.11,0,0,1-.15-.06l-.43-.92c-.07-.14-.27,0-.34.2l-.43,1.42a.49.49,0,0,1-.14.22l-1,.74c-.15.12-.21.41-.1.49l.7.5a.23.23,0,0,1,0,.19l-.16,1.38c0,.22.13.29.27.11l.87-1.11a.22.22,0,0,1,.17-.1l.87.11c.13,0,.29-.23.27-.42l-.17-1.19a.4.4,0,0,1,.06-.25l.7-1.32C237.81,325.63,237.75,325.42,237.59,325.48Zm6.23-3.14c.11-.21.05-.43-.1-.37l-1,.37a.1.1,0,0,1-.14,0l-.43-.92c-.07-.15-.27,0-.34.19l-.43,1.42a.49.49,0,0,1-.14.22l-1,.74c-.16.12-.22.41-.11.49l.7.51a.19.19,0,0,1,.06.19l-.17,1.38c0,.22.14.28.27.1l.87-1.1c.06-.07.12-.11.18-.1l.86.1c.14,0,.3-.23.27-.42l-.16-1.19a.47.47,0,0,1,.05-.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,317.86l.43.92a.1.1,0,0,0,.14.05l1-.37c.16-.06.22.16.11.37l-.7,1.31a.43.43,0,0,0-.06.26l.17,1.19c0,.19-.14.43-.27.42l-.87-.11a.2.2,0,0,0-.17.1l-.87,1.11c-.14.17-.3.11-.27-.11l.16-1.38a.21.21,0,0,0,0-.19l-.7-.51c-.11-.08,0-.36.1-.48l1-.75a.49.49,0,0,0,.14-.22l.43-1.42C248,317.83,248.23,317.71,248.3,317.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.28,281l-2.76-2.09c-.55-.42-.55-1.61,0-2.67s1.45-1.58,2-1.16l.75.57.76-1.45c.56-1.05,1.45-1.57,2-1.15s.55,1.61,0,2.67Z",
    style: {
      fill: "#278AFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.26,313.33c-1.12-.62-2.66-.53-4.36.43l-42.94,24a13.27,13.27,0,0,0-6.21,10.44c0,1.93.7,3.28,1.83,3.9l3.11,1.75c1.12.62,2.67.53,4.37-.43l42.94-24A13.24,13.24,0,0,0,292.2,319c0-1.94-.7-3.29-1.84-3.91Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.26,313.33c-1.12-.62-2.66-.53-4.36.43l-42.94,24a13.27,13.27,0,0,0-6.21,10.44c0,1.93.7,3.28,1.83,3.9l3.11,1.75c1.12.62,2.67.53,4.37-.43l42.94-24A13.24,13.24,0,0,0,292.2,319c0-1.94-.7-3.29-1.84-3.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,353.82l-3-1.69c-1.13-.62-1.83-2-1.83-3.89a13.24,13.24,0,0,1,3.66-8.4l3.1,1.74a13.2,13.2,0,0,0-3.65,8.39A4.28,4.28,0,0,0,238.58,353.82Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.58,353.82l-3-1.69c-1.13-.62-1.83-2-1.83-3.89a13.24,13.24,0,0,1,3.66-8.4l3.1,1.74a13.2,13.2,0,0,0-3.65,8.39A4.28,4.28,0,0,0,238.58,353.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,315.5l-42.94,24a13.28,13.28,0,0,0-6.2,10.44c0,3.85,2.78,5.41,6.2,3.48l42.94-24A13.24,13.24,0,0,0,292.2,319C292.2,315.13,289.43,313.58,286,315.5Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,347.67v1.78a.59.59,0,0,1-.05.22.45.45,0,0,1-.14.16l-.56.32a.12.12,0,0,1-.14,0A.18.18,0,0,1,243,350v-1.78l-1.31.76a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.64a.43.43,0,0,1,.06-.22.32.32,0,0,1,.14-.16l1.31-.76v-1.77a.49.49,0,0,1,.06-.22.32.32,0,0,1,.14-.16l.56-.32a.12.12,0,0,1,.14,0,.21.21,0,0,1,.05.15v1.77l1.31-.76a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.16v.64a.49.49,0,0,1-.06.22.45.45,0,0,1-.14.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,339.59c.07,0,.13-.06.17,0a.36.36,0,0,1,.11.19l1.79,5.14a.13.13,0,0,1,0,.06.46.46,0,0,1-.06.22.38.38,0,0,1-.14.16l-.53.31c-.09.05-.16.06-.2,0a.21.21,0,0,1-.08-.11l-.32-.91L248.64,346l-.32,1.27a.8.8,0,0,1-.08.21.51.51,0,0,1-.21.2l-.52.3c-.06,0-.11,0-.14,0a.16.16,0,0,1-.06-.15v-.07l1.8-7.21a1.41,1.41,0,0,1,.1-.31.47.47,0,0,1,.18-.19Zm.4,4.06-.81-2.33-.8,3.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3,338.88a1.56,1.56,0,0,1,.41-.18.88.88,0,0,1,.31,0,.6.6,0,0,1,.24.05l.15.1v-2.08a.49.49,0,0,1,.06-.22.44.44,0,0,1,.14-.16l.55-.32a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v6.42a.42.42,0,0,1-.06.21.32.32,0,0,1-.14.16l-.55.33a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.23c0,.08-.09.18-.15.28a3.33,3.33,0,0,1-.24.32,2.38,2.38,0,0,1-.31.33,2.55,2.55,0,0,1-.41.3,1.2,1.2,0,0,1-.66.19.79.79,0,0,1-.51-.22,1.31,1.31,0,0,1-.33-.54,2.66,2.66,0,0,1-.13-.79,3.22,3.22,0,0,1,0-.33c0-.14,0-.25,0-.35a4.43,4.43,0,0,1,.13-.94,4.65,4.65,0,0,1,.33-.93,3.89,3.89,0,0,1,.51-.8A2.51,2.51,0,0,1,254.3,338.88Zm-.68,2.76a2.44,2.44,0,0,0,0,.54c0,.41.13.66.29.75a.63.63,0,0,0,.61-.07,1.71,1.71,0,0,0,.61-.64,2.29,2.29,0,0,0,.28-1c0-.1,0-.23,0-.38s0-.27,0-.36a.79.79,0,0,0-.28-.64.59.59,0,0,0-.61.05,1.76,1.76,0,0,0-.61.63A2.56,2.56,0,0,0,253.62,341.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84,336.26a1.56,1.56,0,0,1,.41-.18.88.88,0,0,1,.31,0,.52.52,0,0,1,.23.05l.16.1v-2.08a.49.49,0,0,1,.06-.22.44.44,0,0,1,.14-.16l.55-.32a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15V340a.43.43,0,0,1-.06.22.32.32,0,0,1-.14.16l-.55.33a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.23a3.08,3.08,0,0,1-.16.28,2.13,2.13,0,0,1-.23.32,3.13,3.13,0,0,1-.31.33,2.55,2.55,0,0,1-.41.3,1.2,1.2,0,0,1-.66.19.79.79,0,0,1-.51-.22,1.31,1.31,0,0,1-.33-.54,2.38,2.38,0,0,1-.13-.79,3.33,3.33,0,0,1,0-.34c0-.12,0-.24,0-.34a3.87,3.87,0,0,1,.13-.94,4.65,4.65,0,0,1,.33-.93,3.89,3.89,0,0,1,.51-.8A2.51,2.51,0,0,1,258.84,336.26Zm-.68,2.76a2.53,2.53,0,0,0,0,.55c0,.4.13.65.29.74a.63.63,0,0,0,.61-.07,1.62,1.62,0,0,0,.6-.64,2.2,2.2,0,0,0,.29-1c0-.1,0-.23,0-.38s0-.27,0-.36a.76.76,0,0,0-.29-.64.58.58,0,0,0-.6.05,1.76,1.76,0,0,0-.61.63A2.6,2.6,0,0,0,258.16,339Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72,336.21a.54.54,0,0,0,.12.41c.08.07.23.05.45-.08l.45-.26a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.65a.49.49,0,0,1-.06.22.56.56,0,0,1-.14.16l-.54.31c-.46.26-.82.32-1.06.17s-.37-.54-.37-1.15v-2.11l-.49.28a.14.14,0,0,1-.14,0s-.05-.08-.05-.16v-.64a.44.44,0,0,1,.05-.22.38.38,0,0,1,.14-.16l.49-.28v-1.59a.46.46,0,0,1,.06-.22.31.31,0,0,1,.13-.16l.56-.32a.12.12,0,0,1,.14,0,.16.16,0,0,1,.06.15V333l.95-.55a.12.12,0,0,1,.14,0,.21.21,0,0,1,.05.15v.65a.63.63,0,0,1-.05.22.45.45,0,0,1-.14.16l-.95.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.33,330.78a1.79,1.79,0,0,1,.73-.26,1,1,0,0,1,.57.13,1.06,1.06,0,0,1,.38.47,2,2,0,0,1,.16.74,1.41,1.41,0,0,1,0,.22v.55a1.41,1.41,0,0,1,0,.22,3.86,3.86,0,0,1-.16.94,5.06,5.06,0,0,1-.38.9,4.33,4.33,0,0,1-.57.78,3.2,3.2,0,0,1-.73.59,1.81,1.81,0,0,1-.73.25,1,1,0,0,1-.56-.13,1,1,0,0,1-.38-.46,2.24,2.24,0,0,1-.17-.74,1.86,1.86,0,0,0,0-.22v-.54a2,2,0,0,0,0-.23,4,4,0,0,1,.17-.94,4.42,4.42,0,0,1,.38-.9,4.5,4.5,0,0,1,.56-.79A3.33,3.33,0,0,1,268.33,330.78Zm.89,1.68a1.14,1.14,0,0,0-.1-.44.44.44,0,0,0-.21-.2.42.42,0,0,0-.27,0,1.58,1.58,0,0,0-.31.13,1.91,1.91,0,0,0-.3.22,2.14,2.14,0,0,0-.27.31,2.56,2.56,0,0,0-.21.44,2.41,2.41,0,0,0-.1.57,1.15,1.15,0,0,0,0,.2,2,2,0,0,0,0,.25,1.93,1.93,0,0,0,0,.24,1,1,0,0,0,0,.19,1.14,1.14,0,0,0,.1.44.44.44,0,0,0,.21.2.42.42,0,0,0,.27,0,1.3,1.3,0,0,0,.3-.13,1.6,1.6,0,0,0,.31-.22,2.14,2.14,0,0,0,.27-.31,2.56,2.56,0,0,0,.21-.44,2.41,2.41,0,0,0,.1-.57,1,1,0,0,0,0-.19v-.5A1.09,1.09,0,0,0,269.22,332.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.46,330.11c0,.11,0,.22,0,.35a3,3,0,0,0,0,.34,1.58,1.58,0,0,0,.1.46.51.51,0,0,0,.2.23.5.5,0,0,0,.27,0,.91.91,0,0,0,.3-.11,1.54,1.54,0,0,0,.31-.22,1.51,1.51,0,0,0,.21-.23,1.74,1.74,0,0,0,.15-.26,1.81,1.81,0,0,0,.12-.28l.11-.23a.35.35,0,0,1,.14-.17l.55-.32a.16.16,0,0,1,.15,0,.16.16,0,0,1,.05.16,2.09,2.09,0,0,1-.11.56,3.82,3.82,0,0,1-.32.75,4.22,4.22,0,0,1-.55.77,3.26,3.26,0,0,1-.81.65,1.45,1.45,0,0,1-.72.24.87.87,0,0,1-.56-.17,1.06,1.06,0,0,1-.38-.49,2.43,2.43,0,0,1-.16-.76c0-.11,0-.24,0-.39s0-.28,0-.4a3.71,3.71,0,0,1,.16-1,4.75,4.75,0,0,1,.37-.93,4.31,4.31,0,0,1,.56-.81,3,3,0,0,1,.73-.61,1.86,1.86,0,0,1,.81-.28.94.94,0,0,1,.55.14.79.79,0,0,1,.32.38,1.05,1.05,0,0,1,.11.43.37.37,0,0,1-.05.22.47.47,0,0,1-.15.16l-.55.32c-.06,0-.1,0-.14,0a.57.57,0,0,1-.11-.11.55.55,0,0,0-.12-.14.28.28,0,0,0-.15-.08.38.38,0,0,0-.21,0,1.31,1.31,0,0,0-.31.14,2,2,0,0,0-.3.23,2.48,2.48,0,0,0-.27.35,2.55,2.55,0,0,0-.2.47A3.06,3.06,0,0,0,273.46,330.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.92,327.17a2.73,2.73,0,0,1,.14-.52,3.12,3.12,0,0,1,.3-.61,3.89,3.89,0,0,1,.47-.62,3.4,3.4,0,0,1,.66-.51,1.8,1.8,0,0,1,.67-.25.8.8,0,0,1,.52.08.85.85,0,0,1,.34.45,2.66,2.66,0,0,1,.11.82v2.87a.46.46,0,0,1-.06.22.32.32,0,0,1-.14.16l-.55.32a.12.12,0,0,1-.14,0,.16.16,0,0,1-.06-.15v-.32a2.94,2.94,0,0,1-.45.74,2.5,2.5,0,0,1-.73.63,1.54,1.54,0,0,1-.57.21.61.61,0,0,1-.41-.08.63.63,0,0,1-.26-.33,1.34,1.34,0,0,1-.1-.56,2.36,2.36,0,0,1,.36-1.26,4.18,4.18,0,0,1,1-1.07l1.2-1c0-.27-.07-.42-.2-.45a.62.62,0,0,0-.49.12,1,1,0,0,0-.29.23,2,2,0,0,0-.19.3,1.06,1.06,0,0,1-.13.18.4.4,0,0,1-.12.1l-.68.39a.11.11,0,0,1-.12,0S276.91,327.24,276.92,327.17Zm1.23,2.05a2.12,2.12,0,0,0,.44-.35,1.9,1.9,0,0,0,.32-.44,1.84,1.84,0,0,0,.2-.46,1.48,1.48,0,0,0,.07-.44v-.1l-1,.81a2,2,0,0,0-.43.45.77.77,0,0,0-.13.43q0,.21.15.21A.7.7,0,0,0,278.15,329.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89,323.64a1.62,1.62,0,0,0-.64.63,2.08,2.08,0,0,0-.19,1v2.54a.49.49,0,0,1-.06.22.37.37,0,0,1-.14.16l-.56.32a.1.1,0,0,1-.13,0,.18.18,0,0,1-.06-.15v-4.56a.49.49,0,0,1,.06-.22.32.32,0,0,1,.13-.15l.56-.33a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.23a3.5,3.5,0,0,1,.41-.6,2,2,0,0,1,.56-.45l.33-.19c.06,0,.11,0,.14,0a.18.18,0,0,1,.06.16V323a.46.46,0,0,1-.06.22.32.32,0,0,1-.14.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,324.23a.57.57,0,0,0,.13.42c.08.07.23.05.45-.08l.44-.26a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.65a.49.49,0,0,1-.06.22.34.34,0,0,1-.14.15l-.54.32c-.46.26-.81.32-1.06.17s-.37-.54-.37-1.15v-2.11L284,323a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.64a.46.46,0,0,1,.06-.22.32.32,0,0,1,.14-.16l.48-.28V320a.46.46,0,0,1,.06-.22.38.38,0,0,1,.14-.16l.56-.32a.12.12,0,0,1,.14,0,.22.22,0,0,1,.05.16V321l.95-.55a.12.12,0,0,1,.14,0,.18.18,0,0,1,.06.15v.65a.49.49,0,0,1-.06.22.45.45,0,0,1-.14.16l-.95.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "294.11 266.25 227.71 304.58 227.71 213.04 294.11 174.71 294.11 266.25",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.11 266.25 227.71 304.58 227.71 213.04 294.11 174.71 294.11 266.25",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,260.56l-51.69,29.85V218.73l51.69-29.85Zm-51.06,28.63,50.43-29.11v-70l-50.43,29.11Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.57 271.33 235.18 270.89 250.51 246.14 257.86 249.88 280.11 209.3 286.66 214.19 286.21 215.05 280.09 210.48 257.88 250.99 250.5 247.22 235.57 271.33",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.91,237.14c-3.67,2.12-6.64-.13-6.64-5s3-10.57,6.64-12.69,6.64.14,6.64,5S262.57,235,258.91,237.14Zm0-16.86c-3.32,1.91-6,7.06-6,11.48s2.69,6.45,6,4.54,6-7.06,6-11.48S262.22,218.37,258.91,220.28Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.73 221.38 224.06 237.94 224.06 222.6 252.73 206.05 252.73 221.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,213.87a1.74,1.74,0,0,1,.73-.26.82.82,0,0,1,.85.57,2,2,0,0,1,.13.62c0,.25,0,.53,0,.83s0,.59,0,.87a3.76,3.76,0,0,1-.13.77,3.61,3.61,0,0,1-.32.8,3.67,3.67,0,0,1-.53.73,3,3,0,0,1-.73.59,1.73,1.73,0,0,1-.74.26.81.81,0,0,1-.52-.13.86.86,0,0,1-.32-.42,2.07,2.07,0,0,1-.13-.63c0-.25,0-.53,0-.83s0-.59,0-.87a3.76,3.76,0,0,1,.13-.77,3.61,3.61,0,0,1,.32-.8,4.51,4.51,0,0,1,.52-.74A3.05,3.05,0,0,1,243,213.87Zm4.61-2.29a1.27,1.27,0,0,1,.17-.31.57.57,0,0,1,.24-.22l.69-.4c.09-.05.15-.06.2,0s.08.08.08.18,0,0,0,.08a.76.76,0,0,1,0,.11l-5.68,13.24a2.2,2.2,0,0,1-.16.31.78.78,0,0,1-.25.22l-.69.4a.19.19,0,0,1-.2,0,.19.19,0,0,1-.08-.18.31.31,0,0,1,0-.08.35.35,0,0,1,0-.11Zm-4,5.4a2.28,2.28,0,0,0,0-.3v-.82a2.11,2.11,0,0,0,0-.29.78.78,0,0,0-.15-.43c-.09-.1-.24-.08-.46.05a1.06,1.06,0,0,0-.46.48,2,2,0,0,0-.15.6c0,.07,0,.17,0,.31v.82c0,.13,0,.23,0,.28a.81.81,0,0,0,.15.44c.08.09.24.08.46-.05a1.11,1.11,0,0,0,.46-.48A2.1,2.1,0,0,0,243.64,217Zm4.37-.61a1.67,1.67,0,0,1,.73-.25.86.86,0,0,1,.52.13.91.91,0,0,1,.33.43,2.44,2.44,0,0,1,.13.62c0,.26,0,.54,0,.84s0,.59,0,.86a4.7,4.7,0,0,1-.13.78,3.87,3.87,0,0,1-.33.8,3.61,3.61,0,0,1-.52.73,3.22,3.22,0,0,1-.73.58,2,2,0,0,1-.74.27.79.79,0,0,1-.52-.13.89.89,0,0,1-.32-.43,2,2,0,0,1-.14-.62c0-.26,0-.54,0-.84s0-.59,0-.86a3.81,3.81,0,0,1,.14-.77,3.43,3.43,0,0,1,.32-.8,3.67,3.67,0,0,1,.52-.74A3.14,3.14,0,0,1,248,216.37Zm.61,3.12c0-.07,0-.17,0-.3v-.83c0-.13,0-.23,0-.28a.81.81,0,0,0-.15-.44c-.09-.09-.24-.07-.46.05a1,1,0,0,0-.46.48,1.61,1.61,0,0,0-.15.61,2.11,2.11,0,0,0,0,.3c0,.14,0,.28,0,.42s0,.28,0,.41a1.7,1.7,0,0,0,0,.28.63.63,0,0,0,.15.43c.08.1.23.08.46-.05a1,1,0,0,0,.46-.48A2,2,0,0,0,248.62,219.49Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.6,200.28l-77.21,44.65c-.41.24-.75.82-.75,1.94v66.31a1.61,1.61,0,0,0,.75,1.29l3,1.69a1.66,1.66,0,0,0,1.49,0l77.22-44.65a1.67,1.67,0,0,0,.75-1.29v-67a1.63,1.63,0,0,0-.75-1.28l-3-1.69A1.68,1.68,0,0,0,396.6,200.28Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,200.28l-77.21,44.65c-.41.24-.75.82-.75,1.94v66.31a1.61,1.61,0,0,0,.75,1.29l3,1.69a1.66,1.66,0,0,0,1.49,0l77.22-44.65a1.67,1.67,0,0,0,.75-1.29v-67a1.63,1.63,0,0,0-.75-1.28l-3-1.69A1.68,1.68,0,0,0,396.6,200.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.85,316.15a1.7,1.7,0,0,1-1.49,0l-3-1.69a1.59,1.59,0,0,1-.75-1.29V246.87a2.93,2.93,0,0,1,.26-1.39l4.43,2.54a1.38,1.38,0,0,0-.22.74v67C323.11,316.17,323.41,316.41,323.85,316.15Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.6,265.15c-.47-.28-4-2.29-4.15-2.35a.7.7,0,0,1-.15-1.07l6.34-7.27,4.47,2.56-6.64,7.09A.7.7,0,0,0,316.6,265.15Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.6,265.15c-.47-.28-4-2.29-4.15-2.35a.7.7,0,0,1-.15-1.07l6.34-7.27,4.47,2.56-6.64,7.09A.7.7,0,0,0,316.6,265.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,202.81l-77.22,44.66a1.63,1.63,0,0,0-.74,1.29V257l-6.64,7.09a.67.67,0,0,0,.43,1.14l6.21-.45h0v50.92c0,.48.33.67.74.43l77.22-44.65a1.67,1.67,0,0,0,.75-1.29v-67C401.82,202.77,401.48,202.57,401.07,202.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,203.68v66.53a.92.92,0,0,1-.38.64l-76.83,44.43V264l-.81.06-5.9.43,6.51-7,.2-.21v-8.56a.94.94,0,0,1,.37-.65l76.84-44.43m.33-1a.65.65,0,0,0-.33.1l-77.22,44.66a1.63,1.63,0,0,0-.74,1.29V257l-6.64,7.09a.67.67,0,0,0,.43,1.14l6.21-.45h0v50.92c0,.34.17.54.41.54a.68.68,0,0,0,.33-.11l77.22-44.65a1.67,1.67,0,0,0,.75-1.29v-67c0-.34-.17-.53-.42-.53Z",
    style: {
      fill: "#278AFF"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--credit-card--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M328.52,298.05a.17.17,0,0,0,0,.07c0,1.55,1.14,2.17,2.51,1.39L389,266a5.58,5.58,0,0,0,2.52-4.36V217.5c0-1.59-1.11-2.24-2.46-1.48l-.06,0L331,249.5a5.55,5.55,0,0,0-2.51,4.36v44.19Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.91,252.23h0l-1,.59a2.2,2.2,0,0,0-.32.21l-.28.22-.07.06-.26.25-.14.16a3.36,3.36,0,0,0-.34.41l-.11.16a2.14,2.14,0,0,0-.13.19l0,0-.07.14,0,0-.17.29-.14.31-.1.23c0,.09-.06.19-.1.28s-.09.32-.13.47a2.74,2.74,0,0,0,0,.28,1.23,1.23,0,0,0,0,.19.88.88,0,0,0,0,.16c0,.09,0,.18,0,.27v44.18s.75,1.62.75,1.64l-2.34-1.36a1.83,1.83,0,0,1-.85-1.69V255.79c0-.11,0-.2,0-.31s0-.21,0-.31.07-.37.12-.56.05-.15.08-.23a4.52,4.52,0,0,1,.18-.47,5.12,5.12,0,0,1,.31-.62,2.39,2.39,0,0,0,.13-.21.91.91,0,0,1,.11-.16.83.83,0,0,1,.13-.18,5.52,5.52,0,0,1,.43-.53l.2-.19,0-.05.2-.17.22-.17a2,2,0,0,1,.31-.2l1.05-.6Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,252.23h0l-1,.59a2.2,2.2,0,0,0-.32.21l-.28.22-.07.06-.26.25-.14.16a3.36,3.36,0,0,0-.34.41l-.11.16-.13.19,0,0-.07.14,0,0-.17.29-.14.31-.1.23c0,.09-.06.19-.1.28s-.09.32-.13.47a2.74,2.74,0,0,0,0,.28,1.23,1.23,0,0,0,0,.19.88.88,0,0,0,0,.16c0,.09,0,.18,0,.27v44.18s.75,1.62.75,1.64l-2.34-1.36a1.83,1.83,0,0,1-.85-1.69V255.79c0-.11,0-.2,0-.31s0-.21,0-.31.07-.37.12-.56.05-.15.08-.23a4.52,4.52,0,0,1,.18-.47,5.12,5.12,0,0,1,.31-.62,2.39,2.39,0,0,0,.13-.21.91.91,0,0,1,.11-.16.83.83,0,0,1,.13-.18,5.52,5.52,0,0,1,.43-.53l.2-.19,0-.05.2-.17.22-.17a2,2,0,0,1,.31-.2l1.05-.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,219.2s-1.76.17-1.78.18l-56.91,32.85h0l-1,.59a5.51,5.51,0,0,0-2.1,2.49l-2.44-1.41a5.29,5.29,0,0,1,2.08-2.48l1.05-.6L392.37,218a1.79,1.79,0,0,1,1.66-.23C394.62,218,396.6,219.2,396.6,219.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,252.23h0l-1,.59a5.51,5.51,0,0,0-2.1,2.49l-2.44-1.41a5.29,5.29,0,0,1,2.08-2.48l1.05-.6Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,252.23h0l-1,.59a3.53,3.53,0,0,0-.32.21l-.28.22-.07.06a3,3,0,0,0-.26.25l-.14.16a3.21,3.21,0,0,0-.34.41l-.11.16-.17.24a1.51,1.51,0,0,0-.09.18,2.19,2.19,0,0,0-.17.29c-.06.11-.09.2-.15.31l-2.45-1.4a6.19,6.19,0,0,1,.32-.63,2.39,2.39,0,0,0,.13-.21.91.91,0,0,1,.11-.16.83.83,0,0,1,.13-.18,4.33,4.33,0,0,1,.43-.53l.2-.19,0-.05.2-.17.22-.17a2,2,0,0,1,.31-.2l1.05-.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,301.39a.15.15,0,0,0,0,.06c0,1.55,1.14,2.17,2.51,1.39l57.95-33.46a5.59,5.59,0,0,0,2.52-4.37V220.83c0-1.59-1.1-2.24-2.46-1.48l-.06,0-57.94,33.45a5.54,5.54,0,0,0-2.52,4.36v44.2Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.35,301.39a.15.15,0,0,0,0,.06c0,1.55,1.14,2.17,2.51,1.39l57.95-33.46a5.59,5.59,0,0,0,2.52-4.37V220.83c0-1.59-1.1-2.24-2.46-1.48l-.06,0-57.94,33.45a5.54,5.54,0,0,0-2.52,4.36v44.2Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.36,257.19v10.73l63-36.36V220.83c0-1.59-1.1-2.24-2.46-1.48l-.06,0-57.94,33.45A5.54,5.54,0,0,0,334.36,257.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,252.5V302l-1.5.87c-1.37.78-2.49.16-2.51-1.38a.22.22,0,0,1,0-.08V257.2a5.11,5.11,0,0,1,.74-2.49c0-.1.11-.19.17-.29l.27-.37,0-.07.3-.35a4.35,4.35,0,0,1,1-.8l1-.6h0Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.37 301.97 340.45 300.77 340.45 264.4 338.37 265.6 338.37 301.97",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,281.5l-1,.59a.14.14,0,0,1-.12,0s-.05,0-.05-.09a.3.3,0,0,1,.05-.15.23.23,0,0,1,.12-.12l.34-.2v-1.71c0-.1,0-.16-.1-.19a.29.29,0,0,0-.23,0h0c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.37.37,0,0,1,.05-.15.34.34,0,0,1,.12-.12h0a.55.55,0,0,1,.48-.08.36.36,0,0,1,.21.37v1.71l.34-.2a.18.18,0,0,1,.12,0,.11.11,0,0,1,.05.1.3.3,0,0,1-.05.15A.68.68,0,0,1,345.7,281.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.92,279.18l-.68.4a.61.61,0,0,0-.24.24.51.51,0,0,0-.1.3v.26a.05.05,0,0,0,0,0,0,0,0,0,0,.06,0l1.46-.84a.14.14,0,0,1,.12,0,.11.11,0,0,1,.05.09.3.3,0,0,1-.05.15.23.23,0,0,1-.12.12l-1.71,1c-.05,0-.09,0-.12,0s-.05,0-.05-.09v-.51a1.07,1.07,0,0,1,.2-.6,1.38,1.38,0,0,1,.48-.48l.68-.4a.64.64,0,0,0,.25-.24.51.51,0,0,0,.1-.3V278c0-.1,0-.16-.1-.19a.31.31,0,0,0-.25.05l-.68.39a.78.78,0,0,0-.24.24.56.56,0,0,0-.1.3.3.3,0,0,1,0,.15l-.12.12a.14.14,0,0,1-.12,0s-.05,0-.05-.09a1.07,1.07,0,0,1,.2-.6,1.38,1.38,0,0,1,.48-.48l.68-.4a.57.57,0,0,1,.49-.08.37.37,0,0,1,.2.37v.34a1.16,1.16,0,0,1-.2.6A1.4,1.4,0,0,1,347.92,279.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.35,277.38v.17a1.09,1.09,0,0,1-.21.6,1.38,1.38,0,0,1-.48.48l-.68.4a.56.56,0,0,1-.49.07.34.34,0,0,1-.2-.36.3.3,0,0,1,0-.15.34.34,0,0,1,.12-.12c.05,0,.09,0,.12,0a.08.08,0,0,1,.06.09.17.17,0,0,0,.1.18.25.25,0,0,0,.24,0l.68-.39a.69.69,0,0,0,.24-.24.56.56,0,0,0,.1-.3v-.17c0-.1,0-.16-.1-.19a.28.28,0,0,0-.24,0l-.17.1c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.3.3,0,0,1,.05-.15.34.34,0,0,1,.12-.12l.17-.1a.56.56,0,0,0,.24-.24.51.51,0,0,0,.1-.3v-.17c0-.09,0-.16-.1-.18a.25.25,0,0,0-.24,0l-.68.39a.71.71,0,0,0-.34.54.24.24,0,0,1-.06.15.34.34,0,0,1-.12.12.13.13,0,0,1-.12,0s0,0,0-.09a1.16,1.16,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.4a.55.55,0,0,1,.48-.08.36.36,0,0,1,.21.37v.17a1,1,0,0,1-.07.32,1.29,1.29,0,0,1-.17.33.31.31,0,0,1,.17.13A.49.49,0,0,1,351.35,277.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,276.63a.23.23,0,0,1-.12.12c-.05,0-.09,0-.12,0s-.05,0-.05-.09v-.95a1.28,1.28,0,0,1-.34.29l-.69.4a.55.55,0,0,1-.48.08.37.37,0,0,1-.2-.37v-.86a.37.37,0,0,1,.05-.15.34.34,0,0,1,.12-.12c.05,0,.09,0,.12,0s.05,0,.05.09v.85a.19.19,0,0,0,.1.19.31.31,0,0,0,.24,0l.69-.4a.69.69,0,0,0,.24-.24.51.51,0,0,0,.1-.3v-.85a.3.3,0,0,1,.05-.15.23.23,0,0,1,.12-.12s.09,0,.12,0,.05,0,.05.09v2.39A.23.23,0,0,1,354,276.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.85,272.69a.05.05,0,0,0,0,0,.07.07,0,0,0,.06,0l.94-.54a.54.54,0,0,1,.49-.08.37.37,0,0,1,.2.37v.34a1.16,1.16,0,0,1-.2.6,1.49,1.49,0,0,1-.49.48l-.68.39a.54.54,0,0,1-.49.08c-.13-.05-.19-.18-.19-.37a.26.26,0,0,1,.05-.15.34.34,0,0,1,.12-.12.17.17,0,0,1,.12,0,.11.11,0,0,1,.05.1.17.17,0,0,0,.1.18.25.25,0,0,0,.24,0l.68-.39a.82.82,0,0,0,.25-.24.66.66,0,0,0,.1-.3v-.35a.19.19,0,0,0-.1-.18.3.3,0,0,0-.25,0l-1,.59a.27.27,0,0,1-.25,0,.18.18,0,0,1-.09-.18v-.86a.28.28,0,0,1,0-.15.49.49,0,0,1,.13-.12l1.71-1a.11.11,0,0,1,.12,0s.05,0,.05.09a.37.37,0,0,1-.05.15.4.4,0,0,1-.12.11l-1.46.84-.06.06a.31.31,0,0,0,0,.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.93,271l.68-.39a.54.54,0,0,1,.49-.08.36.36,0,0,1,.2.37v.34a1.16,1.16,0,0,1-.2.6,1.49,1.49,0,0,1-.49.48l-.68.39a.54.54,0,0,1-.49.08.36.36,0,0,1-.2-.37v-1.36a1.16,1.16,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.4a.54.54,0,0,1,.49-.08.37.37,0,0,1,.2.37.3.3,0,0,1-.05.15.68.68,0,0,1-.12.12.14.14,0,0,1-.12,0s-.05,0-.05-.09a.19.19,0,0,0-.1-.19.3.3,0,0,0-.25,0l-.68.4a.64.64,0,0,0-.25.24.6.6,0,0,0-.1.3v.43A1.54,1.54,0,0,1,360.93,271Zm-.35,1.23a.19.19,0,0,0,.1.18.27.27,0,0,0,.25,0l.68-.39a.75.75,0,0,0,.25-.25.59.59,0,0,0,.1-.29v-.35a.19.19,0,0,0-.1-.18.27.27,0,0,0-.25,0l-.68.4a.68.68,0,0,0-.25.23.66.66,0,0,0-.1.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,268.76l-.77,1.9v0s0,0,0,0,0,0,0,0,0,0,0,0l0,0,0,0,0,0,0,0-.13,0s0,0,0-.11a.58.58,0,0,1,.08-.22c.25-.61.48-1.2.7-1.77a.78.78,0,0,0,.05-.18,1,1,0,0,0,0-.15v0c0-.1,0-.16-.1-.19a.31.31,0,0,0-.24,0l-.34.2-.17.1-.69.39a.15.15,0,0,1-.12,0,.11.11,0,0,1,0-.1.37.37,0,0,1,0-.15.34.34,0,0,1,.12-.12l.69-.39.17-.1.34-.2a.55.55,0,0,1,.48-.08.35.35,0,0,1,.2.37,1.38,1.38,0,0,1,0,.26A1.49,1.49,0,0,1,365,268.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,267.9v.17a1.16,1.16,0,0,1-.2.6,1.38,1.38,0,0,1-.48.48l-.69.39a.52.52,0,0,1-.48.08c-.14-.05-.2-.18-.2-.37v-.17a1,1,0,0,1,.06-.32,1.73,1.73,0,0,1,.17-.33.27.27,0,0,1-.17-.13.43.43,0,0,1-.06-.24v-.18a1.07,1.07,0,0,1,.2-.59,1.23,1.23,0,0,1,.48-.48l.69-.4a.52.52,0,0,1,.48-.08.37.37,0,0,1,.2.37v.17a1,1,0,0,1-.06.32,1.73,1.73,0,0,1-.17.33.31.31,0,0,1,.17.13A.49.49,0,0,1,367.77,267.9Zm-.34-1a.19.19,0,0,0-.1-.19.27.27,0,0,0-.24,0l-.69.4a.69.69,0,0,0-.24.24.51.51,0,0,0-.1.3v.17a.17.17,0,0,0,.1.18.24.24,0,0,0,.24,0l.69-.39a.91.91,0,0,0,.24-.24.66.66,0,0,0,.1-.3Zm0,1.19a.19.19,0,0,0-.1-.18.27.27,0,0,0-.24,0l-.69.4a.69.69,0,0,0-.24.24.51.51,0,0,0-.1.29v.18a.17.17,0,0,0,.1.18.24.24,0,0,0,.24,0l.69-.39a.91.91,0,0,0,.24-.24.66.66,0,0,0,.1-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.56,266l-.68.39a.54.54,0,0,1-.49.08.37.37,0,0,1-.2-.37.37.37,0,0,1,.05-.15.68.68,0,0,1,.12-.12.14.14,0,0,1,.12,0s0,.05,0,.1a.19.19,0,0,0,.1.18.3.3,0,0,0,.25,0l.68-.4a.61.61,0,0,0,.24-.24.53.53,0,0,0,.11-.3v-.43a1.54,1.54,0,0,1-.35.29l-.68.4a.56.56,0,0,1-.49.07.35.35,0,0,1-.2-.36v-.35a1.18,1.18,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.39a.54.54,0,0,1,.49-.08.37.37,0,0,1,.2.37v1.37a1.22,1.22,0,0,1-.2.6A1.49,1.49,0,0,1,372.56,266Zm.35-2.26a.19.19,0,0,0-.1-.18.3.3,0,0,0-.25,0l-.68.4a.64.64,0,0,0-.25.24.6.6,0,0,0-.1.3v.34a.19.19,0,0,0,.1.18.27.27,0,0,0,.25,0l.68-.39a.78.78,0,0,0,.24-.24.58.58,0,0,0,.11-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,264.51l-1,.59a.14.14,0,0,1-.12,0s-.05,0-.05-.09a.23.23,0,0,1,.05-.15.23.23,0,0,1,.12-.12l.34-.2v-1.71c0-.1,0-.16-.1-.19a.32.32,0,0,0-.24,0h0c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.26.26,0,0,1,.05-.15.34.34,0,0,1,.12-.12h0a.55.55,0,0,1,.48-.08.35.35,0,0,1,.2.37v1.71l.34-.2a.21.21,0,0,1,.13,0,.11.11,0,0,1,.05.1.3.3,0,0,1-.05.15A.49.49,0,0,1,375.12,264.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.35,263.22l-.68.4a.53.53,0,0,1-.49.07.34.34,0,0,1-.2-.36V262a1.16,1.16,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.4a.57.57,0,0,1,.49-.08.37.37,0,0,1,.2.37v1.37a1.16,1.16,0,0,1-.2.6A1.49,1.49,0,0,1,377.35,263.22Zm-.68,0,.68-.39a.52.52,0,0,0,.16-.14l-1.18-.95v1.34a.18.18,0,0,0,.09.18A.27.27,0,0,0,376.67,263.27Zm.68-2.44-.68.39a.7.7,0,0,0-.17.14l1.19.95V261c0-.09,0-.16-.1-.18A.25.25,0,0,0,377.35,260.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.92,261.74l-1,.59c-.05,0-.09,0-.12,0s0,0,0-.09a.24.24,0,0,1,0-.15.34.34,0,0,1,.12-.12l.34-.2v-1.71a.17.17,0,0,0-.1-.18.25.25,0,0,0-.24,0h0a.14.14,0,0,1-.12,0,.09.09,0,0,1,0-.09.23.23,0,0,1,0-.15.23.23,0,0,1,.12-.12h0a.52.52,0,0,1,.48-.08c.14.05.2.18.2.37v1.71l.35-.2a.11.11,0,0,1,.12,0,.09.09,0,0,1,0,.09.3.3,0,0,1,0,.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,259l-1,.6a.19.19,0,0,1-.12,0,.11.11,0,0,1-.05-.09.3.3,0,0,1,.05-.15.23.23,0,0,1,.12-.12l.34-.2v-1.71c0-.1,0-.16-.1-.19a.32.32,0,0,0-.24,0h0c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.23.23,0,0,1,.05-.15.34.34,0,0,1,.12-.12h0a.52.52,0,0,1,.48-.08.35.35,0,0,1,.2.37v1.71l.35-.2a.13.13,0,0,1,.12,0,.11.11,0,0,1,.05.1.37.37,0,0,1-.05.15A.4.4,0,0,1,384.71,259Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.93,256.66l-.68.4a.56.56,0,0,0-.24.24.51.51,0,0,0-.1.3v.25s0,0,0,0a.07.07,0,0,0,.06,0l1.46-.84a.13.13,0,0,1,.12,0,.09.09,0,0,1,.05.09.3.3,0,0,1-.05.15.68.68,0,0,1-.12.12l-1.71,1a.16.16,0,0,1-.13,0s-.05,0-.05-.09v-.51a1.16,1.16,0,0,1,.2-.6,1.32,1.32,0,0,1,.49-.48l.68-.4a.64.64,0,0,0,.25-.24.66.66,0,0,0,.1-.3v-.34a.19.19,0,0,0-.1-.19.3.3,0,0,0-.25,0l-.68.4a.56.56,0,0,0-.24.24.51.51,0,0,0-.1.3.3.3,0,0,1-.05.15l-.12.12a.16.16,0,0,1-.13,0,.09.09,0,0,1-.05-.09,1.16,1.16,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.4a.54.54,0,0,1,.49-.08.37.37,0,0,1,.2.37v.34a1.16,1.16,0,0,1-.2.6A1.4,1.4,0,0,1,386.93,256.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.5,256.21l-1,.59c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.3.3,0,0,1,.05-.15.34.34,0,0,1,.12-.12l.34-.2v-1.71a.17.17,0,0,0-.1-.18.25.25,0,0,0-.23,0h0a.19.19,0,0,1-.12,0,.09.09,0,0,1-.05-.09.23.23,0,0,1,.05-.15.3.3,0,0,1,.12-.13h0A.54.54,0,0,1,389,254c.14,0,.2.17.2.36v1.71l.35-.19a.11.11,0,0,1,.12,0s.05,0,.05.09a.3.3,0,0,1-.05.15A.68.68,0,0,1,389.5,256.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.41,253.67v.17a1.16,1.16,0,0,1-.2.6,1.49,1.49,0,0,1-.49.48l-.68.4a.57.57,0,0,1-.49.08.37.37,0,0,1-.2-.37.3.3,0,0,1,0-.15l.12-.12a.16.16,0,0,1,.13,0,.11.11,0,0,1,.05.09c0,.1,0,.16.1.19a.32.32,0,0,0,.24,0l.68-.4a.56.56,0,0,0,.24-.24.53.53,0,0,0,.11-.3v-.17a.17.17,0,0,0-.11-.18.25.25,0,0,0-.24,0l-.17.09a.15.15,0,0,1-.12,0,.11.11,0,0,1-.05-.1.37.37,0,0,1,.05-.15.34.34,0,0,1,.12-.12l.17-.1a.56.56,0,0,0,.24-.24.53.53,0,0,0,.11-.3v-.17a.18.18,0,0,0-.11-.18.25.25,0,0,0-.24,0l-.68.39a.69.69,0,0,0-.24.24.56.56,0,0,0-.1.3.3.3,0,0,1-.05.15.29.29,0,0,1-.13.12.11.11,0,0,1-.12,0s0,0,0-.09a1.16,1.16,0,0,1,.2-.6,1.49,1.49,0,0,1,.49-.48l.68-.39a.54.54,0,0,1,.49-.08.36.36,0,0,1,.2.37v.17a.81.81,0,0,1-.07.32,1.1,1.1,0,0,1-.17.32.3.3,0,0,1,.17.14A.36.36,0,0,1,392.41,253.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.44,274.25l-1,.6a.14.14,0,0,1-.12,0s0,0,0-.09a.3.3,0,0,1,0-.15.3.3,0,0,1,.12-.13l.35-.2v-1.73c0-.1,0-.16-.1-.19a.27.27,0,0,0-.24,0h0s-.09,0-.12,0,0,0,0-.09a.23.23,0,0,1,0-.15.3.3,0,0,1,.12-.13h0a.57.57,0,0,1,.49-.08.37.37,0,0,1,.21.38v1.73l.34-.2a.16.16,0,0,1,.13,0,.11.11,0,0,1,.05.1.33.33,0,0,1-.05.15A.49.49,0,0,1,370.44,274.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,271.9l-.69.4a.75.75,0,0,0-.25.25.54.54,0,0,0-.1.3v.26a0,0,0,0,0,0,.05s0,0,.06,0l1.48-.85a.11.11,0,0,1,.12,0s0,0,0,.09a.3.3,0,0,1,0,.15.34.34,0,0,1-.12.12l-1.74,1a.21.21,0,0,1-.13,0,.11.11,0,0,1-.05-.1v-.52a1.15,1.15,0,0,1,.21-.61A1.4,1.4,0,0,1,372,272l.69-.4a.75.75,0,0,0,.25-.25.56.56,0,0,0,.1-.3v-.35c0-.1,0-.16-.1-.19a.3.3,0,0,0-.25,0l-.69.41a.64.64,0,0,0-.25.24.56.56,0,0,0-.1.3.37.37,0,0,1-.05.16.34.34,0,0,1-.12.12.21.21,0,0,1-.13,0,.11.11,0,0,1-.05-.1,1.09,1.09,0,0,1,.21-.6,1.35,1.35,0,0,1,.49-.49l.69-.4a.56.56,0,0,1,.5-.08.36.36,0,0,1,.2.37v.35a1.22,1.22,0,0,1-.2.61A1.43,1.43,0,0,1,372.7,271.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.87,269.5l-.7.4a.78.78,0,0,0-.24.24.57.57,0,0,0-.1.31v.26s0,0,0,0a0,0,0,0,0,.06,0l1.48-.85a.14.14,0,0,1,.12,0,.1.1,0,0,1,.06.09.29.29,0,0,1-.06.16.34.34,0,0,1-.12.12l-1.74,1a.11.11,0,0,1-.12,0s0,0,0-.09v-.52a1.19,1.19,0,0,1,.2-.61,1.43,1.43,0,0,1,.49-.49l.7-.4a.81.81,0,0,0,.25-.24.66.66,0,0,0,.1-.31v-.35a.19.19,0,0,0-.1-.18.27.27,0,0,0-.25,0l-.7.4a.91.91,0,0,0-.24.24.57.57,0,0,0-.1.31.3.3,0,0,1-.05.15.49.49,0,0,1-.13.12.11.11,0,0,1-.12,0s0,0,0-.09a1.19,1.19,0,0,1,.2-.61,1.53,1.53,0,0,1,.49-.49l.7-.4a.54.54,0,0,1,.49-.08.36.36,0,0,1,.21.37v.35a1.12,1.12,0,0,1-.21.61A1.43,1.43,0,0,1,376.87,269.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,267.67v.17a1.19,1.19,0,0,1-.2.61,1.53,1.53,0,0,1-.49.49l-.7.4a.57.57,0,0,1-.49.08c-.14-.06-.2-.18-.2-.38a.26.26,0,0,1,.05-.15.34.34,0,0,1,.12-.12.14.14,0,0,1,.12,0,.09.09,0,0,1,.05.09.18.18,0,0,0,.11.19.25.25,0,0,0,.24,0l.7-.4a.91.91,0,0,0,.24-.24.57.57,0,0,0,.1-.31v-.17c0-.1,0-.16-.1-.19a.27.27,0,0,0-.24,0l-.18.1c-.05,0-.09,0-.12,0s-.05,0-.05-.09a.3.3,0,0,1,.05-.15.3.3,0,0,1,.12-.13l.18-.1a.69.69,0,0,0,.24-.24.56.56,0,0,0,.1-.3v-.18c0-.09,0-.16-.1-.18a.24.24,0,0,0-.24,0l-.7.4a.61.61,0,0,0-.24.24.58.58,0,0,0-.11.3.27.27,0,0,1-.05.16.34.34,0,0,1-.12.12.14.14,0,0,1-.12,0s-.05-.05-.05-.1a1.07,1.07,0,0,1,.2-.6,1.43,1.43,0,0,1,.49-.49l.7-.4a.54.54,0,0,1,.49-.08.37.37,0,0,1,.2.37v.18a1,1,0,0,1-.06.32,1.32,1.32,0,0,1-.18.33.36.36,0,0,1,.18.14A.46.46,0,0,1,380.34,267.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.2,272.5h0a.13.13,0,0,1-.1-.13l.43-3.24a.12.12,0,0,1,.23,0l-.43,3.24A.1.1,0,0,1,374.2,272.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,260.7V268a1.91,1.91,0,0,1-.86,1.49L345,274c-.48.28-.86.06-.86-.49v-7.32a1.89,1.89,0,0,1,.86-1.49c2.09-1.21,5.58-3.28,7.68-4.49C353.15,259.93,353.54,260.15,353.54,260.7Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,260.7V268a1.91,1.91,0,0,1-.86,1.49L345,274c-.48.28-.86.06-.86-.49v-7.32a1.89,1.89,0,0,1,.86-1.49c2.09-1.21,5.58-3.28,7.68-4.49C353.15,259.93,353.54,260.15,353.54,260.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,266l-3,1.77v-3.29l3-1.76v-.45l-9.4,5.47v.45l3-1.77v3.29l-3,1.76v.45l9.4-5.47Zm-3.42,2-2.57,1.5v-3.29l2.57-1.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.12,259.61l-7.22,4.18a2.11,2.11,0,0,0-.95,1.65v.15c0,.61.43.86.95.55l7.22-4.18a2.09,2.09,0,0,0,1-1.65v-.15C393.08,259.55,392.65,259.3,392.12,259.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.38,256.85a.4.4,0,0,1,.07-.19.26.26,0,0,1,.11-.12l.48-.28a.13.13,0,0,1,.12,0,.13.13,0,0,1,0,.13,3.36,3.36,0,0,1-.12.73,3.4,3.4,0,0,1-.32.77,3.79,3.79,0,0,1-.55.75,3.13,3.13,0,0,1-.79.63,1.81,1.81,0,0,1-.73.25.76.76,0,0,1-.54-.14,1,1,0,0,1-.34-.5,2.92,2.92,0,0,1-.15-.8c0-.2,0-.42,0-.66s0-.47,0-.68a5.29,5.29,0,0,1,.15-1,3.89,3.89,0,0,1,.34-.9,3.74,3.74,0,0,1,.54-.76,3,3,0,0,1,.73-.59,1.88,1.88,0,0,1,.79-.29.81.81,0,0,1,.55.12.79.79,0,0,1,.32.41,1.81,1.81,0,0,1,.12.57.31.31,0,0,1,0,.19.34.34,0,0,1-.12.12l-.48.28a.13.13,0,0,1-.12,0,.14.14,0,0,1-.06-.12.54.54,0,0,0-.09-.26.33.33,0,0,0-.18-.17.42.42,0,0,0-.28,0,1.19,1.19,0,0,0-.41.16,1.65,1.65,0,0,0-.41.33,2.42,2.42,0,0,0-.29.42,2.05,2.05,0,0,0-.18.49,3,3,0,0,0-.07.51c0,.21,0,.44,0,.68s0,.47,0,.66a1.84,1.84,0,0,0,.07.44.54.54,0,0,0,.18.27.48.48,0,0,0,.29.09,1,1,0,0,0,.41-.14,2.1,2.1,0,0,0,.41-.31,3.05,3.05,0,0,0,.29-.36,2.58,2.58,0,0,0,.18-.38A1.82,1.82,0,0,0,344.38,256.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,251.19c.5-.29.88-.35,1.14-.19s.38.51.38,1.06a3,3,0,0,1-.2,1.11,3,3,0,0,1-.59,1l.83,1.49a.24.24,0,0,1,0,.08.37.37,0,0,1,0,.14.35.35,0,0,1-.09.11l-.51.29q-.12.07-.18,0a.32.32,0,0,1-.08-.09l-.78-1.41-.8.46v1.86a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-.49.28a.11.11,0,0,1-.11,0,.17.17,0,0,1-.05-.13v-5.15a.41.41,0,0,1,.05-.18.36.36,0,0,1,.11-.13Zm-.9,3,.87-.5a1.67,1.67,0,0,0,.54-.47,1.19,1.19,0,0,0,.21-.73q0-.45-.21-.48a.86.86,0,0,0-.54.17l-.87.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.64,252.86a.09.09,0,0,1,.11,0,.14.14,0,0,1,.05.13v.56a.31.31,0,0,1-.05.18.29.29,0,0,1-.11.13L350,255.37s-.08,0-.11,0a.14.14,0,0,1,0-.12v-5.16a.41.41,0,0,1,0-.18.36.36,0,0,1,.11-.13l2.58-1.49a.13.13,0,0,1,.12,0,.17.17,0,0,1,0,.13V249a.39.39,0,0,1,0,.18c0,.06-.07.11-.12.13l-1.93,1.12v1.27l1.8-1a.08.08,0,0,1,.11,0s.05.06.05.12v.57a.35.35,0,0,1-.05.18.26.26,0,0,1-.11.12l-1.8,1V254Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,246.82a2.07,2.07,0,0,1,.77-.29.77.77,0,0,1,.55.13,1,1,0,0,1,.33.5,2.69,2.69,0,0,1,.14.82,11.81,11.81,0,0,1,0,1.19,4.63,4.63,0,0,1-.14,1,4.21,4.21,0,0,1-.33.88,3.08,3.08,0,0,1-.53.75,3.16,3.16,0,0,1-.76.59l-1.5.87a.11.11,0,0,1-.12,0,.17.17,0,0,1-.05-.13V248a.41.41,0,0,1,.05-.18.26.26,0,0,1,.12-.13Zm1,1.63a1.38,1.38,0,0,0-.07-.43.62.62,0,0,0-.18-.28.46.46,0,0,0-.31-.07,1.11,1.11,0,0,0-.45.16l-.8.46v3.59l.83-.48a1.59,1.59,0,0,0,.43-.33,1.84,1.84,0,0,0,.3-.43,1.9,1.9,0,0,0,.18-.49,2.25,2.25,0,0,0,.07-.52A11.61,11.61,0,0,0,356.13,248.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.86,250.84c-.05,0-.08,0-.11,0s-.05-.06-.05-.12v-5.16a.35.35,0,0,1,.05-.18.28.28,0,0,1,.11-.13l.48-.28a.13.13,0,0,1,.12,0,.17.17,0,0,1,.05.13v5.15a.41.41,0,0,1-.05.18.38.38,0,0,1-.12.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,242.75a.08.08,0,0,1,.11,0,.14.14,0,0,1,.05.12v.57a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-1.08.62v4.37a.41.41,0,0,1-.05.18.36.36,0,0,1-.11.13l-.49.28a.08.08,0,0,1-.11,0,.14.14,0,0,1-.05-.12v-4.37l-1.08.62a.11.11,0,0,1-.11,0,.15.15,0,0,1-.05-.12v-.57a.41.41,0,0,1,.05-.18.36.36,0,0,1,.11-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.68,244a.4.4,0,0,1,.07-.19.43.43,0,0,1,.11-.12l.48-.27a.11.11,0,0,1,.12,0,.12.12,0,0,1,0,.13,3.38,3.38,0,0,1-.12.72,3.21,3.21,0,0,1-.32.78,3.67,3.67,0,0,1-.54.74,3.38,3.38,0,0,1-.8.63,1.66,1.66,0,0,1-.73.26.82.82,0,0,1-.54-.15,1,1,0,0,1-.34-.5,2.92,2.92,0,0,1-.15-.8c0-.19,0-.42,0-.66s0-.47,0-.68a5.43,5.43,0,0,1,.15-1,4.31,4.31,0,0,1,.34-.89,3.8,3.8,0,0,1,.54-.77,2.92,2.92,0,0,1,.73-.58,2.05,2.05,0,0,1,.8-.3.9.9,0,0,1,.54.12.78.78,0,0,1,.32.41,1.81,1.81,0,0,1,.12.58.3.3,0,0,1,0,.18.3.3,0,0,1-.12.13l-.48.28a.13.13,0,0,1-.12,0s-.05-.05-.06-.12a.58.58,0,0,0-.09-.26.4.4,0,0,0-.17-.17.67.67,0,0,0-.29,0,1.27,1.27,0,0,0-.41.16,1.86,1.86,0,0,0-.41.33,2.49,2.49,0,0,0-.29.43,3.41,3.41,0,0,0-.18.48,3.24,3.24,0,0,0-.07.52c0,.2,0,.43,0,.67s0,.47,0,.67a1.76,1.76,0,0,0,.07.43.71.71,0,0,0,.18.27.42.42,0,0,0,.29.09.84.84,0,0,0,.41-.14,1.84,1.84,0,0,0,.41-.31,3.05,3.05,0,0,0,.29-.36,1.64,1.64,0,0,0,.18-.38A1.55,1.55,0,0,0,366.68,244Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,238.19c.07,0,.11-.05.15,0a.34.34,0,0,1,.08.16l1.47,4.19v0a.31.31,0,0,1-.05.18.29.29,0,0,1-.11.13l-.43.25c-.08.05-.14.06-.17,0a.24.24,0,0,1-.06-.09l-.26-.74-1.89,1.09-.26,1a.56.56,0,0,1-.07.17.41.41,0,0,1-.16.16l-.43.25a.13.13,0,0,1-.12,0,.14.14,0,0,1-.05-.12s0,0,0-.06l1.47-5.89a.92.92,0,0,1,.08-.25.29.29,0,0,1,.14-.15Zm.33,3.31-.66-1.9-.66,2.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,235.92c.5-.28.88-.35,1.14-.19s.39.51.39,1.06a3.17,3.17,0,0,1-.2,1.11,3,3,0,0,1-.59.95l.82,1.49a.24.24,0,0,1,0,.08.28.28,0,0,1,0,.15.18.18,0,0,1-.09.1l-.51.3c-.08,0-.14.05-.18,0l-.08-.09-.78-1.41-.8.46v1.86a.39.39,0,0,1,0,.18.38.38,0,0,1-.12.13l-.48.28c-.05,0-.08,0-.12,0s0-.06,0-.12v-5.16a.39.39,0,0,1,0-.18.38.38,0,0,1,.12-.13Zm-.9,3,.87-.5a1.82,1.82,0,0,0,.55-.47,1.23,1.23,0,0,0,.2-.72c0-.3-.07-.46-.2-.49a.94.94,0,0,0-.55.17l-.87.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,233.66a2,2,0,0,1,.77-.28.77.77,0,0,1,.55.12,1,1,0,0,1,.33.5,3.16,3.16,0,0,1,.15.83c0,.39,0,.78,0,1.18a5.13,5.13,0,0,1-.15,1,3.27,3.27,0,0,1-.33.89,3.52,3.52,0,0,1-.53.75,3.31,3.31,0,0,1-.75.59l-1.51.87s-.09,0-.12,0,0-.06,0-.12v-5.15a.39.39,0,0,1,0-.18.26.26,0,0,1,.12-.13Zm1,1.64a1.65,1.65,0,0,0-.08-.43.57.57,0,0,0-.18-.28.47.47,0,0,0-.31-.08,1.07,1.07,0,0,0-.44.17l-.81.46v3.59l.83-.48a1.62,1.62,0,0,0,.43-.34,2,2,0,0,0,.3-.42,2.05,2.05,0,0,0,.18-.49,3.12,3.12,0,0,0,.08-.52C378.93,236.08,378.93,235.68,378.92,235.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,252.5l-.79.46c-.26.15-.53.3-.74.44a4.79,4.79,0,0,0-1.14,1.19,5.85,5.85,0,0,0-.73,1.51,3.84,3.84,0,0,0-.15.81c0,.25,0,.57,0,.87,0,3.3,0,6.6,0,9.9l-.4,26.56v-37a5.11,5.11,0,0,1,.74-2.49c0-.1.11-.19.17-.29a6.18,6.18,0,0,1,.62-.79,4.35,4.35,0,0,1,1-.8l1-.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,254.71a5.2,5.2,0,0,0-.73,2.48v10.73h0V257.19A5.2,5.2,0,0,1,335.09,254.71Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,241.28l-20,11.55a4.58,4.58,0,0,0-1,.8,4.58,4.58,0,0,1,1-.8Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.69,219.45l-12.31,7.38-12.54,7.4c-8.37,4.92-16.77,9.77-25.16,14.65l-6.31,3.62-.46-.27,19-10.95Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.77,412.77c-7.09-7.32-11.26-25.82-4.34-31.63H80.64c6.92,5.81,2.75,24.3-4.34,31.62l-.19.2a2.83,2.83,0,0,1-.25.24c-.2.2-.41.39-.64.58l-.17.14c-.17.13-.34.27-.53.4a10.33,10.33,0,0,1-.92.6c-5.84,3.4-15.3,3.4-21.13,0h0a10.47,10.47,0,0,1-.93-.6l-.5-.38-.2-.17c-.22-.18-.43-.36-.62-.55l-.29-.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58,378.81c8,4.69,8,12.29,0,17s-21.06,4.69-29.09,0-8-12.29,0-17S69.55,374.12,77.58,378.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,381.06c5.9,3.45,5.9,9,0,12.47s-15.47,3.45-21.37,0-5.9-9,0-12.47S67.82,377.62,73.72,381.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,387c5.9-3.44,15.47-3.44,21.37,0a9.91,9.91,0,0,1,3.53,3.28,9.89,9.89,0,0,1-3.53,3.27c-5.9,3.45-15.47,3.45-21.37,0a9.81,9.81,0,0,1-3.53-3.27A9.82,9.82,0,0,1,52.35,387Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,343.25c-2.37,3-9.51,4.33-13.07-3-3.34-6.9-6.87-13.41-7.93-16a2.69,2.69,0,0,1,1.46-3.6s-.09-3.92,6.73-1.78S57.2,324.69,60.58,331,62.58,342,58.21,343.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,353.06a36.86,36.86,0,0,0-.88-3.91,54.9,54.9,0,0,0-2.78-7.47,56.19,56.19,0,0,0-8.75-13.58,50,50,0,0,0-6.55-6.38c-.08-.05-.12.1-.07.15A60.36,60.36,0,0,1,53.26,334.2a60.39,60.39,0,0,1,6.59,14.38c.44,1.41.86,2.84,1.24,4.27s.64,2.94,1,4.4c0,.14.27.22.26,0A28.33,28.33,0,0,0,61.85,353.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.85,353.06a36.86,36.86,0,0,0-.88-3.91,54.9,54.9,0,0,0-2.78-7.47,56.19,56.19,0,0,0-8.75-13.58,50,50,0,0,0-6.55-6.38c-.08-.05-.12.1-.07.15A60.36,60.36,0,0,1,53.26,334.2a60.39,60.39,0,0,1,6.59,14.38c.44,1.41.86,2.84,1.24,4.27s.64,2.94,1,4.4c0,.14.27.22.26,0A28.33,28.33,0,0,0,61.85,353.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,338c-6.2,1.92-10.8-2.92-9.21-10.5s9.56-16,12.57-13.74c1.88-1.88,6-1.21,8,4.95S77.46,340.67,66,338Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.59,318.35A83.84,83.84,0,0,0,65.47,332a132.75,132.75,0,0,0-2.39,14.27,223.18,223.18,0,0,0-1.24,28c0,2.58,0,5.16.1,7.74s0,5.34.24,8c.08,1,1.53.74,1.54-.19.1-4.64-.16-9.31-.21-13.95s0-9.19.09-13.78a193.66,193.66,0,0,1,2.51-27.93c.44-2.57.93-5.13,1.53-7.67s1.4-5.31,2.1-8C69.77,318.35,69.65,318.21,69.59,318.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.59,318.35A83.84,83.84,0,0,0,65.47,332a132.75,132.75,0,0,0-2.39,14.27,223.18,223.18,0,0,0-1.24,28c0,2.58,0,5.16.1,7.74s0,5.34.24,8c.08,1,1.53.74,1.54-.19.1-4.64-.16-9.31-.21-13.95s0-9.19.09-13.78a193.66,193.66,0,0,1,2.51-27.93c.44-2.57.93-5.13,1.53-7.67s1.4-5.31,2.1-8C69.77,318.35,69.65,318.21,69.59,318.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.43,358.74c-1.79,3.67-7.84,5.07-13.31.92s-13.38-23.3-7.39-23.6c.46-3,17.81-1,23.41,11.41C61.2,356.47,54.43,358.74,54.43,358.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,366.8a31.4,31.4,0,0,0-1.78-3.4,75.73,75.73,0,0,0-4.31-6.52,78.19,78.19,0,0,0-10.76-11.73A71.15,71.15,0,0,0,38,339.53c-.07,0-.08.11,0,.14,2,1.65,3.93,3.26,5.77,5a78.42,78.42,0,0,1,5.42,5.82,97.07,97.07,0,0,1,9,12.36c.76,1.24,1.45,2.51,2.22,3.74s1.69,2.49,2.43,3.8c.11.19.39.19.29-.07C62.57,369.17,62.19,368,61.7,366.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,366.8a31.4,31.4,0,0,0-1.78-3.4,75.73,75.73,0,0,0-4.31-6.52,78.19,78.19,0,0,0-10.76-11.73A71.15,71.15,0,0,0,38,339.53c-.07,0-.08.11,0,.14,2,1.65,3.93,3.26,5.77,5a78.42,78.42,0,0,1,5.42,5.82,97.07,97.07,0,0,1,9,12.36c.76,1.24,1.45,2.51,2.22,3.74s1.69,2.49,2.43,3.8c.11.19.39.19.29-.07C62.57,369.17,62.19,368,61.7,366.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.78,357.18c-3.54-.81-3.72-5.06.71-10.28s15.58-7.49,16.11-5.29c2.47,0,2.47,7.76-3,14.89S66.11,362,65.78,357.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,349.59a28.45,28.45,0,0,0-6.13,5.82,28.78,28.78,0,0,0-4.12,7.41c-.12.3.41.75.53.42a32.47,32.47,0,0,1,9.74-13.58S72.76,349.56,72.72,349.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,349.59a28.45,28.45,0,0,0-6.13,5.82,28.78,28.78,0,0,0-4.12,7.41c-.12.3.41.75.53.42a32.47,32.47,0,0,1,9.74-13.58S72.76,349.56,72.72,349.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,383.09c-4.9,2-2.8,7.82,2,12.26a21.85,21.85,0,0,0,14.93,5.37c3.29-.23,4.13-.68,4.13-.68a37.38,37.38,0,0,0,0-8.12,15.7,15.7,0,0,0-11.56-12.45C71.66,377.4,69.82,380.17,69.82,383.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,391.71a39.62,39.62,0,0,0-7.51-6.95c-2.79-1.83-6.51-3.4-9.86-2.26-1.3.45-3.32,1.74-3.07,3.35,0,.16.3.55.49.33a13.94,13.94,0,0,1,1.77-2.06,5.24,5.24,0,0,1,2.63-1,12.2,12.2,0,0,1,6.88,1.57c3.32,1.76,6,4.49,8.64,7.1C83.39,391.82,83.43,391.74,83.4,391.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,391.71a39.62,39.62,0,0,0-7.51-6.95c-2.79-1.83-6.51-3.4-9.86-2.26-1.3.45-3.32,1.74-3.07,3.35,0,.16.3.55.49.33a13.94,13.94,0,0,1,1.77-2.06,5.24,5.24,0,0,1,2.63-1,12.2,12.2,0,0,1,6.88,1.57c3.32,1.76,6,4.49,8.64,7.1C83.39,391.82,83.43,391.74,83.4,391.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,363.91c0-2.08-3.72-6.35-12.91-5.62-4.2.34-8.05,1.47-11.13,4.43a6.39,6.39,0,0,0-2,3.7,2.76,2.76,0,0,0,.22,1.63,2.84,2.84,0,0,0,.79.9c2.2,1.77,5.06,1.3,7.65,2,4,1,12.46,4.69,17.32,2.25S54.1,365.43,51.18,363.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.32,369.64c-5.25-7.16-15.49-7.77-23.5-6.26a32,32,0,0,0-7.64,2.45s0,.11,0,.09a42.48,42.48,0,0,1,13-2.52A27.52,27.52,0,0,1,54,365.82a16.57,16.57,0,0,1,5.15,4C59.31,370,59.43,369.79,59.32,369.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.32,369.64c-5.25-7.16-15.49-7.77-23.5-6.26a32,32,0,0,0-7.64,2.45s0,.11,0,.09a42.48,42.48,0,0,1,13-2.52A27.52,27.52,0,0,1,54,365.82a16.57,16.57,0,0,1,5.15,4C59.31,370,59.43,369.79,59.32,369.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58,346.24c-.13,3.51,4.82,5.55,9.61,2.51s9.81-6,14.25-7.14,6.54-4.77,5.14-6.52-3.63-6.18-15.3-4.73-15.8,6.7-17.4,10.41S72.82,347.25,74.58,346.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,335.07a12.72,12.72,0,0,0-5,.53,24.26,24.26,0,0,0-4.28,1.53,23.69,23.69,0,0,0-7.3,5.29,19.58,19.58,0,0,0-1.64,2,8.41,8.41,0,0,0-1.25,2c-.08.23.26.61.46.37.58-.66,1-1.48,1.56-2.18A22.43,22.43,0,0,1,78,342.48a23.66,23.66,0,0,1,4.49-3.54,28.31,28.31,0,0,1,5-2.43c1-.34,1.92-.62,2.91-.87a10,10,0,0,1,3.17-.44C93.6,335.21,93.62,335.08,93.57,335.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,335.07a12.72,12.72,0,0,0-5,.53,24.26,24.26,0,0,0-4.28,1.53,23.69,23.69,0,0,0-7.3,5.29,19.58,19.58,0,0,0-1.64,2,8.41,8.41,0,0,0-1.25,2c-.08.23.26.61.46.37.58-.66,1-1.48,1.56-2.18A22.43,22.43,0,0,1,78,342.48a23.66,23.66,0,0,1,4.49-3.54,28.31,28.31,0,0,1,5-2.43c1-.34,1.92-.62,2.91-.87a10,10,0,0,1,3.17-.44C93.6,335.21,93.62,335.08,93.57,335.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,365.22c-1.63-1.64-6.07-1.26-8.17,3.58s2.31,10.11,2.8,11.6c2-1.17,3.61-.47,7.18-1.17a8.91,8.91,0,0,0,6.84-8.89C74.61,365.92,72.74,363,66.2,365.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,364.73A6.81,6.81,0,0,0,64,367a12.69,12.69,0,0,0-1.41,2.71,11.47,11.47,0,0,0-.61,6.16c0,.07.07,0,.07,0a12.69,12.69,0,0,1,1-6.08,11.64,11.64,0,0,1,1.47-2.44,13.37,13.37,0,0,1,1-1.14,5.57,5.57,0,0,0,.94-.94C66.58,365,66.39,364.61,66.14,364.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.14,364.73A6.81,6.81,0,0,0,64,367a12.69,12.69,0,0,0-1.41,2.71,11.47,11.47,0,0,0-.61,6.16c0,.07.07,0,.07,0a12.69,12.69,0,0,1,1-6.08,11.64,11.64,0,0,1,1.47-2.44,13.37,13.37,0,0,1,1-1.14,5.57,5.57,0,0,0,.94-.94C66.58,365,66.39,364.61,66.14,364.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46,378.2c-.91-3.48-5.33-5.43-11.1-5.87A15.09,15.09,0,0,0,34,379.7c-3,5.16-4.27,9.27-2.43,9.94s9.58,1.75,14.59,2.19,11.25-.45,15.33-4.25S64.24,379,59.46,378.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,377.74a15.2,15.2,0,0,0-6.23-.29,27.73,27.73,0,0,0-5.88,1.36,36.61,36.61,0,0,0-5.82,2.62c-1,.53-1.94,1.1-2.88,1.7a20.74,20.74,0,0,0-2.58,1.78s0,.15,0,.12c.95-.42,1.84-1,2.74-1.53s2-1.09,3-1.59a41.8,41.8,0,0,1,5.77-2.45,27.26,27.26,0,0,1,6.12-1.31,36.74,36.74,0,0,1,5.84.15C60.14,378.32,59.92,377.82,59.67,377.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,377.74a15.2,15.2,0,0,0-6.23-.29,27.73,27.73,0,0,0-5.88,1.36,36.61,36.61,0,0,0-5.82,2.62c-1,.53-1.94,1.1-2.88,1.7a20.74,20.74,0,0,0-2.58,1.78s0,.15,0,.12c.95-.42,1.84-1,2.74-1.53s2-1.09,3-1.59a41.8,41.8,0,0,1,5.77-2.45,27.26,27.26,0,0,1,6.12-1.31,36.74,36.74,0,0,1,5.84.15C60.14,378.32,59.92,377.82,59.67,377.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,369.65c-4-3.14-2.64-10.7,11.23-11.11s23.79,3.22,23.35,7.68c2.23,2.24,1.1,8.49-10.13,10.45S67.09,377.65,70,369.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,366.27a59.72,59.72,0,0,0-12.39-.72,47.91,47.91,0,0,0-11.45,1.32,16.71,16.71,0,0,0-2.79,1c-.41.2-.82.42-1.21.65s-.67.36-.78.73a.38.38,0,0,0,.41.44,15.22,15.22,0,0,0,2.43-1.2,19.63,19.63,0,0,1,2.4-.88,30.19,30.19,0,0,1,4.82-.94,84.79,84.79,0,0,1,11.71-.65c2.28,0,4.55.2,6.82.38C98,366.44,98.07,366.29,98,366.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,366.27a59.72,59.72,0,0,0-12.39-.72,47.91,47.91,0,0,0-11.45,1.32,16.71,16.71,0,0,0-2.79,1c-.41.2-.82.42-1.21.65s-.67.36-.78.73a.38.38,0,0,0,.41.44,15.22,15.22,0,0,0,2.43-1.2,19.63,19.63,0,0,1,2.4-.88,30.19,30.19,0,0,1,4.82-.94,84.79,84.79,0,0,1,11.71-.65c2.28,0,4.55.2,6.82.38C98,366.44,98.07,366.29,98,366.27Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bags--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bag--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.11,330.32a5.75,5.75,0,0,0-5.89.35c-4.83,2.79-8.76,10.85-8.76,18v16.79a.76.76,0,0,0,1.52,0V348.64c0-6.63,3.59-14.1,8-16.65a4.25,4.25,0,0,1,4.37-.35c1.82,1.05,2.87,3.72,2.87,7.33v16.71a.76.76,0,0,0,1.52,0V339C158.74,334.8,157.42,331.65,155.11,330.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.62 426.58 187.92 345.88 174.46 338.13 170.05 413.55 192.62 426.58",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.62 426.58 187.92 345.88 174.46 338.13 170.05 413.55 192.62 426.58",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 365.43 122.75 440.85 170.05 413.55 174.46 338.13 127.17 365.43",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 365.43 122.75 440.85 170.05 413.55 174.46 338.13 127.17 365.43",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 365.43 122.75 440.85 170.05 413.55 174.46 338.13 127.17 365.43",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 365.43 140.63 373.18 145.33 453.89 122.75 440.85 127.17 365.43",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.17 365.43 140.63 373.18 145.33 453.89 122.75 440.85 127.17 365.43",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.33 453.89 135.63 440.27 134.41 392.69 133.2 439.44 122.75 440.85 145.33 453.89",
    style: {
      fill: "#278AFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,345.88l-47.29,27.3,4.7,80.71,47.29-27.31Zm-33.21,29.19c-.93.53-1.69.08-1.69-1a3.75,3.75,0,0,1,1.69-2.93c.93-.54,1.69-.09,1.69,1A3.72,3.72,0,0,1,154.71,375.07Zm16.76-9.75c-.93.53-1.69.08-1.69-1a3.75,3.75,0,0,1,1.69-2.93c.93-.54,1.69-.09,1.69,1A3.72,3.72,0,0,1,171.47,365.32Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,345.88l-47.29,27.3,4.7,80.71,47.29-27.31Zm-33.21,29.19c-.93.53-1.69.08-1.69-1a3.75,3.75,0,0,1,1.69-2.93c.93-.54,1.69-.09,1.69,1A3.72,3.72,0,0,1,154.71,375.07Zm16.76-9.75c-.93.53-1.69.08-1.69-1a3.75,3.75,0,0,1,1.69-2.93c.93-.54,1.69-.09,1.69,1A3.72,3.72,0,0,1,171.47,365.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,338a5.73,5.73,0,0,0-5.89.36c-4.83,2.78-8.77,10.85-8.77,18v16.79a.77.77,0,0,0,.77.76.76.76,0,0,0,.76-.76V356.32c0-6.64,3.59-14.11,8-16.65a4.25,4.25,0,0,1,4.37-.35c1.82,1.05,2.87,3.72,2.87,7.32v16.72a.76.76,0,0,0,1.52,0V346.64C172.23,342.48,170.91,339.33,168.6,338Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dark-bag--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.56,359.21a5,5,0,0,0-5.15.3c-4.22,2.44-7.65,9.47-7.65,15.69v14.65a.67.67,0,0,0,.67.67.66.66,0,0,0,.66-.67V375.2c0-5.79,3.14-12.31,7-14.53a3.7,3.7,0,0,1,3.81-.31c1.59.92,2.5,3.25,2.5,6.39v14.59a.67.67,0,1,0,1.33,0V366.75C197.72,363.12,196.57,360.37,194.56,359.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.29 443.22 223.19 372.78 211.44 366.02 207.59 431.85 227.29 443.22",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.29 443.22 223.19 372.78 211.44 366.02 207.59 431.85 227.29 443.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.17 389.85 166.31 455.68 207.59 431.85 211.44 366.02 170.17 389.85",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.17 389.85 166.31 455.68 207.59 431.85 211.44 366.02 170.17 389.85",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.17 389.85 181.91 396.61 186.02 467.05 166.31 455.68 170.17 389.85",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.17 389.85 181.91 396.61 186.02 467.05 166.31 455.68 170.17 389.85",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.02 467.05 177.55 455.16 176.49 413.64 175.43 454.44 166.31 455.68 186.02 467.05",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.19,372.78l-41.28,23.83L186,467.05l41.27-23.83Zm-29,25.48c-.81.46-1.47.08-1.47-.86a3.28,3.28,0,0,1,1.47-2.56c.82-.47,1.48-.08,1.48.87A3.21,3.21,0,0,1,194.2,398.26Zm14.63-8.51c-.81.46-1.47.08-1.47-.86a3.28,3.28,0,0,1,1.47-2.56c.82-.47,1.48-.08,1.47.87A3.23,3.23,0,0,1,208.83,389.75Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.33,365.9a5.06,5.06,0,0,0-5.15.31c-4.21,2.44-7.64,9.47-7.64,15.69v14.65a.66.66,0,0,0,.66.67.67.67,0,0,0,.67-.67V381.9c0-5.79,3.13-12.31,7-14.53a3.68,3.68,0,0,1,3.81-.31c1.59.92,2.5,3.25,2.5,6.39V388a.67.67,0,0,0,1.34,0V373.45C209.5,369.82,208.34,367.07,206.33,365.9Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.89,400.66a21.36,21.36,0,0,0-7.88-7.29c-12.87-7.43-33.75-7.43-46.63,0a21.24,21.24,0,0,0-7.87,7.29h-1.79v6.73h0c.23,4.69,3.44,9.33,9.63,12.91,12.88,7.43,33.76,7.43,46.63,0,6.2-3.58,9.43-8.22,9.66-12.91h0v-6.73Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.89,400.66a21.36,21.36,0,0,0-7.88-7.29c-12.87-7.43-33.75-7.43-46.63,0a21.24,21.24,0,0,0-7.87,7.29h-1.79v6.73h0c.23,4.69,3.44,9.33,9.63,12.91,12.88,7.43,33.76,7.43,46.63,0,6.2-3.58,9.43-8.22,9.66-12.91h0v-6.73Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7,387.8c-8.44,0-16.88,1.85-23.32,5.57a21.17,21.17,0,0,0-7.87,7.29h-1.79v6.73h0c.23,4.69,3.44,9.33,9.63,12.91,6.44,3.71,14.88,5.57,23.32,5.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,390.89a35.41,35.41,0,0,0-5.31,2.48,21.17,21.17,0,0,0-7.87,7.29h-1.79v6.73h0c.23,4.69,3.44,9.33,9.63,12.91a36.42,36.42,0,0,0,5.31,2.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.71,390.89a35.29,35.29,0,0,1,5.3,2.48,21.28,21.28,0,0,1,7.88,7.29h1.78v6.73h0c-.24,4.69-3.46,9.33-9.66,12.91a36.3,36.3,0,0,1-5.3,2.48Z",
    style: {
      fill: "#278AFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,387.2c-12.88,7.43-12.87,19.49,0,26.92,11.27,6.51,28.66,7.32,41.46,2.44h0l.51-.2a35.8,35.8,0,0,0,4.66-2.24c10.74-6.2,12.53-15.61,5.35-22.88h0a24.88,24.88,0,0,0-5.35-4C284.14,379.76,263.26,379.76,250.38,387.2Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.38,387.2c-12.88,7.43-12.87,19.49,0,26.92,11.27,6.51,28.66,7.32,41.46,2.44h0l.51-.2a35.8,35.8,0,0,0,4.66-2.24c10.74-6.2,12.53-15.61,5.35-22.88h0a24.88,24.88,0,0,0-5.35-4C284.14,379.76,263.26,379.76,250.38,387.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.36,391.24A14.4,14.4,0,0,1,305.81,403c-1.14,6.54-10.3,12.05-13.46,13.37a35.8,35.8,0,0,0,4.66-2.24C307.75,407.92,309.54,398.51,302.36,391.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,410.08a14.44,14.44,0,0,1-3.45-11.75c1.14-6.54,10.31-12.05,13.46-13.37a36.43,36.43,0,0,0-4.66,2.24C239.64,393.4,237.86,402.81,245,410.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.71,
    cy: 400.63,
    rx: 30.65,
    ry: 17.7,
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.71,
    cy: 400.63,
    rx: 30.65,
    ry: 17.7,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,405.92c2.46-4.56,1.66-9.58-2.41-13.83a20.86,20.86,0,0,0-2.59-2.28,26,26,0,0,0-2.48-1.63c-.49-.29-1-.56-1.51-.82,1.27,2.09.8,4.34-6.42,4.76-14.12.83,3.78,14.33,3.78,14.33S300.45,402.05,303,405.92Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.51,402.18c2.12-.23,3.17-2.41,2.35-4.87s-3.21-4.24-5.33-4-3.17,2.42-2.35,4.87S299.39,402.42,301.51,402.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,413.44c-.7-5.25-23.63-19.77-23.63-19.77s-5.09-2.05-3.4-5.6a25.24,25.24,0,0,0-2.45,1.59,18,18,0,0,0-1.49,1.18c-6.83,5.91-6.84,13.67,0,19.59.46.4,1,.8,1.49,1.18a24,24,0,0,0,2.27,1.48c.78.46,1.59.88,2.43,1.27q1,.48,2.07.9c.7.27,1.42.53,2.15.77a44.33,44.33,0,0,0,6.84,1.64c.51.09,1,.16,1.54.23a53.57,53.57,0,0,0,6.84.43,52.81,52.81,0,0,0,8.37-.69S278.51,416.89,279.17,413.44Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,413.44c-.7-5.25-23.63-19.77-23.63-19.77s-5.09-2.05-3.4-5.6a25.24,25.24,0,0,0-2.45,1.59,18,18,0,0,0-1.49,1.18c-6.83,5.91-6.84,13.67,0,19.59.46.4,1,.8,1.49,1.18a24,24,0,0,0,2.27,1.48c.78.46,1.59.88,2.43,1.27q1,.48,2.07.9c.7.27,1.42.53,2.15.77a44.33,44.33,0,0,0,6.84,1.64c.51.09,1,.16,1.54.23a53.57,53.57,0,0,0,6.84.43,52.81,52.81,0,0,0,8.37-.69S278.51,416.89,279.17,413.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,391.31c-8.55,4.94-8.9,12.82-1,18,.33.22.68.44,1.05.65,8.91,5.14,23.37,5.14,32.29,0s8.92-13.5,0-18.65c-.36-.21-.74-.41-1.12-.6C279.76,386.17,266.11,386.37,257.55,391.31Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.55,391.31c-8.55,4.94-8.9,12.82-1,18,.33.22.68.44,1.05.65,8.91,5.14,23.37,5.14,32.29,0s8.92-13.5,0-18.65c-.36-.21-.74-.41-1.12-.6C279.76,386.17,266.11,386.37,257.55,391.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.71,
    cy: 400.63,
    rx: 21.83,
    ry: 12.6,
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.71,
    cy: 400.63,
    rx: 21.83,
    ry: 12.6,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,395.24c8.52-4.93,22.34-4.93,30.87,0,3.48,2,5.54,4.53,6.18,7.15-.64,2.62-2.7,5.14-6.18,7.15-8.53,4.93-22.35,4.93-30.87,0-3.49-2-5.55-4.53-6.18-7.15C252.73,399.77,254.79,397.25,258.28,395.24Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,395.24c8.52-4.93,22.34-4.93,30.87,0,3.48,2,5.54,4.53,6.18,7.15-.64,2.62-2.7,5.14-6.18,7.15-8.53,4.93-22.35,4.93-30.87,0-3.49-2-5.55-4.53-6.18-7.15C252.73,399.77,254.79,397.25,258.28,395.24Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.46,404.43c0-.43,0-2.16,0-2.61,0-1.06-.74-2.1-2.33-3l-.06,0a11.18,11.18,0,0,0-8.65-.79h0c-1.14.29-2.23.67-3.23,1a31.1,31.1,0,0,1-3.47,1.07h0a6.13,6.13,0,0,1-1.65.16,3.57,3.57,0,0,1-1.36-.36l.1-.08.35-.21a7,7,0,0,1,.91-.45,6.29,6.29,0,0,1,4.85-.11l2.8-2.83v-2.59a13.28,13.28,0,0,0-7.65-.27,14.29,14.29,0,0,0-2.43.84l-2.8-1.62-3.34,1.93V397l1.14.66a2.84,2.84,0,0,0-.49,1.51c0,.43,0,2.15,0,2.59,0,1.07.76,2.1,2.37,3a9.84,9.84,0,0,0,4.62,1.33h0c.3,0,.61,0,.92,0a18,18,0,0,0,4.95-1.07l1-.33-2.82,2.82v2.6a13.76,13.76,0,0,0,10.79-.47l2.77,1.59,3.34-1.92v-2.6l-1.15-.66A3.08,3.08,0,0,0,287.46,404.43Zm-7-.22a7.85,7.85,0,0,1-.77.38,7.17,7.17,0,0,1-5.46.08c2.61-.92,4.8-1.73,6.66-.73C280.71,404,280.57,404.12,280.41,404.21Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.42,398h0c-1.14.29-2.23.67-3.23,1a31.1,31.1,0,0,1-3.47,1.07h0a6.13,6.13,0,0,1-1.65.16,3.53,3.53,0,0,1-1.59-.47c-1.07-.62-1.23-1.53.33-2.56l.35-.21a5.91,5.91,0,0,1,.91-.45,6.29,6.29,0,0,1,4.85-.11l2.8-2.83a13.28,13.28,0,0,0-7.65-.27,14.29,14.29,0,0,0-2.43.84l-2.8-1.62-3.34,1.93,2.77,1.6,0,0c-2.81,2.13-2.86,4.35.29,6.17a9.84,9.84,0,0,0,4.62,1.33h0c.3,0,.61,0,.92,0a18,18,0,0,0,4.95-1.07c3.21-1.07,5.81-2.33,8-1.09,1.45.84,1.05,1.89-.54,2.81a7.85,7.85,0,0,1-.77.38,7.2,7.2,0,0,1-5.57,0l-2.93,2.94a13.72,13.72,0,0,0,10.79-.46l2.77,1.59,3.34-1.93-2.77-1.59c2.78-2.15,3.1-4.49-.14-6.39l-.06,0A11.18,11.18,0,0,0,276.42,398Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.42,398h0c-1.14.29-2.23.67-3.23,1a31.1,31.1,0,0,1-3.47,1.07h0a6.13,6.13,0,0,1-1.65.16,3.53,3.53,0,0,1-1.59-.47c-1.07-.62-1.23-1.53.33-2.56l.35-.21a5.91,5.91,0,0,1,.91-.45,6.29,6.29,0,0,1,4.85-.11l2.8-2.83a13.28,13.28,0,0,0-7.65-.27,14.29,14.29,0,0,0-2.43.84l-2.8-1.62-3.34,1.93,2.77,1.6,0,0c-2.81,2.13-2.86,4.35.29,6.17a9.84,9.84,0,0,0,4.62,1.33h0c.3,0,.61,0,.92,0a18,18,0,0,0,4.95-1.07c3.21-1.07,5.81-2.33,8-1.09,1.45.84,1.05,1.89-.54,2.81a7.85,7.85,0,0,1-.77.38,7.2,7.2,0,0,1-5.57,0l-2.93,2.94a13.72,13.72,0,0,0,10.79-.46l2.77,1.59,3.34-1.93-2.77-1.59c2.78-2.15,3.1-4.49-.14-6.39l-.06,0A11.18,11.18,0,0,0,276.42,398Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.47 394.45 262.84 392.92 265.61 394.14 262.81 392.52 259.47 394.45",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.65,393.4a15.66,15.66,0,0,1,7.18.24l-1.94,2.76,2.8-2.83A13.35,13.35,0,0,0,267.65,393.4Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,398.75l.06,0c3.24,1.9,2.92,4.24.14,6.39,2.47-2.68,2-4.55-.65-6.1a12.65,12.65,0,0,0-8.2-1.12A11.18,11.18,0,0,1,285.07,398.75Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.27 405.18 287.39 406.81 284.7 408.7 288.04 406.77 285.27 405.18",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.64,404.59a7.23,7.23,0,0,1-5.33.47l-3.17,2.51,2.93-2.94A7.2,7.2,0,0,0,279.64,404.59Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,400a4.3,4.3,0,0,1-4-.38c-1-.83-.35-1.72,1.09-2.49-1.56,1-1.4,1.94-.33,2.56a3.53,3.53,0,0,0,1.59.47A6.13,6.13,0,0,0,269.69,400Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.21,396.07c-.24.21-2.25,2.08-1.36,4s3.89,3.28,6.27,3.53h0a9.84,9.84,0,0,1-4.62-1.33C259.35,400.42,259.4,398.2,262.21,396.07Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.06,390.14a21.26,21.26,0,0,1,7.88-7.28c12.88-7.44,33.75-7.44,46.63,0a21.26,21.26,0,0,1,7.88,7.28h1.78v6.74h0c-.24,4.68-3.45,9.33-9.64,12.9-12.88,7.43-33.75,7.43-46.63,0-6.19-3.57-9.42-8.22-9.66-12.9h0v-6.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.06,390.14a21.26,21.26,0,0,1,7.88-7.28c12.88-7.44,33.75-7.44,46.63,0a21.26,21.26,0,0,1,7.88,7.28h1.78v6.74h0c-.24,4.68-3.45,9.33-9.64,12.9-12.88,7.43-33.75,7.43-46.63,0-6.19-3.57-9.42-8.22-9.66-12.9h0v-6.74Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.25,377.28c8.44,0,16.88,1.86,23.32,5.58a21.26,21.26,0,0,1,7.88,7.28h1.78v6.74h0c-.24,4.68-3.45,9.33-9.64,12.9-6.44,3.72-14.88,5.58-23.32,5.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,380.37a36.46,36.46,0,0,1,5.31,2.49,21.26,21.26,0,0,1,7.88,7.28h1.78v6.74h0c-.24,4.68-3.45,9.33-9.64,12.9a36.46,36.46,0,0,1-5.31,2.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.25,380.37a36.46,36.46,0,0,0-5.31,2.49,21.26,21.26,0,0,0-7.88,7.28h-1.78v6.74h0c.24,4.68,3.47,9.33,9.66,12.9a36.46,36.46,0,0,0,5.31,2.49Z",
    style: {
      fill: "#278AFF",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,376.68c12.88,7.44,12.88,19.49,0,26.93-11.26,6.5-28.66,7.31-41.46,2.44h0l-.51-.2a37.14,37.14,0,0,1-4.66-2.24c-10.74-6.2-12.52-15.62-5.35-22.88h0a25.55,25.55,0,0,1,5.35-4C265.82,369.25,286.69,369.25,299.57,376.68Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,376.68c12.88,7.44,12.88,19.49,0,26.93-11.26,6.5-28.66,7.31-41.46,2.44h0l-.51-.2a37.14,37.14,0,0,1-4.66-2.24c-10.74-6.2-12.52-15.62-5.35-22.88h0a25.55,25.55,0,0,1,5.35-4C265.82,369.25,286.69,369.25,299.57,376.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,380.73a14.41,14.41,0,0,0-3.45,11.74c1.14,6.55,10.3,12,13.46,13.38a37.14,37.14,0,0,1-4.66-2.24C242.2,397.41,240.42,388,247.59,380.73Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.92,399.56a14.41,14.41,0,0,0,3.45-11.74c-1.14-6.55-10.3-12.05-13.46-13.38a35.8,35.8,0,0,1,4.66,2.24C310.31,382.88,312.09,392.29,304.92,399.56Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.27,
    cy: 390.12,
    rx: 30.65,
    ry: 17.7,
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.27,
    cy: 390.12,
    rx: 30.65,
    ry: 17.7,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,395.4c-2.47-4.55-1.66-9.57,2.4-13.83a20.14,20.14,0,0,1,2.6-2.27,26,26,0,0,1,2.48-1.64c.49-.29,1-.56,1.51-.82-1.27,2.1-.8,4.35,6.42,4.77,14.12.82-3.78,14.32-3.78,14.32S249.53,391.54,247,395.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,391.67c-2.12-.24-3.18-2.42-2.35-4.87s3.21-4.25,5.33-4,3.17,2.42,2.35,4.87S250.59,391.91,248.47,391.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.81,402.92c.7-5.25,23.63-19.77,23.63-19.77s5.09-2,3.4-5.6a27.26,27.26,0,0,1,2.45,1.59c.53.38,1,.78,1.49,1.18,6.83,5.91,6.84,13.68,0,19.6-.46.4-1,.79-1.49,1.18-.7.51-1.46,1-2.27,1.48s-1.59.87-2.43,1.27c-.67.32-1.37.61-2.07.89s-1.42.54-2.15.78a45.51,45.51,0,0,1-6.84,1.64c-.51.08-1,.16-1.54.22a51.91,51.91,0,0,1-6.84.43,50.56,50.56,0,0,1-8.37-.69S271.47,406.37,270.81,402.92Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.81,402.92c.7-5.25,23.63-19.77,23.63-19.77s5.09-2,3.4-5.6a27.26,27.26,0,0,1,2.45,1.59c.53.38,1,.78,1.49,1.18,6.83,5.91,6.84,13.68,0,19.6-.46.4-1,.79-1.49,1.18-.7.51-1.46,1-2.27,1.48s-1.59.87-2.43,1.27c-.67.32-1.37.61-2.07.89s-1.42.54-2.15.78a45.51,45.51,0,0,1-6.84,1.64c-.51.08-1,.16-1.54.22a51.91,51.91,0,0,1-6.84.43,50.56,50.56,0,0,1-8.37-.69S271.47,406.37,270.81,402.92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,380.79c8.55,4.94,8.9,12.82,1,18-.33.22-.68.44-1.05.65-8.92,5.15-23.37,5.15-32.29,0s-8.92-13.5,0-18.65c.36-.2.74-.41,1.12-.6C270.22,375.65,283.87,375.86,292.43,380.79Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.43,380.79c8.55,4.94,8.9,12.82,1,18-.33.22-.68.44-1.05.65-8.92,5.15-23.37,5.15-32.29,0s-8.92-13.5,0-18.65c.36-.2.74-.41,1.12-.6C270.22,375.65,283.87,375.86,292.43,380.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.27,
    cy: 390.12,
    rx: 21.83,
    ry: 12.6,
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.27,
    cy: 390.12,
    rx: 21.83,
    ry: 12.6,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,384.72c-8.52-4.92-22.34-4.92-30.87,0-3.48,2-5.54,4.54-6.18,7.15.64,2.62,2.7,5.15,6.18,7.16,8.53,4.92,22.35,4.92,30.87,0,3.49-2,5.55-4.54,6.18-7.16C297.25,389.26,295.19,386.73,291.7,384.72Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,384.72c-8.52-4.92-22.34-4.92-30.87,0-3.48,2-5.54,4.54-6.18,7.15.64,2.62,2.7,5.15,6.18,7.16,8.53,4.92,22.35,4.92,30.87,0,3.49-2,5.55-4.54,6.18-7.16C297.25,389.26,295.19,386.73,291.7,384.72Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,393.91c0-.42,0-2.16,0-2.6,0-1.07-.74-2.11-2.33-3l-.05,0a11.2,11.2,0,0,0-8.66-.79h0c-1.15.29-2.24.66-3.23,1a32.1,32.1,0,0,1-3.47,1.08h0a6.17,6.17,0,0,1-1.65.16,3.5,3.5,0,0,1-1.37-.37l.11-.07.34-.21a7.89,7.89,0,0,1,.92-.46,6.34,6.34,0,0,1,4.85-.11l2.8-2.82v-2.59a13.28,13.28,0,0,0-7.65-.28,16.39,16.39,0,0,0-2.44.84L265.37,382,262,383.93v2.6l1.14.66a2.73,2.73,0,0,0-.49,1.51v2.58c0,1.07.77,2.1,2.38,3a9.69,9.69,0,0,0,4.61,1.33h.93a18.48,18.48,0,0,0,4.95-1.07l1-.33-2.82,2.82v2.59a13.71,13.71,0,0,0,10.79-.47l2.77,1.6,3.34-1.93v-2.59l-1.15-.66A3,3,0,0,0,290,393.91Zm-7-.22a7.09,7.09,0,0,1-.78.39,7.17,7.17,0,0,1-5.46.08c2.62-.92,4.8-1.73,6.66-.74Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,387.45h0c-1.15.29-2.24.66-3.23,1a32.1,32.1,0,0,1-3.47,1.08h0a6.17,6.17,0,0,1-1.65.16,3.59,3.59,0,0,1-1.59-.48c-1.08-.62-1.23-1.53.33-2.55l.34-.21a7.89,7.89,0,0,1,.92-.46,6.34,6.34,0,0,1,4.85-.11l2.8-2.82a13.28,13.28,0,0,0-7.65-.28,16.39,16.39,0,0,0-2.44.84L265.37,382,262,383.93l2.76,1.6,0,0c-2.81,2.14-2.87,4.35.29,6.17a9.69,9.69,0,0,0,4.61,1.33h.93a18.48,18.48,0,0,0,4.95-1.07c3.21-1.08,5.8-2.34,8-1.09,1.45.83,1.05,1.88-.54,2.8a7.09,7.09,0,0,1-.78.39,7.17,7.17,0,0,1-5.56,0l-2.93,2.94a13.71,13.71,0,0,0,10.79-.47l2.77,1.6,3.34-1.93-2.77-1.6c2.78-2.15,3.1-4.49-.15-6.39l-.05,0A11.2,11.2,0,0,0,279,387.45Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,387.45h0c-1.15.29-2.24.66-3.23,1a32.1,32.1,0,0,1-3.47,1.08h0a6.17,6.17,0,0,1-1.65.16,3.59,3.59,0,0,1-1.59-.48c-1.08-.62-1.23-1.53.33-2.55l.34-.21a7.89,7.89,0,0,1,.92-.46,6.34,6.34,0,0,1,4.85-.11l2.8-2.82a13.28,13.28,0,0,0-7.65-.28,16.39,16.39,0,0,0-2.44.84L265.37,382,262,383.93l2.76,1.6,0,0c-2.81,2.14-2.87,4.35.29,6.17a9.69,9.69,0,0,0,4.61,1.33h.93a18.48,18.48,0,0,0,4.95-1.07c3.21-1.08,5.8-2.34,8-1.09,1.45.83,1.05,1.88-.54,2.8a7.09,7.09,0,0,1-.78.39,7.17,7.17,0,0,1-5.56,0l-2.93,2.94a13.71,13.71,0,0,0,10.79-.47l2.77,1.6,3.34-1.93-2.77-1.6c2.78-2.15,3.1-4.49-.15-6.39l-.05,0A11.2,11.2,0,0,0,279,387.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "262.03 383.94 265.4 382.41 268.17 383.62 265.37 382.01 262.03 383.94",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,382.89a15.66,15.66,0,0,1,7.18.24l-1.94,2.75,2.8-2.82A13.28,13.28,0,0,0,270.21,382.89Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.63,388.24l.05,0c3.25,1.9,2.93,4.24.15,6.39,2.46-2.68,2-4.55-.66-6.09a12.57,12.57,0,0,0-8.2-1.12A11.2,11.2,0,0,1,287.63,388.24Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.83 394.66 289.95 396.29 287.25 398.19 290.6 396.26 287.83 394.66",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.19,394.08a7.17,7.17,0,0,1-5.32.46l-3.17,2.52,2.93-2.94A7.17,7.17,0,0,0,282.19,394.08Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.25,389.53a4.35,4.35,0,0,1-4-.38c-1-.83-.35-1.72,1.09-2.49-1.56,1-1.41,1.93-.33,2.55a3.59,3.59,0,0,0,1.59.48A6.17,6.17,0,0,0,272.25,389.53Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,385.55c-.24.21-2.25,2.09-1.36,4s3.89,3.28,6.27,3.54h0a9.69,9.69,0,0,1-4.61-1.33C261.9,389.9,262,387.69,264.77,385.55Z",
    style: {
      fill: "#f5f5f5",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.13 386.79 247.96 380.48 248.79 386.79 259.72 387.27 248.79 387.75 247.96 394.06 247.13 387.75 236.21 387.27 247.13 386.79",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.36,393.89l-6.27-15-17.76,7c8.14,9.34,16.82,20.6,18.65,24.55,0,0,9.4-1.36,11.2-6S389.73,395.64,387.36,393.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,400.34a7.52,7.52,0,0,1,1.88,2.39c.53.92,0,5.19.45,7.22s.82,2.59,1.58,5.15c.85,2.83,2.61,5.49-.11,12.42s-6.5,10-9.6,11.56a7.84,7.84,0,0,1-3.64.6s-3.79-1.76-3-4S397.34,400.34,397.34,400.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.68,406.85a8.52,8.52,0,0,0,1.37,2.57,19.58,19.58,0,0,1,2,7.27c1.47,11.39-3.42,16.76,2.31,21.42,1.67,1.23,5.32,1.2,11.36-5.47,3.08-3.4,5.24-10.71,4.39-14.15s-2.19-5.75-2.71-8.39.21-7.43-1.05-9.76a10.25,10.25,0,0,0-3.28-3.27c-1-.73-3.3-1.77-4.35-2.47s-1.59-1.45-2.35-.71l1.14,1.65c1.77,2.87,1.19,3.23,1,4.68a22.38,22.38,0,0,0,.39,4.67c-1.27-1.87-1.73-3.45-3.28-3.3s-1.73.07-4.07,2S379.64,406.2,379.68,406.85Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.68,406.85a8.52,8.52,0,0,0,1.37,2.57,19.58,19.58,0,0,1,2,7.27c1.47,11.39-3.42,16.76,2.31,21.42,1.67,1.23,5.32,1.2,11.36-5.47,3.08-3.4,5.24-10.71,4.39-14.15s-2.19-5.75-2.71-8.39.21-7.43-1.05-9.76a10.25,10.25,0,0,0-3.28-3.27c-1-.73-3.3-1.77-4.35-2.47s-1.59-1.45-2.35-.71l1.14,1.65c1.77,2.87,1.19,3.23,1,4.68a22.38,22.38,0,0,0,.39,4.67c-1.27-1.87-1.73-3.45-3.28-3.3s-1.73.07-4.07,2S379.64,406.2,379.68,406.85Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.71,432.64c3.08-3.4,5.24-10.71,4.39-14.15a30.47,30.47,0,0,0-1.05-3.36c0,.23.08.47.1.67,0,.44.06.88.07,1.32a10.18,10.18,0,0,1-.94,5.05c-.74,1.35-2.46,4.75-4.36,4.69-1.07,0-1.89-1.15-2.22-2.38-.13-.51-.32-1.9-.32-1.9a16.79,16.79,0,0,0-5.05,1.64c-2.88,1.61-2.81,2-2.81,2a7.31,7.31,0,0,1-.08,2.41,6.09,6.09,0,0,1-1.2,2.32,3.71,3.71,0,0,1-.74.5,7.33,7.33,0,0,0,2.85,6.64C387,439.34,390.67,439.31,396.71,432.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,416.69a37.77,37.77,0,0,1,0,9c.82,3,1.72,2.93,2,1.45s-1.29-7.8-2.39-13C382.81,415,382.94,415.87,383,416.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2,399.21a6.28,6.28,0,0,0-.79-4.19l-.7-.42c-1.13-.76-1.59-1.45-2.35-.71l1.14,1.65c1.77,2.87,1.19,3.23,1,4.68a21.72,21.72,0,0,0,.39,4.67c.78,5,1.7,6.66,1.9,11.3s-1,7.67-.32,8,2-.12,2.49-3.79-.66-10-1.59-13S390.82,401.16,391.2,399.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.69,422.93a.44.44,0,0,1-.25.11,11,11,0,0,0-7.67,3.76.46.46,0,1,1-.66-.64,11.89,11.89,0,0,1,8.21-4,.46.46,0,0,1,.52.39A.47.47,0,0,1,392.69,422.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.39,419.05a.44.44,0,0,1-.24.11,12.42,12.42,0,0,0-8.1,4.13.46.46,0,0,1-.67,0,.48.48,0,0,1,0-.67,13.26,13.26,0,0,1,8.62-4.39.47.47,0,0,1,.54.39A.47.47,0,0,1,392.39,419.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.78,414.83a.48.48,0,0,1-.26.12,14.06,14.06,0,0,0-9,4.64.52.52,0,1,1-.74-.73,15.09,15.09,0,0,1,9.63-4.94.52.52,0,0,1,.59.44A.51.51,0,0,1,392.78,414.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.44,411.17a.42.42,0,0,1-.26.12,13.65,13.65,0,0,0-8.85,4.54.51.51,0,0,1-.73-.72,14.67,14.67,0,0,1,9.42-4.82.51.51,0,0,1,.59.42A.54.54,0,0,1,392.44,411.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.37,407.56a.45.45,0,0,1-.25.12,13.69,13.69,0,0,0-8.86,4.54.52.52,0,0,1-.72,0,.51.51,0,0,1,0-.72,14.68,14.68,0,0,1,9.42-4.83.51.51,0,0,1,.58.43A.49.49,0,0,1,391.37,407.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.69,342.53s-38.14-4.51-53.07-4.42c-15.24.1-16.65,11.54-12.84,18.55,7.3,13.41,30.89,40.83,30.89,40.83s9.48-2.87,12.1-10.24L379.82,374,409.36,378l5.37-3.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.66,384.35c3.27-4.18,5.45-5.15,11.35-7.19l3.76,10.09c-2.62,7.37-12.1,10.24-12.1,10.24s-2.72-3.16-6.6-7.86A59.76,59.76,0,0,1,369.66,384.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.78,361.43c1.91,2.84,3.57,5.4,5,7.84S388.57,372.9,393,372a86.14,86.14,0,0,0,15.33-5,20.39,20.39,0,0,1-2-10.16,20.11,20.11,0,0,0,6.78,10.89L412,375.44l-2.13,2.6-25.41-3.5h0l-4.13-.57c-5.24-12.5-7.26-18-13.74-20.56C366.6,353.41,372.13,353,377.78,361.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.81,435.83l13.95-14.9-13.71-11.88c-6.42,9.94-12.67,19.44-16.74,23.09,0,0,2.7,9.1,7.84,9.63S356.71,438.7,357.81,435.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.51,444.79a8.09,8.09,0,0,1-1.88,2.56c-.78.79-5.22,1.48-7.14,2.46s-2.38,1.55-4.74,3c-2.62,1.65-4.81,4.16-12.54,3.35s-11.92-3.73-14.31-6.43a8.2,8.2,0,0,1-1.62-3.5s.72-4.3,3.2-4.16S354.51,444.79,354.51,444.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,428.84c-.73.26-1.67,1.53-2.2,2.08a20.4,20.4,0,0,1-6.77,4c-11.05,4.65-17.82,1.23-20.91,8.29-.77,2,.28,5.69,8.67,9.91,4.28,2.16,12.24,2.29,15.47.48s5.18-3.81,7.69-5.07,7.54-1.86,9.53-3.78a10.94,10.94,0,0,0,2.38-4.21c.45-1.24,1.73-5.48,1.73-5.48-2.4,2.58-4.67,1.55-6.17,1.8a24,24,0,0,0-4.59,1.7c1.53-1.8,3-2.71,2.4-4.22s-.55-1.72-3.11-3.55S343.67,428.6,343,428.84Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,428.84c-.73.26-1.67,1.53-2.2,2.08a20.4,20.4,0,0,1-6.77,4c-11.05,4.65-17.82,1.23-20.91,8.29-.77,2,.28,5.69,8.67,9.91,4.28,2.16,12.24,2.29,15.47.48s5.18-3.81,7.69-5.07,7.54-1.86,9.53-3.78a10.94,10.94,0,0,0,2.38-4.21c.45-1.24,1.73-5.48,1.73-5.48-2.4,2.58-4.67,1.55-6.17,1.8a24,24,0,0,0-4.59,1.7c1.53-1.8,3-2.71,2.4-4.22s-.55-1.72-3.11-3.55S343.67,428.6,343,428.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,453.16c4.28,2.16,12.24,2.29,15.47.48a33.21,33.21,0,0,0,3.09-2c-.23.1-.45.22-.65.29-.43.16-.87.3-1.31.44a10.45,10.45,0,0,1-5.34.46c-1.57-.36-5.47-1.15-5.93-3.08-.27-1.08.62-2.23,1.77-2.89.48-.28,1.82-.86,1.82-.86a17.48,17.48,0,0,0-3.06-4.63c-2.42-2.44-2.81-2.25-2.81-2.25a7.79,7.79,0,0,1-2.45.58,6.31,6.31,0,0,1-2.67-.56,4.32,4.32,0,0,1-.72-.6,7.65,7.65,0,0,0-5.88,4.71C312.38,445.28,313.43,448.94,321.82,453.16Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,435a39.6,39.6,0,0,1-9.06,2.55c-2.74,1.65-2.47,2.56-.92,2.38s7.5-3.48,12.44-6C335.69,434.26,334.86,434.62,334.06,435Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.93,438.3c1.48-.12,2.62,0,3.88-.71.81-.4,1.26-2.24,1.22-3.06l-1.31,1.38c-2.21,1-3.77.74-5.27,1a24,24,0,0,0-4.59,1.7c-4.77,2.17-6.23,3.57-10.85,5.06s-8,1.18-8.11,1.9.67,2,4.51,1.46,9.86-3.45,12.65-5.23S351.87,438.46,353.93,438.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.47,446.41a.52.52,0,0,1-.17-.22,11.55,11.55,0,0,0-5.93-6.67.49.49,0,0,1-.19-.66.48.48,0,0,1,.65-.18,12.39,12.39,0,0,1,6.35,7.14.48.48,0,0,1-.26.63A.51.51,0,0,1,330.47,446.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,445a.46.46,0,0,1-.18-.21,12.91,12.91,0,0,0-6.42-7,.48.48,0,0,1-.18-.68.49.49,0,0,1,.67-.18,13.9,13.9,0,0,1,6.83,7.45.49.49,0,0,1-.72.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,444.24a.48.48,0,0,1-.19-.23,14.65,14.65,0,0,0-7.2-7.81.55.55,0,0,1-.21-.74.54.54,0,0,1,.74-.21,15.75,15.75,0,0,1,7.66,8.32.54.54,0,0,1-.27.71A.55.55,0,0,1,338.65,444.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,442.88a.56.56,0,0,1-.2-.23,14.26,14.26,0,0,0-7-7.64.54.54,0,0,1-.2-.73.52.52,0,0,1,.72-.2,15.27,15.27,0,0,1,7.48,8.13.53.53,0,0,1-.26.71A.54.54,0,0,1,342.24,442.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.58,440.8a.5.5,0,0,1-.2-.23,14.29,14.29,0,0,0-7-7.64.53.53,0,0,1,.52-.93,15.36,15.36,0,0,1,7.49,8.13.54.54,0,0,1-.27.71A.51.51,0,0,1,345.58,440.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.87,420.64c3.34,6,12.37,11,12.37,11s3.84-3.48,13.08-11c6.51-5.29,11.87-10.54,15.71-16.94,11-2.2,29.35-1.2,49.69-9.18,10.15-4,18.6-13.43,20.71-23.33a79,79,0,0,0,1.7-17.78C463,335.27,405,343.8,405,343.8l8.16,23.9s-24.53,9.35-32.89,12.79c-3.83,1.58-4.92,1.53-9.46,7.83C360.41,402.74,349.87,420.64,349.87,420.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6,430l-.72-.48c4.92-4.62,17.3-16.63,21.07-21.72,1.3-1.76,2.32-3.32,3.21-4.71,2.11-3.25,3.51-5.4,6-6,.54-.14,1.85-.4,3.83-.81,10.1-2.07,36.91-7.56,46.22-12.6l.8-.47c-3.19-3.16-2.84-9.21-.4-12.93,2.61-4,4.6-11.89,3.16-15.75l.79-.29c1.68,4.49-.8,12.78-3.24,16.51-2.29,3.49-2.54,9.26.45,12,8.92-5.58,13.41-15.33,13-28.34l.85,0c.43,14.1-4.76,24.49-15,30-9.42,5.1-36.32,10.61-46.45,12.68-1.9.39-3.27.67-3.8.8-2.21.54-3.53,2.57-5.54,5.65-.9,1.4-1.93,3-3.24,4.75C376.67,413.65,364.16,425.7,359.6,430Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M420.31,287c-9,0-12,5.28-12.83,10.21-.92,5.66-1.84,19.36-1.84,19.36l-12.9,10.45,7.89,10.49s9.94-5.17,13.89-7.52c4.83-2.88,4.61-4.93,5.13-12.72S420.77,291.49,420.31,287Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M463.13,362.89c-.21-2.18,2-22.63,0-39.47-.65-5.4-6.55-28.23-8-32.26l-10.71-2.79s-9.29-.95-20.76-1.29l-3.38,0c-.71.75-11,9.15-14.15,18.29-1.81,5.2-2.32,14,3.76,18.51,0,0,.91,9.11.92,9.18s-3,9.08-4,11.1c1.41,9,9.59,16.55,24.83,19.72C450,367.65,462,363.58,463.13,362.89Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.13,362.89c-.21-2.18,2-22.63,0-39.47-.65-5.4-6.55-28.23-8-32.26l-10.71-2.79s-9.29-.95-20.76-1.29l-3.38,0c-.71.75-11,9.15-14.15,18.29-1.81,5.2-2.32,14,3.76,18.51,0,0,.91,9.11.92,9.18s-3,9.08-4,11.1c1.41,9,9.59,16.55,24.83,19.72C450,367.65,462,363.58,463.13,362.89Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.17,328.75s4.39,5.3,13,4.26a15.9,15.9,0,0,0,12.21-8.07s-1.2,9.25-11.81,10.54A12.79,12.79,0,0,1,422.17,328.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.29,372.63l-.07,1a2.87,2.87,0,0,1-1.59,2.4l-28.44,14a2.86,2.86,0,0,1-1.46.29,2.77,2.77,0,0,1-1.41-.48l-48.38-32.3a2.87,2.87,0,0,1-1.28-2.58l0-.7,51.14,34.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,354.26,379.64,339a1.69,1.69,0,0,1,1.71.12l49.77,33.23a.38.38,0,0,1-.05.66l-31.22,15.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.29 385.9 416.98 377.67 371.73 347.46 354.97 355.63 400.29 385.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.88 360.62 409.57 360.77 401.39 364.8 387.91 355.8 387.63 355.61 396.11 351.43 409.88 360.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.57 360.77 401.39 364.8 387.91 355.8 396.09 351.76 409.57 360.77",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,388.41l-.12,1.91a2.77,2.77,0,0,1-1.41-.48l-48.38-32.3a2.87,2.87,0,0,1-1.28-2.58l0-.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.85,388.41l-.12,1.91a2.77,2.77,0,0,1-1.41-.48l-48.38-32.3a2.87,2.87,0,0,1-1.28-2.58l0-.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.47,348.29C364,346,366,344,367.39,341.64a40,40,0,0,1,4.61-4.2c4.73-3.5,6-3.43,12-5.44a26.32,26.32,0,0,0,8.78-4.94l7.89,10.49c-.88.51-1.73,1-2.55,1.55-1.34.86-3.05,3.91-6.11,5.12-4,1.61-8.85.62-9.28,1.81a8.6,8.6,0,0,1-.27,2.22,7.62,7.62,0,0,1,2.37-.66c.75,0,1.83.85,1.62,1.37s-.68.73-1.21,1.16c-.37.31-1.61,1.35-1.78,1.47a7.27,7.27,0,0,1-3.8.66,1.67,1.67,0,0,1-1.26-1.07,6.91,6.91,0,0,1-.87.32,2.26,2.26,0,0,1-1.66-.08,1.36,1.36,0,0,1-.55-.78,6.87,6.87,0,0,1-2-.37c-.9-.49-.93-1.6-1.11-2.49a11.21,11.21,0,0,1-.18-3.37c-2.69,1.71-4.76,4.84-8.05,5.47C362.73,350.06,361.21,349.64,362.47,348.29Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.43,337.83c-1.41-13.13-2.78-25-4.84-34.62-1.13-5.31-4.85-11-12.43-12-7.34,4.53-5.3,19.84-4.55,23.57l4.07,23.12s-4.58,3.54-11.28,7.81c-5.66,3.61-9.38,6.53-15.81,6.86s-9,0-12.42,1.18c-1.82.65-6,2.17-7.4,2.78s-4.06,2.93-6.46,4.46.36,2.7,2.06,2.32a21.53,21.53,0,0,0,5.18-2.1A29.13,29.13,0,0,1,413,359.8a25.93,25.93,0,0,0-1.25,5c-.06.92-.34,2,.42,2.74a6.73,6.73,0,0,0,1.86.92,1.42,1.42,0,0,0,.33.91,2.24,2.24,0,0,0,1.6.53,6.09,6.09,0,0,0,.94-.08,1.7,1.7,0,0,0,.95,1.4,7.41,7.41,0,0,0,3.9.39c.2-.07,1.7-.75,2.15-.95a3.76,3.76,0,0,0,1.5-.81c.35-.45-.47-1.62-1.22-1.79a7.71,7.71,0,0,0-2.5,0,8.52,8.52,0,0,0,.87-2.1c.75-1,5.58.39,10-.07,3.32-.35,5.9-3.32,7.42-3.89,9.74-3.63,15.35-5.08,25.28-10.21C474.26,347.07,473.16,344.65,472.43,337.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.09,360c.59-1.21,1.46-2.63,2.43-2.91A10.9,10.9,0,0,0,413,359.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,368.42a10.71,10.71,0,0,1,.1-2.71,24.06,24.06,0,0,1,.53-2.66,11.55,11.55,0,0,1,.9-2.57,4.93,4.93,0,0,1,1.77-2.06,3.6,3.6,0,0,0-.81,1.05,7.22,7.22,0,0,0-.59,1.18,17.27,17.27,0,0,0-.77,2.53c-.23.87-.43,1.74-.64,2.6A26.63,26.63,0,0,0,414,368.42Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.86,369.78a11.74,11.74,0,0,1,.18-2.65,21.31,21.31,0,0,1,.57-2.61,17.42,17.42,0,0,1,.89-2.51,5.15,5.15,0,0,1,1.51-2.19,3.51,3.51,0,0,0-.67,1.11c-.17.4-.33.81-.47,1.23-.27.83-.53,1.66-.76,2.51C417.63,366.35,417.18,368,416.86,369.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.14,368a4.38,4.38,0,0,0-1.11.09c-.36.06-.62.22-1.07.33l.2-.27a1.05,1.05,0,0,1-.11.52,1.21,1.21,0,0,1-.28.39,1.57,1.57,0,0,1-.78.44,4,4,0,0,0,.5-.65,2.92,2.92,0,0,0,.13-.34.86.86,0,0,0,0-.3V368l.21-.07a3.2,3.2,0,0,1,1-.15A2.3,2.3,0,0,1,424.14,368Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399,388.78a3.4,3.4,0,0,1-2.92-.42L347.93,356.2a3.4,3.4,0,0,1-1.5-2.49l-3.35-33a3.51,3.51,0,0,1,0-.56,3.46,3.46,0,0,1,1.16-2.36l50.06,33.43A2.55,2.55,0,0,1,395.4,353Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399,388.78a3.4,3.4,0,0,1-2.92-.42L347.93,356.2a3.4,3.4,0,0,1-1.5-2.49l-3.35-33a3.51,3.51,0,0,1,0-.56,3.46,3.46,0,0,1,1.16-2.36l50.06,33.43A2.55,2.55,0,0,1,395.4,353Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,388.41l-.35.17a3.26,3.26,0,0,1-.48.2L395.4,353a2.55,2.55,0,0,0-1.11-1.84l-50.06-33.43a3.54,3.54,0,0,1,.73-.48l50.16,33.49a2.52,2.52,0,0,1,1.11,1.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.79,356.78c-.22-2.22-2.29-5.27-4.62-6.82s-4-1-3.81,1.19,2.29,5.26,4.62,6.82S373,359,372.79,356.78Z",
    style: {
      fill: "#278AFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.58,249.58c.06.26,1.5,1,1.77,1.24a8.12,8.12,0,0,1,1.35,1.52,11,11,0,0,1,1.56,4.1c.49,2.45.44,4.95.69,7.43a47.77,47.77,0,0,0,1.44,7.08,24,24,0,0,1,1,6.28,8.15,8.15,0,0,1-2.22,5.79,13.76,13.76,0,0,0-.16-6.35,12.92,12.92,0,0,1-.71,3.9,9.14,9.14,0,0,1-4.23,4.45,23.46,23.46,0,0,1-5.9,2.05,42.14,42.14,0,0,1-10.12,1.22c-2.1,0-4.21-.13-6.3-.35a18.13,18.13,0,0,1-7.77-2.22c-2.31-1.44-4.08-4-3.87-6.72a8,8,0,0,0-1,4.36,8.6,8.6,0,0,1-2.2-6,14.91,14.91,0,0,1,1.63-6.29,31.39,31.39,0,0,0,1.73-3.78,5.35,5.35,0,0,0,.06-3.7c-.38-.76-1-1.46-1.41-2.24a14,14,0,0,1-1.74-6.93c.24-5,3-11.53,12-13.77C432.75,238.79,447.31,239.82,449.58,249.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.1,275.23a5.71,5.71,0,0,0,5-2.12c2.56-3,2.69-6,1.35-7.9-1.09-1.57-3.67-2.49-5.41-1.32s-1.87,2.2-2.53,3.55-2.55.4-2.16-4.93c-3.76-1.55-3.43-7.65-5.53-10-3.29-3.74-8.39-2.51-10-1.53a6.81,6.81,0,0,0-7-.14c-2.43,1.41-4,4.22-4.43,13.69-.48,9.66,1.48,16,3.83,17.93,1.62,1.34,4.55,2.16,8,1.82l.13,3.62s-9.51,10.62,3.14,9.15a20,20,0,0,0,14-8.62l-.55-14.58S444.19,275,446.1,275.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.19,274.43a2.84,2.84,0,0,0,3.43,2,2.79,2.79,0,0,0,2.08-3.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.76,274a2.79,2.79,0,0,1-3.14,2.51A2.86,2.86,0,0,1,430.76,274Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.83,258.35l3.61-1.35a1.88,1.88,0,0,0-2.44-1.14A2,2,0,0,0,417.83,258.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,256.71l3.72,1.78a1.94,1.94,0,0,0-.88-2.7A2.19,2.19,0,0,0,431.3,256.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,260.8a2.55,2.55,0,0,0,.64,1.44,1.1,1.1,0,0,1,.25.52,24,24,0,0,0,.81,3.92,4.3,4.3,0,0,0,4.41,2.72,7.18,7.18,0,0,0,1.54-.15l.12,0a5,5,0,0,0,1.27-.49l.08,0,.11-.07.14-.08.13-.09.14-.11.13-.11.25-.23a5.92,5.92,0,0,0,1.07-1.52c.72-1.39.63-3.31,1.72-3.55l.13,0h.14c1.46,0,1.2,2.1,1.95,3.58s2,2.93,5.21,2.92h.41l.32,0a5.7,5.7,0,0,0,.77-.11l.24-.06.23-.06.15-.05a4.76,4.76,0,0,0,.88-.39l.29-.19a4.07,4.07,0,0,0,.52-.41,5.33,5.33,0,0,0,1-1.41,24.2,24.2,0,0,0,1-3.92,1.78,1.78,0,0,1,.27-.57,2.83,2.83,0,0,0,.78-1.42,1.15,1.15,0,0,0-.83-1.22l-.77-.08a25.13,25.13,0,0,0-7.72.21c-2.47.67-3.35,1.42-4.72,1.42s-2.06-.75-4.35-1.42a22.15,22.15,0,0,0-7.21-.23l-.72.08A1.24,1.24,0,0,0,412.42,260.8Zm16,1.16a2.13,2.13,0,0,1,.72-.55l.12-.06.07,0,.36-.16L430,261a8.21,8.21,0,0,1,1.06-.33l.42-.1c.35-.07.72-.13,1.08-.17l.25,0c2.36-.21,3.81.28,4.32.72s.2,2.5-.07,3.54a.24.24,0,0,0,0,.08.19.19,0,0,0,0,.08c0,.12-.08.27-.12.42l-.09.26h0a2.94,2.94,0,0,1-.17.43h0l-.07.14-.05.09a.31.31,0,0,1-.05.1l-.07.13-.09.14-.1.14-.11.15a4,4,0,0,1-3.35,1.51,4.49,4.49,0,0,1-3.42-1.18h0a4.18,4.18,0,0,1-1-2.06C428.07,263.94,428,262.59,428.45,262Zm-13.8-.85a2.08,2.08,0,0,1,.59-.35l0,0,.26-.1.16-.05.13,0,.09,0h0l.13,0,.54-.1.3,0h1c.33,0,.69,0,1.08.08,1.67.2,3.39.9,3.82,1.54s.26,2,0,3.13a5.2,5.2,0,0,1-.24.78l0,.06,0,.08s0,0,0,.05l-.05.09a1.14,1.14,0,0,1-.1.19l-.09.17,0,.06-.07.11-.07.09v0a4.05,4.05,0,0,1-3.56,1.55,3.77,3.77,0,0,1-3.89-3.69C414.36,263.61,414.13,261.57,414.65,261.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.63,269.77l5.47,2.05L427,265c-.24-1-.48-2-1.37-2.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6,260.35l8.45,3.54a9,9,0,0,0-1.23,1.06l-7.36-2.9Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M418.06,263.73c-.26.85.33,1.11,1.15,1.36s1.56.41,1.82-.45a1.58,1.58,0,0,0-1-2A1.61,1.61,0,0,0,418.06,263.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,262.93a4.06,4.06,0,0,0-1.19-.39,3.46,3.46,0,0,0-1.2,0,3.86,3.86,0,0,0-1.22.4s-.05.1,0,.1c.33,0,.62-.11,1.09-.15a6.15,6.15,0,0,1,1.36.12,5.65,5.65,0,0,1,1.55.52l.5.26c.05,0,.08-.09.06-.13A2.67,2.67,0,0,0,420.81,262.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76,263.61c.22.87-.39,1.09-1.22,1.31s-1.57.32-1.8-.54a1.58,1.58,0,0,1,1.11-1.95A1.6,1.6,0,0,1,433.76,263.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,262.68a4.2,4.2,0,0,1,1.2-.33,3.51,3.51,0,0,1,1.21,0,3.92,3.92,0,0,1,1.19.45s.05.11,0,.1c-.32-.06-.61-.14-1.08-.19a5.62,5.62,0,0,0-1.36.05,5.91,5.91,0,0,0-1.58.44l-.51.23c-.05,0-.08-.09-.05-.13A2.65,2.65,0,0,1,431.05,262.68Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.18,284.24c4.95-.4,11.53-2.42,13.18-5.64-.85,3.43-4.27,5.34-7,6.23a29.78,29.78,0,0,1-6,1.3Z",
    style: {
      fill: "#f28f8f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shopping-cart-list--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.44,70.13l-31.19,18c-.41.24-.75.82-.75,1.93V216.85a1.64,1.64,0,0,0,.75,1.3l3,1.68a1.63,1.63,0,0,0,1.49,0l31.2-18a1.66,1.66,0,0,0,.74-1.3V73.09a1.63,1.63,0,0,0-.75-1.28l-3-1.69A1.68,1.68,0,0,0,369.44,70.13Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.44,70.13l-31.19,18c-.41.24-.75.82-.75,1.93V216.85a1.64,1.64,0,0,0,.75,1.3l3,1.68a1.63,1.63,0,0,0,1.49,0l31.2-18a1.66,1.66,0,0,0,.74-1.3V73.09a1.63,1.63,0,0,0-.75-1.28l-3-1.69A1.68,1.68,0,0,0,369.44,70.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,219.82a1.66,1.66,0,0,1-1.49,0l-3-1.69a1.58,1.58,0,0,1-.75-1.29V90.1a2.93,2.93,0,0,1,.26-1.39l4.43,2.55A1.34,1.34,0,0,0,342,92v127.4C342,219.84,342.27,220.08,342.71,219.82Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.46,108.39c-.47-.28-4-2.29-4.15-2.36a.69.69,0,0,1-.15-1.06l6.34-7.27,4.47,2.56-6.64,7.09A.7.7,0,0,0,335.46,108.39Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.46,108.39c-.47-.28-4-2.29-4.15-2.36a.69.69,0,0,1-.15-1.06l6.34-7.27,4.47,2.56-6.64,7.09A.7.7,0,0,0,335.46,108.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.91,72.66l-31.2,18A1.66,1.66,0,0,0,342,92v8.27l-6.64,7.08a.67.67,0,0,0,.43,1.15L342,108h0V219.39c0,.48.33.67.74.43l31.2-18a1.66,1.66,0,0,0,.74-1.3V73.09C374.65,72.62,374.32,72.43,373.91,72.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.9,73.53v127a.94.94,0,0,1-.37.65L342.72,219V107.23l-.81.06-5.9.43,6.51-7,.2-.21V92a.94.94,0,0,1,.37-.64L373.9,73.53m.34-1a.63.63,0,0,0-.33.1l-31.2,18A1.66,1.66,0,0,0,342,92v8.27l-6.64,7.08a.67.67,0,0,0,.43,1.15L342,108h0V219.39c0,.34.17.54.41.54a.68.68,0,0,0,.33-.11l31.2-18a1.66,1.66,0,0,0,.74-1.3V73.09c0-.33-.17-.53-.41-.53Z",
    style: {
      fill: "#278AFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.79,191.58a2.35,2.35,0,0,0-2.3.22l-17.57,9.84a7,7,0,0,0-3.27,5.49,2.21,2.21,0,0,0,1,2.06l1.64.92a2.33,2.33,0,0,0,2.3-.23l17.57-9.83a7,7,0,0,0,3.27-5.5,2.2,2.2,0,0,0-1-2.06Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.79,191.58a2.35,2.35,0,0,0-2.3.22l-17.57,9.84a7,7,0,0,0-3.27,5.49,2.21,2.21,0,0,0,1,2.06l1.64.92a2.33,2.33,0,0,0,2.3-.23l17.57-9.83a7,7,0,0,0,3.27-5.5,2.2,2.2,0,0,0-1-2.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.19,210.07l-1.58-.88a2.2,2.2,0,0,1-1-2.05,7,7,0,0,1,1.92-4.42l1.64.91a6.92,6.92,0,0,0-1.92,4.42A2.23,2.23,0,0,0,348.19,210.07Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.19,210.07l-1.58-.88a2.2,2.2,0,0,1-1-2.05,7,7,0,0,1,1.92-4.42l1.64.91a6.92,6.92,0,0,0-1.92,4.42A2.23,2.23,0,0,0,348.19,210.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.12,192.72l-17.57,9.83a7,7,0,0,0-3.27,5.5c0,2,1.47,2.85,3.27,1.83l17.57-9.83a7,7,0,0,0,3.27-5.5C371.39,192.53,369.93,191.7,368.12,192.72Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.94,204.47a3.52,3.52,0,0,1,.09-.64,2.23,2.23,0,0,1,.2-.6,2.33,2.33,0,0,1,.34-.52,1.91,1.91,0,0,1,.49-.4,1,1,0,0,1,.48-.15.46.46,0,0,1,.34.14.88.88,0,0,1,.21.37,2.2,2.2,0,0,1,.08.55c0,.07,0,.15,0,.24V204c0,.09,0,.17,0,.25a3.5,3.5,0,0,1-.08.64,2.51,2.51,0,0,1-.21.6,2.22,2.22,0,0,1-.34.52,1.79,1.79,0,0,1-.48.39.88.88,0,0,1-.49.15.47.47,0,0,1-.34-.13.77.77,0,0,1-.2-.37,2.26,2.26,0,0,1-.09-.55v-1Zm1.72-.93a.72.72,0,0,0-.18-.54.36.36,0,0,0-.42,0,1.07,1.07,0,0,0-.43.46,1.71,1.71,0,0,0-.17.73c0,.15,0,.31,0,.49s0,.33,0,.47a.69.69,0,0,0,.17.53c.11.09.25.08.43,0a1,1,0,0,0,.42-.46,1.67,1.67,0,0,0,.18-.73c0-.14,0-.3,0-.48S354.67,203.68,354.66,203.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,200.8c.31-.17.55-.2.72-.07a1,1,0,0,1,.24.77,2.45,2.45,0,0,1-.12.78,1.88,1.88,0,0,1-.38.64l.53,1.11s0,0,0,.06a.22.22,0,0,1,0,.1.13.13,0,0,1-.06.07l-.32.18c-.05,0-.09,0-.11,0l-.05-.07-.5-1-.5.29v1.32a.27.27,0,0,1,0,.12.35.35,0,0,1-.07.09l-.31.17a.06.06,0,0,1-.07,0,.12.12,0,0,1,0-.09v-3.66a.27.27,0,0,1,0-.12.22.22,0,0,1,.07-.09Zm-.57,2.11.55-.31a.93.93,0,0,0,.34-.31.82.82,0,0,0,.13-.5c0-.21,0-.33-.13-.35a.44.44,0,0,0-.34.08l-.55.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,199.35a1.11,1.11,0,0,1,.49-.16.46.46,0,0,1,.34.12.82.82,0,0,1,.21.37,2.53,2.53,0,0,1,.09.6q0,.41,0,.84a3.83,3.83,0,0,1-.09.69,2.74,2.74,0,0,1-.21.61,2,2,0,0,1-.81.89l-1,.53s-.05,0-.07,0a.12.12,0,0,1,0-.09v-3.66a.28.28,0,0,1,0-.13s0-.07.07-.08Zm.62,1.22a.91.91,0,0,0-.05-.31.42.42,0,0,0-.11-.21.29.29,0,0,0-.2-.07.6.6,0,0,0-.28.09l-.51.28v2.55l.53-.29a1.13,1.13,0,0,0,.27-.22,1.38,1.38,0,0,0,.19-.28,1.35,1.35,0,0,0,.11-.34,1.49,1.49,0,0,0,.05-.36Q360.08,201,360.06,200.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.93,200.65a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09v.4a.27.27,0,0,1,0,.12.17.17,0,0,1-.07.09l-1.67.93a0,0,0,0,1-.07,0,.12.12,0,0,1,0-.09v-3.66a.31.31,0,0,1,0-.13.19.19,0,0,1,.07-.08l1.64-.92a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09v.4a.27.27,0,0,1,0,.12.17.17,0,0,1-.07.09l-1.23.69v.9l1.14-.64a.06.06,0,0,1,.08,0,.12.12,0,0,1,0,.09v.41a.27.27,0,0,1,0,.12.24.24,0,0,1-.08.09l-1.14.63v1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,196.41c.32-.17.56-.2.73-.07a1,1,0,0,1,.24.77,2.2,2.2,0,0,1-.13.78,1.71,1.71,0,0,1-.37.64l.52,1.11a.14.14,0,0,1,0,.06.22.22,0,0,1,0,.1l-.06.07-.32.18s-.09,0-.11,0a.23.23,0,0,1-.05-.07l-.5-1.05-.5.29v1.32a.27.27,0,0,1,0,.12.24.24,0,0,1-.08.09l-.3.17a.06.06,0,0,1-.07,0s0,0,0-.09v-3.66a.27.27,0,0,1,0-.12.22.22,0,0,1,.07-.09Zm-.56,2.11.55-.31a.93.93,0,0,0,.34-.31.82.82,0,0,0,.13-.5c0-.21,0-.33-.13-.35a.44.44,0,0,0-.34.08l-.55.31Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.48,188.9a.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11v.47a.4.4,0,0,1,0,.15.21.21,0,0,1-.08.1l-.78.44v3.64a.4.4,0,0,1,0,.15.29.29,0,0,1-.08.1l-.35.2a.07.07,0,0,1-.09,0,.18.18,0,0,1,0-.11v-3.64l-.78.45a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1v-.47a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.59,189.38a.88.88,0,0,1,.43-.13.48.48,0,0,1,.33.12.81.81,0,0,1,.23.33,1.94,1.94,0,0,1,.09.52.66.66,0,0,1,0,.15v.37a.66.66,0,0,1,0,.15,2.76,2.76,0,0,1-.1.63,2.47,2.47,0,0,1-.22.59,2.41,2.41,0,0,1-.33.5,1.62,1.62,0,0,1-.43.36.78.78,0,0,1-.43.13.52.52,0,0,1-.33-.11.77.77,0,0,1-.22-.34,1.49,1.49,0,0,1-.1-.51s0-.09,0-.15v-.36c0-.07,0-.12,0-.16a3.18,3.18,0,0,1,.32-1.22,2.23,2.23,0,0,1,.33-.51A1.62,1.62,0,0,1,349.59,189.38Zm.52,1.2a1,1,0,0,0-.06-.31.24.24,0,0,0-.12-.14.22.22,0,0,0-.16,0,.67.67,0,0,0-.18.07l-.18.13a1.75,1.75,0,0,0-.16.2,2,2,0,0,0-.12.29,2,2,0,0,0-.06.38s0,.08,0,.14v.33c0,.06,0,.1,0,.13a1,1,0,0,0,.06.3.38.38,0,0,0,.12.15.22.22,0,0,0,.16,0,.45.45,0,0,0,.18-.07,1,1,0,0,0,.18-.13.83.83,0,0,0,.16-.2,1.1,1.1,0,0,0,.12-.29,1.89,1.89,0,0,0,.06-.38.45.45,0,0,0,0-.13v-.33A.45.45,0,0,0,350.11,190.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,190.32a.42.42,0,0,0,.07.29s.14,0,.26,0l.27-.15a.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11V191a.32.32,0,0,1,0,.14.17.17,0,0,1-.08.1l-.32.19c-.27.15-.48.17-.62.06s-.22-.39-.22-.8v-1.43l-.29.16a.06.06,0,0,1-.08,0,.18.18,0,0,1,0-.11v-.44a.32.32,0,0,1,0-.14.17.17,0,0,1,.08-.1l.29-.17v-1.08a.4.4,0,0,1,0-.15.29.29,0,0,1,.08-.1l.33-.19a.08.08,0,0,1,.08,0,.12.12,0,0,1,0,.11v1.08l.55-.32a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.11v.44a.35.35,0,0,1,0,.14s-.05.09-.09.1l-.55.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,188.31a2.1,2.1,0,0,1,.08-.35,2.66,2.66,0,0,1,.17-.4,3.16,3.16,0,0,1,.28-.39,1.72,1.72,0,0,1,.39-.31,1.07,1.07,0,0,1,.4-.14.4.4,0,0,1,.3.09.59.59,0,0,1,.2.32,2.19,2.19,0,0,1,.07.56v1.95a.42.42,0,0,1,0,.15.21.21,0,0,1-.08.1l-.33.19a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1v-.22a1.94,1.94,0,0,1-.27.48,1.32,1.32,0,0,1-.43.38.83.83,0,0,1-.33.12.36.36,0,0,1-.25-.08.55.55,0,0,1-.15-.24,1.06,1.06,0,0,1-.05-.38,1.74,1.74,0,0,1,.21-.84,2.57,2.57,0,0,1,.56-.68l.71-.59c0-.18,0-.29-.12-.32a.33.33,0,0,0-.29.06.61.61,0,0,0-.17.14,1.18,1.18,0,0,0-.11.19.41.41,0,0,1-.08.12l-.07.06-.4.23s-.05,0-.07,0S353,188.36,353,188.31Zm.72,1.46a1.09,1.09,0,0,0,.26-.22,1.38,1.38,0,0,0,.19-.28,1.88,1.88,0,0,0,.12-.3,1.65,1.65,0,0,0,0-.3v-.06l-.59.49a1.33,1.33,0,0,0-.26.29.55.55,0,0,0-.07.28c0,.1,0,.15.09.16A.56.56,0,0,0,353.76,189.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.06,189a.32.32,0,0,1,0,.14c0,.05,0,.09-.09.1l-.32.19a.07.07,0,0,1-.09,0,.16.16,0,0,1,0-.11V185a.4.4,0,0,1,0-.15.22.22,0,0,1,.09-.1l.32-.19s.06,0,.09,0a.13.13,0,0,1,0,.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,180.16a.55.55,0,0,1,.28,0,.43.43,0,0,1,.2.11.52.52,0,0,1,.12.19.87.87,0,0,1,.05.22.2.2,0,0,1,0,.11.12.12,0,0,1-.06.08l-.22.13s-.07,0-.08,0a.1.1,0,0,1-.05-.06.32.32,0,0,0-.15-.13.42.42,0,0,0-.29.08.61.61,0,0,0-.16.12.93.93,0,0,0-.13.15.76.76,0,0,0-.09.18.58.58,0,0,0,0,.19.32.32,0,0,0,0,.16.17.17,0,0,0,.12.06.79.79,0,0,0,.2,0l.3-.07a1.05,1.05,0,0,1,.33,0,.36.36,0,0,1,.21.08.44.44,0,0,1,.13.21,1.65,1.65,0,0,1,0,.34,1.31,1.31,0,0,1-.05.39,1.34,1.34,0,0,1-.14.38,1.86,1.86,0,0,1-.22.35,2.13,2.13,0,0,1-.3.3V184a.22.22,0,0,1,0,.11.28.28,0,0,1-.06.08l-.26.15s-.05,0-.06,0a.1.1,0,0,1,0-.08v-.33a.93.93,0,0,1-.27,0,.52.52,0,0,1-.22-.07.47.47,0,0,1-.15-.19.84.84,0,0,1-.07-.31.26.26,0,0,1,0-.11.14.14,0,0,1,.06-.07l.22-.13s.07,0,.09,0a.09.09,0,0,1,0,.06l.06.1a.15.15,0,0,0,.09.06.18.18,0,0,0,.13,0,.69.69,0,0,0,.21-.09l.18-.13.16-.16a1.28,1.28,0,0,0,.11-.2.46.46,0,0,0,0-.21.21.21,0,0,0-.05-.15.17.17,0,0,0-.13,0,.74.74,0,0,0-.23,0l-.31.06a.94.94,0,0,1-.28,0,.33.33,0,0,1-.2-.08.53.53,0,0,1-.12-.21,1.86,1.86,0,0,1,0-.36,1.72,1.72,0,0,1,0-.39,2.79,2.79,0,0,1,.14-.37,1.38,1.38,0,0,1,.2-.33,1.76,1.76,0,0,1,.26-.28v-.33a.2.2,0,0,1,0-.11.12.12,0,0,1,.06-.08l.26-.15a0,0,0,0,1,.06,0s0,0,0,.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58,178.55a.46.46,0,0,1,.28,0,.47.47,0,0,1,.2.1.62.62,0,0,1,.12.19.86.86,0,0,1,.05.23.23.23,0,0,1,0,.11.14.14,0,0,1-.06.07l-.22.13s-.07,0-.08,0a.12.12,0,0,1,0-.05.27.27,0,0,0-.15-.13c-.07,0-.16,0-.29.07a1,1,0,0,0-.16.12,1,1,0,0,0-.13.16.56.56,0,0,0-.09.17.68.68,0,0,0,0,.19.3.3,0,0,0,0,.16.14.14,0,0,0,.12.06.5.5,0,0,0,.2,0l.3-.07a1,1,0,0,1,.33,0,.3.3,0,0,1,.21.08.36.36,0,0,1,.13.21,1.55,1.55,0,0,1,0,.33,1.31,1.31,0,0,1-.05.39,1.34,1.34,0,0,1-.14.38,1.38,1.38,0,0,1-.22.35,2.13,2.13,0,0,1-.3.3v.34a.23.23,0,0,1,0,.11.22.22,0,0,1-.06.07l-.26.15h-.06a.11.11,0,0,1,0-.08v-.34a.68.68,0,0,1-.27,0,.38.38,0,0,1-.22-.07.36.36,0,0,1-.15-.19.83.83,0,0,1-.07-.3.2.2,0,0,1,0-.11.12.12,0,0,1,.06-.08l.22-.13a.1.1,0,0,1,.09,0s0,0,0,.06l.06.09a.16.16,0,0,0,.09.07h.13a.69.69,0,0,0,.21-.09,1,1,0,0,0,.18-.13.81.81,0,0,0,.16-.16,1.18,1.18,0,0,0,.11-.19.78.78,0,0,0,0-.22.21.21,0,0,0-.05-.15.17.17,0,0,0-.13,0l-.23,0-.31.07a.94.94,0,0,1-.28,0,.34.34,0,0,1-.2-.09.53.53,0,0,1-.12-.21,1.73,1.73,0,0,1,0-.36,1.58,1.58,0,0,1,0-.38,2.35,2.35,0,0,1,.14-.37,1.45,1.45,0,0,1,.2-.34,2.23,2.23,0,0,1,.26-.27v-.34a.23.23,0,0,1,0-.11.09.09,0,0,1,.06-.07l.26-.15a0,0,0,0,1,.06,0s0,0,0,.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.38,176.93a.55.55,0,0,1,.28,0,.4.4,0,0,1,.2.11.57.57,0,0,1,.12.18,1,1,0,0,1,0,.23.2.2,0,0,1,0,.11.14.14,0,0,1-.06.07l-.22.13s-.07,0-.09,0l-.05-.06a.25.25,0,0,0-.14-.13.37.37,0,0,0-.29.08.61.61,0,0,0-.16.12.64.64,0,0,0-.13.15.76.76,0,0,0-.09.18.57.57,0,0,0,0,.18.37.37,0,0,0,0,.17.2.2,0,0,0,.12.06l.2,0,.3-.07a1,1,0,0,1,.32,0,.35.35,0,0,1,.34.29,1.09,1.09,0,0,1,0,.34,1.31,1.31,0,0,1,0,.39,2,2,0,0,1-.14.38,1.86,1.86,0,0,1-.22.35,1.64,1.64,0,0,1-.3.29v.34a.43.43,0,0,1,0,.11.22.22,0,0,1-.06.07l-.26.15s-.05,0-.06,0a.1.1,0,0,1,0-.08v-.34a.54.54,0,0,1-.27,0,.32.32,0,0,1-.22-.07.34.34,0,0,1-.15-.18.89.89,0,0,1-.07-.31.43.43,0,0,1,0-.11.12.12,0,0,1,.07-.07l.22-.13s.07,0,.09,0a.15.15,0,0,1,0,.06l.06.1a.16.16,0,0,0,.08.06.33.33,0,0,0,.14,0,.75.75,0,0,0,.2-.08l.19-.13a1.29,1.29,0,0,0,.16-.17,1.18,1.18,0,0,0,.11-.19.71.71,0,0,0,0-.21.21.21,0,0,0-.05-.15.14.14,0,0,0-.13,0l-.23,0-.31.07a.94.94,0,0,1-.28,0,.4.4,0,0,1-.2-.08.51.51,0,0,1-.12-.22,1.73,1.73,0,0,1,0-.36,1.69,1.69,0,0,1,0-.38,2.35,2.35,0,0,1,.14-.37,1.68,1.68,0,0,1,.2-.34,2.23,2.23,0,0,1,.26-.27v-.34a.26.26,0,0,1,0-.11.11.11,0,0,1,.06-.07l.26-.15h.06a.19.19,0,0,1,0,.08Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 103.61 346.37 108.61 346.37 96.66 355.03 91.65 355.03 103.61",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 103.61 346.37 108.61 346.37 96.66 355.03 91.65 355.03 103.61",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,102.86l-6.75,3.9V97.4l6.75-3.9Zm-6.66,3.74,6.58-3.8V93.66l-6.58,3.8Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.39 104.27 347.34 104.21 349.34 100.98 350.3 101.47 353.21 96.17 354.06 96.81 354 96.92 353.2 96.32 350.31 101.61 349.34 101.12 347.39 104.27",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.44,99.81c-.48.27-.87,0-.87-.66a2.09,2.09,0,0,1,.87-1.66c.48-.27.87,0,.87.66A2.09,2.09,0,0,1,350.44,99.81Zm0-2.21a1.91,1.91,0,0,0-.79,1.5c0,.58.36.84.79.59a1.86,1.86,0,0,0,.78-1.49C351.22,97.62,350.87,97.35,350.44,97.6Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,100.45,346.81,113.2c-.32.18-.58,0-.58-.44a1.36,1.36,0,0,1,.58-1.1l22.08-12.75c.32-.19.58,0,.58.43A1.4,1.4,0,0,1,368.89,100.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.15,112.53l-7.34,4.24c-.32.18-.58,0-.58-.44a1.4,1.4,0,0,1,.58-1.11l7.34-4.24c.32-.18.58,0,.58.44A1.4,1.4,0,0,1,354.15,112.53Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,108.19l-5,2.88c-.32.18-.58,0-.58-.44a1.38,1.38,0,0,1,.58-1.1l5-2.88c.32-.18.58,0,.58.44A1.38,1.38,0,0,1,361.65,108.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,88.2a1.15,1.15,0,0,1,.54,0,.9.9,0,0,1,.4.21,1.18,1.18,0,0,1,.24.37,1.8,1.8,0,0,1,.09.45.34.34,0,0,1,0,.22.24.24,0,0,1-.12.14l-.44.26c-.07,0-.13,0-.16,0a.25.25,0,0,1-.1-.12.51.51,0,0,0-.29-.25.71.71,0,0,0-.57.15,1.72,1.72,0,0,0-.32.23,1.94,1.94,0,0,0-.26.31,1.42,1.42,0,0,0-.17.35,1.13,1.13,0,0,0-.06.36.58.58,0,0,0,.07.33.24.24,0,0,0,.22.11,1.22,1.22,0,0,0,.4,0l.59-.13a2,2,0,0,1,.64-.08.86.86,0,0,1,.44.16.78.78,0,0,1,.23.42,2.51,2.51,0,0,1,.08.67,2.89,2.89,0,0,1-.1.76,3.36,3.36,0,0,1-.27.75,3.92,3.92,0,0,1-.44.7,4,4,0,0,1-.59.58v.66A.59.59,0,0,1,368,96a.35.35,0,0,1-.12.14l-.51.3a.09.09,0,0,1-.13,0,.21.21,0,0,1,0-.15v-.67a1.19,1.19,0,0,1-.54.08.92.92,0,0,1-.44-.14.94.94,0,0,1-.3-.37,1.49,1.49,0,0,1-.12-.6.41.41,0,0,1,0-.22.3.3,0,0,1,.13-.14l.44-.26c.07,0,.13,0,.16,0s.07,0,.1.12a.93.93,0,0,0,.11.19.3.3,0,0,0,.17.12.48.48,0,0,0,.27,0,1.51,1.51,0,0,0,.4-.17,2.78,2.78,0,0,0,.37-.26,1.88,1.88,0,0,0,.31-.32,2,2,0,0,0,.21-.38,1,1,0,0,0,.08-.42.38.38,0,0,0-.09-.3.33.33,0,0,0-.26-.08,2.26,2.26,0,0,0-.45.07c-.18.05-.38.09-.61.13a1.6,1.6,0,0,1-.56,0,.63.63,0,0,1-.39-.16.94.94,0,0,1-.23-.42,2.72,2.72,0,0,1-.08-.71,2.78,2.78,0,0,1,.1-.76,4,4,0,0,1,.26-.73,3.62,3.62,0,0,1,.4-.66,3.41,3.41,0,0,1,.52-.55V88a.52.52,0,0,1,0-.21.39.39,0,0,1,.13-.15l.51-.3a.11.11,0,0,1,.12,0,.23.23,0,0,1,.05.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,90.6a1,1,0,0,1,.55,0,.83.83,0,0,1,.39.21,1.08,1.08,0,0,1,.24.37,1.8,1.8,0,0,1,.09.45A.4.4,0,0,1,365,92l-.44.25c-.07,0-.13,0-.16,0a.27.27,0,0,1-.1-.11.5.5,0,0,0-.29-.26.8.8,0,0,0-.57.15,1.43,1.43,0,0,0-.31.24,1.48,1.48,0,0,0-.26.3,1.29,1.29,0,0,0-.18.35,1.19,1.19,0,0,0-.06.37.58.58,0,0,0,.07.33.29.29,0,0,0,.22.11,1.54,1.54,0,0,0,.4,0l.59-.14a2.32,2.32,0,0,1,.65-.07.71.71,0,0,1,.43.16.79.79,0,0,1,.24.41,2.55,2.55,0,0,1,.07.67,3.44,3.44,0,0,1-.09.77,4.25,4.25,0,0,1-.28.75,3.52,3.52,0,0,1-.44.69,3.66,3.66,0,0,1-.59.59v.66a.54.54,0,0,1-.05.21.24.24,0,0,1-.12.15l-.51.3a.1.1,0,0,1-.12,0,.19.19,0,0,1-.05-.16V98a1.51,1.51,0,0,1-.54.08.92.92,0,0,1-.44-.14,1,1,0,0,1-.3-.37,1.68,1.68,0,0,1-.12-.6.41.41,0,0,1,0-.22.39.39,0,0,1,.13-.15l.44-.25c.07,0,.13-.06.17,0a.24.24,0,0,1,.09.12,1.18,1.18,0,0,0,.11.19.31.31,0,0,0,.17.13.61.61,0,0,0,.27,0,1.32,1.32,0,0,0,.4-.16,3.09,3.09,0,0,0,.37-.26,1.93,1.93,0,0,0,.31-.33,1.53,1.53,0,0,0,.21-.37,1.07,1.07,0,0,0,.09-.43.41.41,0,0,0-.09-.3.36.36,0,0,0-.27-.07,1.71,1.71,0,0,0-.45.07l-.61.13a1.87,1.87,0,0,1-.56,0,.61.61,0,0,1-.39-.17.85.85,0,0,1-.23-.41,2.81,2.81,0,0,1-.08-.72,3.22,3.22,0,0,1,.1-.75,3.73,3.73,0,0,1,.26-.73,4.09,4.09,0,0,1,.4-.67,3.8,3.8,0,0,1,.52-.54v-.66a.42.42,0,0,1,.05-.22.24.24,0,0,1,.12-.14l.51-.3a.09.09,0,0,1,.12,0,.21.21,0,0,1,.05.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 130.14 346.37 135.15 346.37 123.2 355.03 118.19 355.03 130.14",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 130.14 346.37 135.15 346.37 123.2 355.03 118.19 355.03 130.14",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,129.4l-6.75,3.9v-9.36l6.75-3.9Zm-6.66,3.74,6.58-3.8V120.2l-6.58,3.8Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.39 130.81 347.34 130.75 349.34 127.52 350.3 128.01 353.21 122.71 354.06 123.35 354 123.46 353.2 122.86 350.31 128.15 349.34 127.66 347.39 130.81",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.44,126.34c-.48.28-.87,0-.87-.65a2.09,2.09,0,0,1,.87-1.66c.48-.27.87,0,.87.66A2.07,2.07,0,0,1,350.44,126.34Zm0-2.2a1.89,1.89,0,0,0-.79,1.5c0,.58.36.84.79.59a1.88,1.88,0,0,0,.78-1.5C351.22,124.16,350.87,123.89,350.44,124.14Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,127l-22.08,12.75c-.32.18-.58,0-.58-.44a1.4,1.4,0,0,1,.58-1.11l22.08-12.75c.32-.18.58,0,.58.44A1.4,1.4,0,0,1,368.89,127Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.15,139.06l-7.34,4.24c-.32.19-.58,0-.58-.43a1.38,1.38,0,0,1,.58-1.11l7.34-4.24c.32-.18.58,0,.58.44A1.38,1.38,0,0,1,354.15,139.06Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,134.73l-5,2.88c-.32.18-.58,0-.58-.44a1.4,1.4,0,0,1,.58-1.11l5-2.87c.32-.19.58,0,.58.44A1.38,1.38,0,0,1,361.65,134.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,114.74a1,1,0,0,1,.54,0,.9.9,0,0,1,.4.21,1.08,1.08,0,0,1,.24.37,1.8,1.8,0,0,1,.09.45.36.36,0,0,1,0,.22.28.28,0,0,1-.12.14l-.44.26c-.07,0-.13.05-.16,0a.31.31,0,0,1-.1-.12.51.51,0,0,0-.29-.25.71.71,0,0,0-.57.15,1.72,1.72,0,0,0-.32.23,2.43,2.43,0,0,0-.26.3,1.87,1.87,0,0,0-.17.35,1.24,1.24,0,0,0-.06.37.58.58,0,0,0,.07.33.26.26,0,0,0,.22.11,1.22,1.22,0,0,0,.4,0l.59-.14a2.26,2.26,0,0,1,.64-.07.78.78,0,0,1,.44.16.75.75,0,0,1,.23.41,2.56,2.56,0,0,1,.08.67,2.91,2.91,0,0,1-.1.77,3.36,3.36,0,0,1-.27.75,3.92,3.92,0,0,1-.44.7,4,4,0,0,1-.59.58v.66a.63.63,0,0,1-.05.22.35.35,0,0,1-.12.14l-.51.3a.1.1,0,0,1-.13,0,.22.22,0,0,1,0-.16v-.66a1.34,1.34,0,0,1-.54.08.92.92,0,0,1-.44-.14.94.94,0,0,1-.3-.37,1.49,1.49,0,0,1-.12-.6.41.41,0,0,1,0-.22.3.3,0,0,1,.13-.14l.44-.26a.23.23,0,0,1,.16,0,.25.25,0,0,1,.1.12.78.78,0,0,0,.11.2.3.3,0,0,0,.17.12.59.59,0,0,0,.27,0,1.51,1.51,0,0,0,.4-.17,2.78,2.78,0,0,0,.37-.26,2.34,2.34,0,0,0,.31-.32,2,2,0,0,0,.21-.38,1,1,0,0,0,.08-.42.38.38,0,0,0-.09-.3.29.29,0,0,0-.26-.08,2.26,2.26,0,0,0-.45.07l-.61.13a1.89,1.89,0,0,1-.56,0,.59.59,0,0,1-.39-.17.85.85,0,0,1-.23-.41,2.72,2.72,0,0,1-.08-.71,2.78,2.78,0,0,1,.1-.76,3.73,3.73,0,0,1,.26-.73,3.62,3.62,0,0,1,.4-.66,3.41,3.41,0,0,1,.52-.55v-.66a.6.6,0,0,1,0-.22.3.3,0,0,1,.13-.14l.51-.3a.11.11,0,0,1,.12,0,.22.22,0,0,1,.05.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,117.13a1.05,1.05,0,0,1,.55,0,.81.81,0,0,1,.39.2,1.23,1.23,0,0,1,.24.38,1.64,1.64,0,0,1,.09.44.41.41,0,0,1,0,.22.39.39,0,0,1-.13.15l-.44.25c-.07,0-.13.05-.16,0a.27.27,0,0,1-.1-.11.5.5,0,0,0-.29-.26.8.8,0,0,0-.57.15,1.18,1.18,0,0,0-.31.24,1.48,1.48,0,0,0-.26.3,1.29,1.29,0,0,0-.18.35,1.19,1.19,0,0,0-.06.37.52.52,0,0,0,.07.32.27.27,0,0,0,.22.12,1.54,1.54,0,0,0,.4,0l.59-.14a2,2,0,0,1,.65-.07.71.71,0,0,1,.43.16.79.79,0,0,1,.24.41,2.55,2.55,0,0,1,.07.67,3.29,3.29,0,0,1-.09.76,4.35,4.35,0,0,1-.28.76,4.23,4.23,0,0,1-.44.69,3.66,3.66,0,0,1-.59.59v.66a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.51.3a.1.1,0,0,1-.12,0,.21.21,0,0,1-.05-.16v-.66a1.51,1.51,0,0,1-.54.08.92.92,0,0,1-.44-.14,1,1,0,0,1-.3-.37,1.69,1.69,0,0,1-.12-.61.4.4,0,0,1,.17-.36l.44-.25a.17.17,0,0,1,.17,0,.24.24,0,0,1,.09.12,1.18,1.18,0,0,0,.11.19.37.37,0,0,0,.17.13.61.61,0,0,0,.27,0,1.15,1.15,0,0,0,.4-.17,2.19,2.19,0,0,0,.37-.25,1.93,1.93,0,0,0,.31-.33,1.53,1.53,0,0,0,.21-.37,1.07,1.07,0,0,0,.09-.43.31.31,0,0,0-.36-.38,2.39,2.39,0,0,0-.45.08l-.61.13a2.27,2.27,0,0,1-.56,0,.66.66,0,0,1-.39-.17.89.89,0,0,1-.23-.42,2.72,2.72,0,0,1-.08-.71,3.22,3.22,0,0,1,.1-.75,3.82,3.82,0,0,1,.26-.74,4.46,4.46,0,0,1,.4-.66,3.8,3.8,0,0,1,.52-.54V117a.42.42,0,0,1,.05-.22.31.31,0,0,1,.12-.15l.51-.29c.05,0,.09,0,.12,0a.21.21,0,0,1,.05.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 156.68 346.37 161.69 346.37 149.74 355.03 144.73 355.03 156.68",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.03 156.68 346.37 161.69 346.37 149.74 355.03 144.73 355.03 156.68",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,155.94l-6.75,3.9v-9.36l6.75-3.9Zm-6.66,3.74,6.58-3.8v-9.14l-6.58,3.8Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.39 157.35 347.34 157.29 349.34 154.06 350.3 154.55 353.21 149.25 354.06 149.89 354 150 353.2 149.4 350.31 154.69 349.34 154.2 347.39 157.35",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.44,152.88c-.48.28-.87,0-.87-.65a2.09,2.09,0,0,1,.87-1.66c.48-.28.87,0,.87.66A2.07,2.07,0,0,1,350.44,152.88Zm0-2.2a1.89,1.89,0,0,0-.79,1.5c0,.58.36.84.79.59a1.88,1.88,0,0,0,.78-1.5C351.22,150.7,350.87,150.43,350.44,150.68Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,153.53l-22.08,12.75c-.32.18-.58,0-.58-.44a1.4,1.4,0,0,1,.58-1.11L368.89,152c.32-.18.58,0,.58.44A1.4,1.4,0,0,1,368.89,153.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.15,165.6l-7.34,4.24c-.32.19-.58,0-.58-.44a1.38,1.38,0,0,1,.58-1.1l7.34-4.24c.32-.19.58,0,.58.44A1.38,1.38,0,0,1,354.15,165.6Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.65,161.27l-5,2.88c-.32.18-.58,0-.58-.44a1.4,1.4,0,0,1,.58-1.11l5-2.87c.32-.19.58,0,.58.43A1.38,1.38,0,0,1,361.65,161.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,141.28a1,1,0,0,1,.54,0,.9.9,0,0,1,.4.21,1.08,1.08,0,0,1,.24.37,1.8,1.8,0,0,1,.09.45.31.31,0,0,1,0,.21.31.31,0,0,1-.12.15l-.44.25c-.07.05-.13.06-.16,0a.22.22,0,0,1-.1-.11.57.57,0,0,0-.29-.26.8.8,0,0,0-.57.15,2.43,2.43,0,0,0-.32.24,1.87,1.87,0,0,0-.26.3,1.62,1.62,0,0,0-.17.35,1.19,1.19,0,0,0-.06.37.58.58,0,0,0,.07.33.29.29,0,0,0,.22.11,1.22,1.22,0,0,0,.4,0l.59-.14a2.26,2.26,0,0,1,.64-.07.71.71,0,0,1,.44.16.75.75,0,0,1,.23.41,2.51,2.51,0,0,1,.08.67,2.91,2.91,0,0,1-.1.77,3.36,3.36,0,0,1-.27.75,3.52,3.52,0,0,1-.44.69,4.11,4.11,0,0,1-.59.59v.66a.63.63,0,0,1-.05.22.35.35,0,0,1-.12.14l-.51.3a.12.12,0,0,1-.13,0,.24.24,0,0,1,0-.16v-.66a1.54,1.54,0,0,1-.54.08.92.92,0,0,1-.44-.14,1,1,0,0,1-.3-.37,1.49,1.49,0,0,1-.12-.6.41.41,0,0,1,0-.22.39.39,0,0,1,.13-.15l.44-.25c.07,0,.13-.06.16,0a.25.25,0,0,1,.1.12.72.72,0,0,0,.11.19.31.31,0,0,0,.17.13.59.59,0,0,0,.27,0,1.51,1.51,0,0,0,.4-.17A4.17,4.17,0,0,0,368,147a3.11,3.11,0,0,0,.31-.32,2,2,0,0,0,.21-.38,1,1,0,0,0,.08-.42.38.38,0,0,0-.09-.3.29.29,0,0,0-.26-.08,2.26,2.26,0,0,0-.45.07l-.61.13a1.89,1.89,0,0,1-.56,0,.59.59,0,0,1-.39-.17.85.85,0,0,1-.23-.41,2.81,2.81,0,0,1-.08-.72,2.76,2.76,0,0,1,.1-.75,3.73,3.73,0,0,1,.26-.73,3.62,3.62,0,0,1,.4-.66,3.41,3.41,0,0,1,.52-.55v-.66a.57.57,0,0,1,0-.22.3.3,0,0,1,.13-.14l.51-.3a.09.09,0,0,1,.12,0,.21.21,0,0,1,.05.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,143.67a1.05,1.05,0,0,1,.55,0,.81.81,0,0,1,.39.2,1.23,1.23,0,0,1,.24.38,1.64,1.64,0,0,1,.09.44.41.41,0,0,1,0,.22.3.3,0,0,1-.13.14l-.44.26c-.07,0-.13.05-.16,0a.27.27,0,0,1-.1-.11.5.5,0,0,0-.29-.26.71.71,0,0,0-.57.15,1.39,1.39,0,0,0-.31.23,1.86,1.86,0,0,0-.26.31,1.29,1.29,0,0,0-.18.35,1.15,1.15,0,0,0-.06.37.54.54,0,0,0,.07.32.27.27,0,0,0,.22.12,2.15,2.15,0,0,0,.4,0l.59-.14a2.38,2.38,0,0,1,.65-.08.72.72,0,0,1,.67.58,2.55,2.55,0,0,1,.07.67,3.29,3.29,0,0,1-.09.76,4.35,4.35,0,0,1-.28.76,4.23,4.23,0,0,1-.44.69,3.24,3.24,0,0,1-.59.58v.67a.54.54,0,0,1-.05.21.31.31,0,0,1-.12.15l-.51.29q-.08,0-.12,0a.21.21,0,0,1-.05-.16v-.66a1.51,1.51,0,0,1-.54.08.83.83,0,0,1-.44-.15.91.91,0,0,1-.3-.36,1.74,1.74,0,0,1-.12-.61.43.43,0,0,1,0-.22.44.44,0,0,1,.13-.14l.44-.26a.19.19,0,0,1,.17,0,.24.24,0,0,1,.09.12,1.18,1.18,0,0,0,.11.19.37.37,0,0,0,.17.13.61.61,0,0,0,.27,0,1.15,1.15,0,0,0,.4-.17,3,3,0,0,0,.37-.25,1.93,1.93,0,0,0,.31-.33,1.41,1.41,0,0,0,.21-.38,1,1,0,0,0,.09-.42.41.41,0,0,0-.09-.3.36.36,0,0,0-.27-.08,3.35,3.35,0,0,0-.45.07l-.61.14a2.27,2.27,0,0,1-.56,0,.66.66,0,0,1-.39-.17.94.94,0,0,1-.23-.42,2.72,2.72,0,0,1-.08-.71,3.3,3.3,0,0,1,.1-.76,4,4,0,0,1,.26-.73,4.46,4.46,0,0,1,.4-.66,3.8,3.8,0,0,1,.52-.54v-.67a.41.41,0,0,1,.05-.21.31.31,0,0,1,.12-.15l.51-.29c.05,0,.09,0,.12,0a.21.21,0,0,1,.05.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.84,128.22l-4.57-8.58L98,109v-6.49L86.71,109v6.48l4.83,8.37a.68.68,0,0,0,.33.3h0Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.84,128.22l-4.57-8.58L98,109v-6.49L86.71,109v6.48l4.83,8.37a.68.68,0,0,0,.33.3h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,42.84A7.46,7.46,0,0,0,136.39,37l-2.75-1.58a7.42,7.42,0,0,0-6.74,0L70.75,67.88a7.45,7.45,0,0,0-3.37,5.84V120a7.46,7.46,0,0,0,3.37,5.84l2.74,1.58a7.48,7.48,0,0,0,6.74,0l13.53-7.82L98.59,128a.72.72,0,0,0,1.3-.12l5.1-14.71L136.39,95a7.46,7.46,0,0,0,3.37-5.84Z",
    style: {
      fill: "#278AFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.38,120a7.46,7.46,0,0,0,3.37,5.84l2.74,1.58a7.53,7.53,0,0,0,6.17.27c-1.59.6-2.8-.29-2.8-2.21V79.19a6.91,6.91,0,0,1,1-3.32L68.37,70.4a6.85,6.85,0,0,0-1,3.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,41.88c-.4-1.43-1.7-1.89-3.26-1L80.23,73.36a6.54,6.54,0,0,0-2.37,2.51L68.38,70.4a6.69,6.69,0,0,1,2.37-2.51L126.9,35.42a7.48,7.48,0,0,1,6.74,0L136.39,37A7.42,7.42,0,0,1,139.65,41.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,76.64a16.16,16.16,0,0,1-.59,4.3,20.58,20.58,0,0,1-1.57,4,16.33,16.33,0,0,1-2.27,3.3,10.86,10.86,0,0,1-2.69,2.26,6.14,6.14,0,0,1-2.84.93,3.3,3.3,0,0,1-2.24-.7,4.74,4.74,0,0,1-1.47-2.23,10.74,10.74,0,0,1-.53-3.65,17.89,17.89,0,0,1,.53-4.39,18.32,18.32,0,0,1,1.47-4,16,16,0,0,1,2.24-3.32A11.36,11.36,0,0,1,95.7,70.8a6,6,0,0,1,2.86-.93,3.3,3.3,0,0,1,2.25.71,4.85,4.85,0,0,1,1.48,2.28A11.75,11.75,0,0,1,102.82,76.64Zm11.86-15.18a11.09,11.09,0,0,1,.76-1.29,3.84,3.84,0,0,1,1.24-1.11l4.6-2.65L98.94,107.63a6.27,6.27,0,0,1-.77,1.3,3.68,3.68,0,0,1-1.1,1l-4.72,2.73ZM98,79.44a10.58,10.58,0,0,0-.18-2.2,2.57,2.57,0,0,0-.48-1.17.83.83,0,0,0-.72-.34,1.92,1.92,0,0,0-.9.3,3.9,3.9,0,0,0-.9.73,4.05,4.05,0,0,0-.69,1.16,7.86,7.86,0,0,0-.44,1.71A15,15,0,0,0,93.5,82a10.38,10.38,0,0,0,.17,2.08,2.58,2.58,0,0,0,.44,1.12.8.8,0,0,0,.69.33,2,2,0,0,0,.9-.3,3.8,3.8,0,0,0,.9-.73,4.18,4.18,0,0,0,.72-1.15,7,7,0,0,0,.48-1.66A12.66,12.66,0,0,0,98,79.44Zm27.28,4.92a15.94,15.94,0,0,1-.59,4.31,20.4,20.4,0,0,1-1.56,4,17.19,17.19,0,0,1-2.27,3.3,11.08,11.08,0,0,1-2.7,2.26,6.16,6.16,0,0,1-2.84.94,3.32,3.32,0,0,1-2.23-.71,4.67,4.67,0,0,1-1.48-2.24,11.17,11.17,0,0,1-.53-3.67,18.38,18.38,0,0,1,.53-4.39,17.84,17.84,0,0,1,1.48-4,15.74,15.74,0,0,1,2.23-3.31,11.41,11.41,0,0,1,2.84-2.36,6,6,0,0,1,2.86-.93,3.32,3.32,0,0,1,2.26.72,4.81,4.81,0,0,1,1.47,2.28A11.4,11.4,0,0,1,125.26,84.36Zm-4.84,2.79a10.46,10.46,0,0,0-.18-2.17,2.69,2.69,0,0,0-.47-1.17.82.82,0,0,0-.72-.34,2,2,0,0,0-.91.3,3.9,3.9,0,0,0-.9.74,3.79,3.79,0,0,0-.69,1.16,8.17,8.17,0,0,0-.45,1.7,16.11,16.11,0,0,0-.16,2.36,11.32,11.32,0,0,0,.16,2.08,2.75,2.75,0,0,0,.45,1.13.82.82,0,0,0,.69.33,2,2,0,0,0,.9-.3,3.94,3.94,0,0,0,.91-.74,4.43,4.43,0,0,0,.72-1.15,7.31,7.31,0,0,0,.47-1.66A12.58,12.58,0,0,0,120.42,87.15Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommercewebpageAmico);
export default __webpack_public_path__ + "static/media/Ecommerce web page-amico.c4eb1d5e68af0229b0e69ebf7a565254.svg";
export { ForwardRef as ReactComponent };